import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};





export type Account = {
  __typename?: 'Account';
  id: Scalars['Int'];
  email: Scalars['String'];
  accountStatus: AccountStatus;
  subscriptionStatus: AccountSubscriptionStatus;
  role: AccountRole;
  createdAt: Scalars['Date'];
  phoneNumber?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
  profile?: Maybe<Profile>;
  language: Language;
};


export type AccountProfileImageArgs = {
  size?: Maybe<Image_Size>;
  resize?: Maybe<GetMediaResizeInput>;
};

export type AccountProfilePictureInput = {
  connect?: Maybe<AccountProfilePictureInputConnect>;
  create?: Maybe<CreateMediaPayload>;
};

export type AccountProfilePictureInputConnect = {
  mediaId: Scalars['Int'];
};

export enum AccountRole {
  Client = 'CLIENT',
  Admin = 'ADMIN',
  Doctor = 'DOCTOR',
  MedicalSpecialist = 'MEDICAL_SPECIALIST',
  Author = 'AUTHOR'
}

export type AccountShortData = {
  __typename?: 'AccountShortData';
  id: Scalars['Int'];
  email: Scalars['String'];
  password: Scalars['String'];
  role: AccountRole;
  subscriptionStatus?: Maybe<AccountSubscriptionStatus>;
  accountStatus?: Maybe<AccountStatus>;
  phoneNumber?: Maybe<Scalars['String']>;
  tfaCode?: Maybe<Scalars['String']>;
};

export enum AccountStatus {
  Active = 'ACTIVE',
  Unconfirmed = 'UNCONFIRMED',
  Blocked = 'BLOCKED'
}

export type AccountSubscription = {
  __typename?: 'AccountSubscription';
  id: Scalars['Int'];
  account: Account;
  tier: Tier;
  startDate: Scalars['DateTime'];
  expirationDate: Scalars['DateTime'];
  isActive: Scalars['Boolean'];
  authorization: SubscriptionAuthorization;
  remainingDays: Scalars['Int'];
  callsNumber: Scalars['Int'];
  minutesOfCallsNumber: Scalars['Int'];
  card?: Maybe<HealthInsuranceCard>;
};

export enum AccountSubscriptionStatus {
  Expired = 'EXPIRED',
  Active = 'ACTIVE',
  RequiresVerification = 'REQUIRES_VERIFICATION'
}

export enum AccountType {
  ClientProfile = 'ClientProfile',
  DoctorProfile = 'DoctorProfile',
  SystemUserProfile = 'SystemUserProfile'
}

export type AccountsQueryInput = {
  role: AccountRole;
  search?: Maybe<Scalars['String']>;
  accountStatus?: Maybe<AccountStatus>;
};

export type ActivateSubscriptionPayload = {
  insurancePoliceId: Scalars['Int'];
  insurancePolicyCode: Scalars['String'];
};

export type Advertisement = {
  __typename?: 'Advertisement';
  id: Scalars['Int'];
  position: AdvertisementPosition;
  isActive?: Maybe<Scalars['Boolean']>;
  clickUrl?: Maybe<Scalars['String']>;
  media?: Maybe<Media>;
  createdAt: Scalars['DateTime'];
  author: Account;
};


export type AdvertisementMediaArgs = {
  size?: Maybe<Image_Size>;
  resize?: Maybe<GetMediaResizeInput>;
};

export enum AdvertisementPosition {
  ArticlesHomeTop = 'ARTICLES_HOME_TOP',
  ArticlesHomeBottom = 'ARTICLES_HOME_BOTTOM',
  ArticleBottom = 'ARTICLE_BOTTOM'
}

export type AllWaitingQueueResponseItem = {
  __typename?: 'AllWaitingQueueResponseItem';
  profile?: Maybe<Participant>;
  calls: Array<Maybe<Call>>;
};

export type ApproveDoctorRequest = {
  requestId: Scalars['Int'];
};

export type ApproveDoctorRequestAsSpecialist = {
  requestId: Scalars['Int'];
  specialityId: Scalars['Int'];
};

export type Article = {
  __typename?: 'Article';
  id: Scalars['Int'];
  language: Language;
  title: Scalars['String'];
  body: Scalars['String'];
  excerpt: Scalars['String'];
  createdAt: Scalars['DateTime'];
  cover?: Maybe<Media>;
  author: Account;
  url?: Maybe<Scalars['String']>;
};


export type ArticleCoverArgs = {
  size?: Maybe<Image_Size>;
  resize?: Maybe<GetMediaResizeInput>;
};

export type AuthResponse = {
  __typename?: 'AuthResponse';
  token?: Maybe<Scalars['String']>;
};

export type Benefit = {
  __typename?: 'Benefit';
  id: Scalars['Int'];
  title: Scalars['String'];
  description: Scalars['String'];
  image?: Maybe<Media>;
  rawTitle: MultiLangStringType;
  rawDescription: MultiLangStringType;
  rawExternalUrlLabel?: Maybe<MultiLangStringType>;
  externalURL?: Maybe<Scalars['String']>;
  externalUrlLabel?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  tiers: Array<Maybe<Tier>>;
};


export type BenefitImageArgs = {
  size?: Maybe<Image_Size>;
  resize?: Maybe<GetMediaResizeInput>;
};

export type BuySubscriptionPayload = {
  tierId: Scalars['Int'];
  currency: Currency;
  paymentGateway: PaymentGateway;
  tokenVerifyer: Scalars['String'];
  recipe: Scalars['String'];
};

export type BuyTierCardPayload = {
  recipe?: Maybe<Scalars['String']>;
  tierId: Scalars['Int'];
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  name: Scalars['String'];
  lastname: Scalars['String'];
  birthday: Scalars['Date'];
  sex: Gender;
  languageCode: LanguageCode;
};

export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}

export type Call = {
  __typename?: 'Call';
  id: Scalars['Int'];
  duration: Scalars['Float'];
  room: Scalars['String'];
  requestTime?: Maybe<Scalars['DateTime']>;
  startTime?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
  status: CallStatus;
  participants: Array<Participant>;
  review?: Maybe<CallReview>;
  twilioToken: Scalars['String'];
  participationStatus: ParticipantStatus;
  participationRole: ParticipantRole;
  recordings: Array<Maybe<Scalars['String']>>;
};

export type CallCsv = {
  __typename?: 'CallCSV';
  url: Scalars['String'];
};

export type CallNotificationRelatedResources = {
  __typename?: 'CallNotificationRelatedResources';
  type: Scalars['String'];
  callId: Scalars['Int'];
  calleeId: Scalars['Int'];
};

export type CallReview = {
  __typename?: 'CallReview';
  rating: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
};

export type CallStatsReport = {
  __typename?: 'CallStatsReport';
  callsByDoctor: Array<Maybe<DoctorCallsReportItem>>;
  totalCalls: CallsReportItem;
};

export enum CallStatus {
  Requested = 'REQUESTED',
  Waiting = 'WAITING',
  Processing = 'PROCESSING',
  Ringing = 'RINGING',
  Started = 'STARTED',
  Terminated = 'TERMINATED',
  Expired = 'EXPIRED'
}

export type CallSubscriptionPayloadData = CallSubscriptionPayloadDataInfo | CallSubscriptionPayloadDataCount;

export type CallSubscriptionPayloadDataCount = {
  __typename?: 'CallSubscriptionPayloadDataCount';
  count: Scalars['Int'];
};

export type CallSubscriptionPayloadDataInfo = {
  __typename?: 'CallSubscriptionPayloadDataInfo';
  message?: Maybe<Scalars['String']>;
};

export enum CallSubscriptionPayloadType {
  Info = 'INFO',
  QueueUpdate = 'QUEUE_UPDATE',
  CallStarted = 'CALL_STARTED',
  CallAccepted = 'CALL_ACCEPTED',
  CallRejected = 'CALL_REJECTED',
  CallTerminated = 'CALL_TERMINATED'
}

export type CallUpdateSubscriptionPayload = {
  __typename?: 'CallUpdateSubscriptionPayload';
  waitingCalls: Scalars['Int'];
  call: Call;
};

export type CallWhereInput = {
  id: Scalars['Int'];
};

export type CallsReportItem = {
  __typename?: 'CallsReportItem';
  callsSuccess: Scalars['Int'];
  callsExpired: Scalars['Int'];
  callsClosed: Scalars['Int'];
  callsMinutes: Scalars['Int'];
};

export type CallsWhereInput = {
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  accountId?: Maybe<Scalars['Int']>;
};

export type City = {
  __typename?: 'City';
  id: Scalars['Int'];
  name: Scalars['String'];
  country: Country;
  rawName: MultiLangStringType;
};

export type ClientAccountQuery = {
  id: Scalars['Int'];
};

export type ClientProfile = {
  __typename?: 'ClientProfile';
  id: Scalars['Int'];
  type: AccountType;
  name: Scalars['String'];
  lastname: Scalars['String'];
  birthday: Scalars['Date'];
  sex: Gender;
  subscription?: Maybe<AccountSubscription>;
};

export type ClientSignupPayload = {
  email: Scalars['String'];
  password: Scalars['String'];
  phoneNumber: Scalars['String'];
  name: Scalars['String'];
  lastname: Scalars['String'];
  birthday: Scalars['Date'];
  sex: Gender;
  languageCode: LanguageCode;
};

export type ClientSignupPayloadAdmin = {
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  name: Scalars['String'];
  lastname: Scalars['String'];
  birthday: Scalars['Date'];
  sex: Gender;
  languageCode: LanguageCode;
  tierId: Scalars['Int'];
};

export type ClientSignupUsingSigalInsurancePayload = {
  email: Scalars['String'];
  insurancePoliceId: Scalars['Int'];
  insurancePolicyCode: Scalars['String'];
  phoneNumber: Scalars['String'];
  name: Scalars['String'];
  lastname: Scalars['String'];
  birthday: Scalars['Date'];
  sex: Gender;
  languageCode: LanguageCode;
};

export type ClientSignupWithoutPasswordPayload = {
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  name: Scalars['String'];
  lastname: Scalars['String'];
  birthday: Scalars['Date'];
  sex: Gender;
  languageCode: LanguageCode;
};

export type CodeStatsResponse = {
  __typename?: 'CodeStatsResponse';
  tier: Tier;
  totalCount: Scalars['Int'];
  usedCount: Scalars['Int'];
  unusedCount: Scalars['Int'];
};

export type Config = {
  __typename?: 'Config';
  vapidKey: Scalars['String'];
  clinicLocations: Scalars['String'];
  contactNumber: Scalars['String'];
  policy: Scalars['String'];
  terms: Scalars['String'];
};

export type Country = {
  __typename?: 'Country';
  id: Scalars['Int'];
  name: Scalars['String'];
  rawName: MultiLangStringType;
};

export type CreateCallResponse = {
  __typename?: 'CreateCallResponse';
  waitingQueueCount: Scalars['Int'];
  call: Call;
};

export type CreateCallReviewPayload = {
  rating: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
};

export type CreateCommentPayload = {
  content?: Maybe<Scalars['String']>;
};

export type CreateDoctorAccountRequestPayload = {
  name: Scalars['String'];
  lastname: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  birthday: Scalars['Date'];
  phoneNumber: Scalars['String'];
  languageCode: LanguageCode;
  licenceNumber: Scalars['String'];
  cvKey: Scalars['String'];
  sex: Gender;
  countryId: Scalars['Int'];
  cityId: Scalars['Int'];
  healthCenterId: Scalars['Int'];
};

export type CreateDocumentPayload = {
  key: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export type CreateEventPayload = {
  title: Scalars['String'];
  description: Scalars['String'];
  coverMediaKey: Scalars['String'];
  specialistId: Scalars['Int'];
  startDate: Scalars['DateTime'];
  durationMinutes: Scalars['Int'];
  maxParticipantsNumber: Scalars['Int'];
};

export type CreateMediaLibraryPayload = {
  title: Scalars['String'];
  mediaKey: Scalars['String'];
};

export type CreateMediaPayload = {
  key: Scalars['String'];
  contentType: Scalars['String'];
};

export type CreateMedicalCardPayload = {
  patientId: Scalars['Int'];
  symptoms: Scalars['String'];
  diagnosis: Scalars['String'];
  recommendation?: Maybe<Scalars['String']>;
  recipe?: Maybe<Scalars['String']>;
  privateNote?: Maybe<Scalars['String']>;
  medicalConcernCategoryId?: Maybe<Scalars['Int']>;
};

export type CreateTemporaryBlockagePayload = {
  accountId: Scalars['Int'];
  hours?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
};

export type CreateUpdateAdvertisementPayload = {
  position: AdvertisementPosition;
  isActive: Scalars['Boolean'];
  clickUrl?: Maybe<Scalars['String']>;
  mediaKey?: Maybe<Scalars['String']>;
};

export type CreateUpdateArticlePayload = {
  languageCode: LanguageCode;
  title: Scalars['String'];
  excerpt: Scalars['String'];
  body: Scalars['String'];
  coverMediaKey: Scalars['String'];
};

export type CreateUpdateBenefitPayload = {
  title: MultiLanguageString;
  description: MultiLanguageString;
  imageMediaKey: Scalars['String'];
  externalURL?: Maybe<Scalars['String']>;
  externalUrlLabel?: Maybe<MultiLanguageString>;
};

export type CreateUpdateCityPayload = {
  countryId: Scalars['Int'];
  name: MultiLanguageString;
};

export type CreateUpdateCountryPayload = {
  name: MultiLanguageString;
};

export type CreateUpdateFaqPayload = {
  title: MultiLanguageString;
  body: MultiLanguageString;
};

export type CreateUpdateHealthCenterPayload = {
  cityId: Scalars['Int'];
  name: MultiLanguageString;
};

export type CreateUpdateInsurancePolicyPayload = {
  name: MultiLanguageString;
};

export type CreateUpdateMedicalConcernCategoryPayload = {
  name: MultiLanguageString;
};

export type CreateUpdateSpecialityPayload = {
  name: MultiLanguageString;
};

export type CreateUpdateStoryItemPayload = {
  isActive: Scalars['Boolean'];
  linkURL?: Maybe<Scalars['String']>;
  linkLabel?: Maybe<Scalars['String']>;
  bgColor?: Maybe<Scalars['String']>;
  mediaKey?: Maybe<Scalars['String']>;
  storyId: Scalars['Int'];
  language: LanguageCode;
};

export type CreateUpdateStoryPayload = {
  isActive?: Maybe<Scalars['Boolean']>;
  mediaKey: Scalars['String'];
  title: MultiLanguageString;
};

export type CreateUpdateTierPayload = {
  name: MultiLanguageString;
  description: MultiLanguageString;
  color: Scalars['String'];
  activeDays: Scalars['Int'];
  eventsPerMonth: Scalars['Int'];
  pricePerYear: Scalars['Int'];
  isDefaultForSigalClients: Scalars['Boolean'];
  isDefaultForDemo: Scalars['Boolean'];
  benefitIDs: Array<Scalars['Int']>;
  sigalHealthInsuranceType?: Maybe<HealthInsuranceCardType>;
};

export enum Currency {
  All = 'ALL',
  Eur = 'EUR'
}

export type Damage = {
  __typename?: 'Damage';
  group?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['String']>;
};


export type DateRange = {
  from: Scalars['Date'];
  to: Scalars['Date'];
};


export enum DayOfWeek {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday'
}

export type DeleteDoctorRequest = {
  requestId: Scalars['Int'];
};

export type DeleteFcmTokenPayload = {
  device: DeviceType;
};

export type Device = {
  __typename?: 'Device';
  id: Scalars['Int'];
  account: Account;
  type: DeviceType;
  fcmToken: Scalars['String'];
  date: Scalars['DateTime'];
};

export enum DeviceType {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type DoctorAccountRequest = {
  __typename?: 'DoctorAccountRequest';
  id?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  lastname: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  birthday: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  phoneNumber: Scalars['String'];
  language: Language;
  licenceNumber: Scalars['String'];
  cvUrl: Scalars['String'];
  sex: Gender;
  country: Country;
  city: City;
  healthCenter: HealthCenter;
};

export type DoctorCallsReportItem = {
  __typename?: 'DoctorCallsReportItem';
  doctorName: Scalars['String'];
  info: CallsReportItem;
};

export type DoctorProfile = {
  __typename?: 'DoctorProfile';
  id: Scalars['Int'];
  type: AccountType;
  name: Scalars['String'];
  lastname: Scalars['String'];
  birthday: Scalars['Date'];
  licenceNumber: Scalars['String'];
  country: Country;
  city: City;
  healthCenter: HealthCenter;
  bio?: Maybe<Scalars['String']>;
  sex: Gender;
  speciality?: Maybe<Speciality>;
  timetable?: Maybe<Array<Maybe<DoctorTimeTable>>>;
};

export type DoctorSignupPayload = {
  email: Scalars['String'];
  password: Scalars['String'];
  phoneNumber: Scalars['String'];
  name: Scalars['String'];
  lastname: Scalars['String'];
  birthday: Scalars['Date'];
  sex: Gender;
  licenceNumber: Scalars['String'];
  bio?: Maybe<Scalars['String']>;
  cityId: Scalars['Int'];
  countryId: Scalars['Int'];
  healthCenterId: Scalars['Int'];
  languageCode: LanguageCode;
};

export type DoctorTimeTable = {
  __typename?: 'DoctorTimeTable';
  dayOfWeek: DayOfWeek;
  startHour: Scalars['Int'];
  startMinute: Scalars['Int'];
  endHour: Scalars['Int'];
  endMinute: Scalars['Int'];
};

export type Document = {
  __typename?: 'Document';
  id: Scalars['Int'];
  author: Account;
  media: Media;
  description?: Maybe<Scalars['String']>;
  comments: Array<Maybe<DocumentComment>>;
  medicalCard: MedicalCard;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type DocumentMediaArgs = {
  size?: Maybe<Image_Size>;
  resize?: Maybe<GetMediaResizeInput>;
};

export type DocumentComment = {
  __typename?: 'DocumentComment';
  id: Scalars['Int'];
  author: Account;
  content: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum Event_Epoch {
  Past = 'PAST',
  Upcoming = 'UPCOMING'
}

export enum Event_Participation_Role {
  Attendee = 'ATTENDEE',
  Host = 'HOST'
}

export enum Event_Participation_Status {
  LimitReached = 'LIMIT_REACHED',
  NotAllowed = 'NOT_ALLOWED',
  CanJoin = 'CAN_JOIN',
  Joined = 'JOINED',
  NotAvailable = 'NOT_AVAILABLE'
}

export type Event = {
  __typename?: 'Event';
  id: Scalars['Int'];
  title: Scalars['String'];
  description: Scalars['String'];
  cover?: Maybe<Media>;
  specialist: Account;
  roomName: Scalars['String'];
  creator: Account;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  durationMinutes: Scalars['Int'];
  participants: EventParticipants;
  createdAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  participationStatus?: Maybe<Event_Participation_Status>;
};


export type EventCoverArgs = {
  size?: Maybe<Image_Size>;
  resize?: Maybe<GetMediaResizeInput>;
};

export type EventNotificationRelatedResources = {
  __typename?: 'EventNotificationRelatedResources';
  type: Scalars['String'];
  eventId: Scalars['Int'];
};

export type EventParticipants = {
  __typename?: 'EventParticipants';
  maxNumber: Scalars['Int'];
  currentCount: Scalars['Int'];
  list: Array<Maybe<Account>>;
};

export type Faq = {
  __typename?: 'Faq';
  id: Scalars['Int'];
  title: Scalars['String'];
  rawTitle: MultiLangStringType;
  body: Scalars['String'];
  rawBody: MultiLangStringType;
};

export type FilterMyPAtients = {
  contains?: Maybe<Scalars['String']>;
  callDate?: Maybe<FromToDate>;
};

export type FromToDate = {
  from: Scalars['Date'];
  to?: Maybe<Scalars['Date']>;
};

export enum Gender {
  Male = 'MALE',
  Female = 'FEMALE'
}

export type GetEventsInput = {
  epoch?: Maybe<Event_Epoch>;
  participationRole?: Maybe<Event_Participation_Role>;
};

export type GetMediaResizeInput = {
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
};

export type GetMedicalCardPdfResponse = {
  __typename?: 'GetMedicalCardPDFResponse';
  url: Scalars['String'];
};

export type HealthCenter = {
  __typename?: 'HealthCenter';
  id: Scalars['Int'];
  name: Scalars['String'];
  city: City;
  rawName: MultiLangStringType;
};

export type HealthInsuranceCard = {
  __typename?: 'HealthInsuranceCard';
  label: Scalars['String'];
  type: HealthInsuranceCardType;
  cardNumber: Scalars['String'];
  client: Scalars['String'];
  validity: Scalars['Date'];
  note?: Maybe<Scalars['String']>;
};

export enum HealthInsuranceCardType {
  Standard = 'STANDARD',
  Silver = 'SILVER',
  Gold = 'GOLD',
  Teleshendet = 'TELESHENDET'
}

export enum Image_Size {
  Thumbnail = 'THUMBNAIL',
  Medium = 'MEDIUM',
  Large = 'LARGE'
}

export type IncomingCallSubscriptionPayload = {
  __typename?: 'IncomingCallSubscriptionPayload';
  call: Call;
};

export type InsurancePolicy = {
  __typename?: 'InsurancePolicy';
  id: Scalars['Int'];
  name: Scalars['String'];
  rawName: MultiLangStringType;
};

export type InsurancePolicyHolderSubscriptionAuthorization = {
  __typename?: 'InsurancePolicyHolderSubscriptionAuthorization';
  type: SubscriptionAuthorizerType;
  status: SubscriptionAuthorizationStatus;
  insuranceUsageType?: Maybe<SubscriptionAuthorizationInsuranceUsageType>;
  insuranceCodeType?: Maybe<SubscriptionAuthorizationInsuranceCodeType>;
  insurancePolicy: InsurancePolicy;
  insurancePolicySerialNumber: Scalars['String'];
  tier: Tier;
  createdAt: Scalars['DateTime'];
  subscription: AccountSubscription;
};

export type InviteGuestInCallInput = {
  callId: Scalars['Int'];
  accountId: Scalars['Int'];
};


export type Language = {
  __typename?: 'Language';
  code: LanguageCode;
  name: Scalars['String'];
};

export enum LanguageCode {
  Sq = 'sq',
  En = 'en',
  Mk = 'mk'
}

export type LoginPayload = {
  email: Scalars['String'];
  password: Scalars['String'];
  tfaCode?: Maybe<Scalars['String']>;
};

export type Media = {
  __typename?: 'Media';
  id: Scalars['Int'];
  url: Scalars['String'];
  createdAt: Scalars['DateTime'];
  contentType: Scalars['String'];
  byteSize: Scalars['Int'];
  key?: Maybe<Scalars['String']>;
};

export type MediaLibrary = {
  __typename?: 'MediaLibrary';
  id: Scalars['Int'];
  title: Scalars['String'];
  media: Media;
  isActive: Scalars['Boolean'];
  author: Account;
  createdAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type MediaLibraryMediaArgs = {
  size?: Maybe<Image_Size>;
  resize?: Maybe<GetMediaResizeInput>;
};

export type MediaLibraryItemWhereInput = {
  id: Scalars['Int'];
};

export type MediaLibraryItemsWhereInput = {
  search: Scalars['String'];
};

export type MedicalCard = {
  __typename?: 'MedicalCard';
  id: Scalars['Int'];
  patient: Account;
  doctor: Account;
  symptoms: Scalars['String'];
  diagnosis: Scalars['String'];
  recommendation?: Maybe<Scalars['String']>;
  recipe?: Maybe<Scalars['String']>;
  privateNote?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  documents: Array<Maybe<Document>>;
  comments: Array<Maybe<MedicalCardComment>>;
  concernCategory?: Maybe<MedicalConcernCategory>;
};

export type MedicalCardComment = {
  __typename?: 'MedicalCardComment';
  id: Scalars['Int'];
  author: Account;
  content: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MedicalCardNotificationRelatedResources = {
  __typename?: 'MedicalCardNotificationRelatedResources';
  type: Scalars['String'];
  medicalCardId: Scalars['Int'];
  medicalCardCommentId?: Maybe<Scalars['Int']>;
  medicalCardDocumentId?: Maybe<Scalars['Int']>;
  medicalCardDocumentCommentId?: Maybe<Scalars['Int']>;
};

export type MedicalConcernCategory = {
  __typename?: 'MedicalConcernCategory';
  id: Scalars['Int'];
  name: Scalars['String'];
  rawName: MultiLangStringType;
};

export type MessageResponse = {
  __typename?: 'MessageResponse';
  message?: Maybe<Scalars['String']>;
};

export type MultiLangStringType = {
  __typename?: 'MultiLangStringType';
  sq: Scalars['String'];
  en: Scalars['String'];
  mk: Scalars['String'];
};

export type MultiLanguageString = {
  sq: Scalars['String'];
  en: Scalars['String'];
  mk: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  login?: Maybe<AuthResponse>;
  accountExists: Scalars['Boolean'];
  clientSignup?: Maybe<AuthResponse>;
  clientSignupWithVerificationCode?: Maybe<AuthResponse>;
  verifyAccountUsingVerificationCode?: Maybe<MessageResponse>;
  clientSignupWithoutPassword?: Maybe<AuthResponse>;
  clientSignupAdmin?: Maybe<AuthResponse>;
  clientSignupUsingSigalInsurancePolicy?: Maybe<AuthResponse>;
  doctorSignup?: Maybe<AuthResponse>;
  specialistSignup?: Maybe<AuthResponse>;
  updateClient: Account;
  updateDoctor: Account;
  updateSpecialist: Account;
  updateSystemUser: Account;
  requestPasswordReset?: Maybe<Scalars['Boolean']>;
  resetPassword: Account;
  changePassword?: Maybe<AuthResponse>;
  createDoctorRequest: DoctorAccountRequest;
  approveDoctorRequest: Account;
  approveDoctorRequestAsSpecialist: Account;
  deleteDoctorRequest: DoctorAccountRequest;
  setAccountProfilePicture: Account;
  setAccountProfileLanguage: Account;
  registerFcmToken: Device;
  deleteFcmToken?: Maybe<Device>;
  requestCall: CreateCallResponse;
  sendRetryCallNotification: Notification;
  requestCallForEvent: CreateCallResponse;
  answerCall: Call;
  leaveCall: Call;
  inviteGuestInCall: Call;
  createCallReview: CallReview;
  createMedia: Media;
  deleteMedia: Media;
  createMedicalCard: MedicalCard;
  generateMedicalCardPDF?: Maybe<GetMedicalCardPdfResponse>;
  updateMedicalCard: MedicalCard;
  addDocumentToMedicalCard: Document;
  deleteDocumentFromMedicalCard: Document;
  createDocumentComment: DocumentComment;
  updateDocumentComment: DocumentComment;
  deleteDocumentComment: DocumentComment;
  createMedicalCardComment: MedicalCardComment;
  updateMedicalCardComment: MedicalCardComment;
  deleteMedicalCardComment: MedicalCardComment;
  createEvent: Event;
  updateEvent: Event;
  deleteEvent: Event;
  joinEvent: Event;
  leaveEvent: Event;
  createCountry?: Maybe<Country>;
  updateCountry?: Maybe<Country>;
  deleteCountry?: Maybe<Country>;
  createCity?: Maybe<City>;
  updateCity?: Maybe<City>;
  deleteCity?: Maybe<City>;
  createHealthCenter?: Maybe<HealthCenter>;
  updateHealthCenter?: Maybe<HealthCenter>;
  deleteHealthCenter?: Maybe<HealthCenter>;
  createSpeciality?: Maybe<Speciality>;
  updateSpeciality?: Maybe<Speciality>;
  deleteSpeciality?: Maybe<Speciality>;
  createInsurancePolicy?: Maybe<InsurancePolicy>;
  updateInsurancePolicy?: Maybe<InsurancePolicy>;
  deleteInsurancePolicy?: Maybe<InsurancePolicy>;
  createTier?: Maybe<Tier>;
  updateTier?: Maybe<Tier>;
  deleteTier?: Maybe<Tier>;
  publishTier: Tier;
  createBenefit?: Maybe<Benefit>;
  updateBenefit?: Maybe<Benefit>;
  deleteBenefit?: Maybe<Benefit>;
  claimSubscriptionUsingInsurancePolicy: AccountSubscription;
  calls2csv: CallCsv;
  clients2csv: Scalars['String'];
  createAuthor: Account;
  createAdmin: Account;
  deleteAuthor?: Maybe<Account>;
  deleteAdmin?: Maybe<Account>;
  createArticle: Article;
  updateArticle: Article;
  deleteArticle: Article;
  createUpdateAdvertisement: Advertisement;
  readAllNotifications: Scalars['Boolean'];
  clientSignupUsingTierCard?: Maybe<Account>;
  claimSubscriptionUsingTierCard?: Maybe<AccountSubscription>;
  claimDemoSubscription?: Maybe<AccountSubscription>;
  generateTierCodes?: Maybe<Scalars['Boolean']>;
  codes2csv: Scalars['String'];
  subscriptions2csv: Scalars['String'];
  createFaq?: Maybe<Faq>;
  updateFaq?: Maybe<Faq>;
  deleteFaq?: Maybe<Faq>;
  updateTimetable?: Maybe<Account>;
  getRecipeEmailTextForMedicalCard: Scalars['String'];
  approveSubscriptionsThatNeedReview?: Maybe<AccountSubscription>;
  deleteSubscriptionsThatNeedReview?: Maybe<AccountSubscription>;
  testPushNotification?: Maybe<Scalars['Boolean']>;
  notifyAll: PushNotificationResponse;
  createStory?: Maybe<Story>;
  updateStory?: Maybe<Story>;
  moveStoryUp?: Maybe<Scalars['Boolean']>;
  moveStoryDown?: Maybe<Scalars['Boolean']>;
  deleteStory?: Maybe<Story>;
  createStoryItem?: Maybe<StoryItem>;
  updateStoryItem?: Maybe<StoryItem>;
  deleteStoryItem?: Maybe<StoryItem>;
  temporaryBlock: TemporaryBlockage;
  createMedicalConcernCategory: MedicalConcernCategory;
  updateMedicalConcernCategory?: Maybe<MedicalConcernCategory>;
  deleteMedicalConcernCategory?: Maybe<MedicalConcernCategory>;
  createMediaLibraryItem: MediaLibrary;
  deleteMediaLibraryItem?: Maybe<MediaLibrary>;
};


export type MutationLoginArgs = {
  data: LoginPayload;
};


export type MutationAccountExistsArgs = {
  email: Scalars['String'];
};


export type MutationClientSignupArgs = {
  data: ClientSignupPayload;
};


export type MutationClientSignupWithVerificationCodeArgs = {
  data: ClientSignupPayload;
};


export type MutationVerifyAccountUsingVerificationCodeArgs = {
  verificationCode: Scalars['String'];
};


export type MutationClientSignupWithoutPasswordArgs = {
  data: ClientSignupWithoutPasswordPayload;
};


export type MutationClientSignupAdminArgs = {
  data: ClientSignupPayloadAdmin;
};


export type MutationClientSignupUsingSigalInsurancePolicyArgs = {
  data: ClientSignupUsingSigalInsurancePayload;
};


export type MutationDoctorSignupArgs = {
  data: DoctorSignupPayload;
};


export type MutationSpecialistSignupArgs = {
  data: SpecialistSignupPayload;
};


export type MutationUpdateClientArgs = {
  data: UpdateClientPayload;
};


export type MutationUpdateDoctorArgs = {
  data: UpdateDoctorPayload;
};


export type MutationUpdateSpecialistArgs = {
  data: UpdateSpecialistPayload;
};


export type MutationUpdateSystemUserArgs = {
  data: UpdateSystemUser;
};


export type MutationRequestPasswordResetArgs = {
  data: RequestPasswordResetPayload;
};


export type MutationResetPasswordArgs = {
  data: ResetPasswordPayload;
};


export type MutationChangePasswordArgs = {
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
};


export type MutationCreateDoctorRequestArgs = {
  data: CreateDoctorAccountRequestPayload;
};


export type MutationApproveDoctorRequestArgs = {
  data: ApproveDoctorRequest;
};


export type MutationApproveDoctorRequestAsSpecialistArgs = {
  data: ApproveDoctorRequestAsSpecialist;
};


export type MutationDeleteDoctorRequestArgs = {
  id: Scalars['Int'];
};


export type MutationSetAccountProfilePictureArgs = {
  data?: Maybe<AccountProfilePictureInput>;
};


export type MutationSetAccountProfileLanguageArgs = {
  data?: Maybe<UpdateAccountLanguagePayload>;
};


export type MutationRegisterFcmTokenArgs = {
  data: RegisterFcmTokenPayload;
};


export type MutationDeleteFcmTokenArgs = {
  where: DeleteFcmTokenPayload;
};


export type MutationRequestCallArgs = {
  data?: Maybe<RequestCall>;
};


export type MutationSendRetryCallNotificationArgs = {
  data: RetryCallNotification;
};


export type MutationRequestCallForEventArgs = {
  id: Scalars['Int'];
};


export type MutationAnswerCallArgs = {
  where: CallWhereInput;
};


export type MutationLeaveCallArgs = {
  where: CallWhereInput;
};


export type MutationInviteGuestInCallArgs = {
  data: InviteGuestInCallInput;
};


export type MutationCreateCallReviewArgs = {
  id: Scalars['Int'];
  data: CreateCallReviewPayload;
};


export type MutationCreateMediaArgs = {
  data: CreateMediaPayload;
};


export type MutationDeleteMediaArgs = {
  id: Scalars['Int'];
};


export type MutationCreateMedicalCardArgs = {
  data: CreateMedicalCardPayload;
};


export type MutationGenerateMedicalCardPdfArgs = {
  id: Scalars['Int'];
};


export type MutationUpdateMedicalCardArgs = {
  where: WhereIdUnique;
  data: UpdateMedicalCardPayload;
};


export type MutationAddDocumentToMedicalCardArgs = {
  where: WhereIdUnique;
  data?: Maybe<CreateDocumentPayload>;
};


export type MutationDeleteDocumentFromMedicalCardArgs = {
  id: Scalars['Int'];
};


export type MutationCreateDocumentCommentArgs = {
  where: WhereIdUnique;
  data: CreateCommentPayload;
};


export type MutationUpdateDocumentCommentArgs = {
  where: WhereIdUnique;
  data: CreateCommentPayload;
};


export type MutationDeleteDocumentCommentArgs = {
  id: Scalars['Int'];
};


export type MutationCreateMedicalCardCommentArgs = {
  where: WhereIdUnique;
  data: CreateCommentPayload;
};


export type MutationUpdateMedicalCardCommentArgs = {
  where: WhereIdUnique;
  data: CreateCommentPayload;
};


export type MutationDeleteMedicalCardCommentArgs = {
  id: Scalars['Int'];
};


export type MutationCreateEventArgs = {
  data: CreateEventPayload;
};


export type MutationUpdateEventArgs = {
  id: Scalars['Int'];
  data: UpdateEventPayload;
};


export type MutationDeleteEventArgs = {
  id: Scalars['Int'];
};


export type MutationJoinEventArgs = {
  id: Scalars['Int'];
};


export type MutationLeaveEventArgs = {
  id: Scalars['Int'];
};


export type MutationCreateCountryArgs = {
  data: CreateUpdateCountryPayload;
};


export type MutationUpdateCountryArgs = {
  where: WhereIdUnique;
  data: CreateUpdateCountryPayload;
};


export type MutationDeleteCountryArgs = {
  where: WhereIdUnique;
};


export type MutationCreateCityArgs = {
  data: CreateUpdateCityPayload;
};


export type MutationUpdateCityArgs = {
  where: WhereIdUnique;
  data: CreateUpdateCityPayload;
};


export type MutationDeleteCityArgs = {
  where: WhereIdUnique;
};


export type MutationCreateHealthCenterArgs = {
  data: CreateUpdateHealthCenterPayload;
};


export type MutationUpdateHealthCenterArgs = {
  where: WhereIdUnique;
  data: CreateUpdateHealthCenterPayload;
};


export type MutationDeleteHealthCenterArgs = {
  where: WhereIdUnique;
};


export type MutationCreateSpecialityArgs = {
  data: CreateUpdateSpecialityPayload;
};


export type MutationUpdateSpecialityArgs = {
  where: WhereIdUnique;
  data: CreateUpdateSpecialityPayload;
};


export type MutationDeleteSpecialityArgs = {
  where: WhereIdUnique;
};


export type MutationCreateInsurancePolicyArgs = {
  data: CreateUpdateInsurancePolicyPayload;
};


export type MutationUpdateInsurancePolicyArgs = {
  where: WhereIdUnique;
  data: CreateUpdateInsurancePolicyPayload;
};


export type MutationDeleteInsurancePolicyArgs = {
  where: WhereIdUnique;
};


export type MutationCreateTierArgs = {
  data: CreateUpdateTierPayload;
};


export type MutationUpdateTierArgs = {
  where: WhereIdUnique;
  data: CreateUpdateTierPayload;
};


export type MutationDeleteTierArgs = {
  where: WhereIdUnique;
};


export type MutationPublishTierArgs = {
  where: WhereIdUnique;
};


export type MutationCreateBenefitArgs = {
  data: CreateUpdateBenefitPayload;
};


export type MutationUpdateBenefitArgs = {
  where: WhereIdUnique;
  data: CreateUpdateBenefitPayload;
};


export type MutationDeleteBenefitArgs = {
  where: WhereIdUnique;
};


export type MutationClaimSubscriptionUsingInsurancePolicyArgs = {
  data: ActivateSubscriptionPayload;
};


export type MutationCalls2csvArgs = {
  where?: Maybe<CallsWhereInput>;
  page: Scalars['Int'];
  pageLimit: Scalars['Int'];
};


export type MutationCreateAuthorArgs = {
  data: SystemUserSignupPayload;
};


export type MutationCreateAdminArgs = {
  data: SystemUserSignupPayload;
};


export type MutationDeleteAuthorArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteAdminArgs = {
  id: Scalars['Int'];
};


export type MutationCreateArticleArgs = {
  data: CreateUpdateArticlePayload;
};


export type MutationUpdateArticleArgs = {
  id: Scalars['Int'];
  data: CreateUpdateArticlePayload;
};


export type MutationDeleteArticleArgs = {
  id: Scalars['Int'];
};


export type MutationCreateUpdateAdvertisementArgs = {
  data: CreateUpdateAdvertisementPayload;
};


export type MutationClientSignupUsingTierCardArgs = {
  data: BuyTierCardPayload;
};


export type MutationClaimSubscriptionUsingTierCardArgs = {
  code: Scalars['String'];
};


export type MutationGenerateTierCodesArgs = {
  tierIds: Array<Maybe<Scalars['Int']>>;
  type: TierCodeType;
};


export type MutationSubscriptions2csvArgs = {
  range?: Maybe<DateRange>;
  endRange?: Maybe<DateRange>;
  tierId?: Maybe<Scalars['Int']>;
};


export type MutationCreateFaqArgs = {
  data: CreateUpdateFaqPayload;
};


export type MutationUpdateFaqArgs = {
  id: Scalars['Int'];
  data: CreateUpdateFaqPayload;
};


export type MutationDeleteFaqArgs = {
  id: Scalars['Int'];
};


export type MutationUpdateTimetableArgs = {
  id: Scalars['Int'];
  data: Array<TimeTableItem>;
};


export type MutationGetRecipeEmailTextForMedicalCardArgs = {
  id: Scalars['Int'];
};


export type MutationApproveSubscriptionsThatNeedReviewArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteSubscriptionsThatNeedReviewArgs = {
  id: Scalars['Int'];
};


export type MutationTestPushNotificationArgs = {
  data?: Maybe<Scalars['JSONObject']>;
};


export type MutationNotifyAllArgs = {
  data: PushNotification;
};


export type MutationCreateStoryArgs = {
  data: CreateUpdateStoryPayload;
};


export type MutationUpdateStoryArgs = {
  where: WhereIdUnique;
  data: CreateUpdateStoryPayload;
};


export type MutationMoveStoryUpArgs = {
  where: WhereIdUnique;
};


export type MutationMoveStoryDownArgs = {
  where: WhereIdUnique;
};


export type MutationDeleteStoryArgs = {
  where: WhereIdUnique;
};


export type MutationCreateStoryItemArgs = {
  data: CreateUpdateStoryItemPayload;
};


export type MutationUpdateStoryItemArgs = {
  where: WhereIdUnique;
  data: CreateUpdateStoryItemPayload;
};


export type MutationDeleteStoryItemArgs = {
  where: WhereIdUnique;
};


export type MutationTemporaryBlockArgs = {
  data: CreateTemporaryBlockagePayload;
};


export type MutationCreateMedicalConcernCategoryArgs = {
  data: CreateUpdateMedicalConcernCategoryPayload;
};


export type MutationUpdateMedicalConcernCategoryArgs = {
  where: WhereIdUnique;
  data: CreateUpdateMedicalConcernCategoryPayload;
};


export type MutationDeleteMedicalConcernCategoryArgs = {
  where: WhereIdUnique;
};


export type MutationCreateMediaLibraryItemArgs = {
  data: CreateMediaLibraryPayload;
};


export type MutationDeleteMediaLibraryItemArgs = {
  where: WhereIdUnique;
};

export type MyCallsWhereInput = {
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
};

export type Notification = {
  __typename?: 'Notification';
  id: Scalars['Int'];
  text: Scalars['String'];
  createdAt: Scalars['DateTime'];
  readAt?: Maybe<Scalars['DateTime']>;
  isRead: Scalars['Boolean'];
  account: Account;
  author?: Maybe<Account>;
  type?: Maybe<StorableNotificationType>;
  relatedResources?: Maybe<NotificationRelatedResources>;
};

export type NotificationRelatedResources = CallNotificationRelatedResources | EventNotificationRelatedResources | MedicalCardNotificationRelatedResources | SystemNotificationRelatedResources;

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  nextPage?: Maybe<Scalars['Int']>;
};

export type PaginatedAccount = {
  __typename?: 'PaginatedAccount';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  nodes: Array<Maybe<Account>>;
};

export type PaginatedAccountSubscription = {
  __typename?: 'PaginatedAccountSubscription';
  nodes: Array<Maybe<AccountSubscription>>;
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
};

export type PaginatedArticle = {
  __typename?: 'PaginatedArticle';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  nodes: Array<Maybe<Article>>;
};

export type PaginatedCall = {
  __typename?: 'PaginatedCall';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  nodes: Array<Maybe<Call>>;
};

export type PaginatedMediaLibrary = {
  __typename?: 'PaginatedMediaLibrary';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  nodes: Array<Maybe<MediaLibrary>>;
};

export type PaginatedNotification = {
  __typename?: 'PaginatedNotification';
  totalCount: Scalars['Int'];
  unreadCount: Scalars['Int'];
  pageInfo: PageInfo;
  nodes: Array<Maybe<Notification>>;
};

export type Participant = {
  __typename?: 'Participant';
  id: Scalars['Int'];
  account: Account;
  role: ParticipantRole;
  status: ParticipantStatus;
  joinTime: Scalars['DateTime'];
  twilioToken: Scalars['String'];
};

export enum ParticipantRole {
  Caller = 'CALLER',
  Callee = 'CALLEE',
  GuestCallee = 'GUEST_CALLEE'
}

export enum ParticipantStatus {
  Ringing = 'RINGING',
  Answered = 'ANSWERED',
  Left = 'LEFT',
  Expired = 'EXPIRED'
}

export type Payment = {
  __typename?: 'Payment';
  id: Scalars['Int'];
  account: Account;
  createdAt: Scalars['DateTime'];
  paymentGateway: PaymentGateway;
  amount: Scalars['Int'];
  currency: Currency;
  authorization: SubscriptionAuthorization;
};

export enum PaymentGateway {
  Cash = 'Cash',
  OnlineTransaction = 'OnlineTransaction',
  AdminApproved = 'AdminApproved'
}

export type PresignedUrlInput = {
  fileName?: Maybe<Scalars['String']>;
};

export type PresignedUrlResponse = {
  __typename?: 'PresignedUrlResponse';
  url: Scalars['String'];
  key: Scalars['String'];
  contentType: Scalars['String'];
  expiry: Scalars['Int'];
};

export type Profile = ClientProfile | DoctorProfile | SystemUserProfile;

export type PushNotification = {
  externalURL?: Maybe<Scalars['String']>;
  language: LanguageCode;
  title: Scalars['String'];
  body: Scalars['String'];
  role: AccountRole;
};

export type PushNotificationResponse = {
  __typename?: 'PushNotificationResponse';
  accounts: Scalars['Int'];
  devices: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<Account>;
  accounts: PaginatedAccount;
  doctorRequests: Array<Maybe<DoctorAccountRequest>>;
  doctorRequest: DoctorAccountRequest;
  myContacts?: Maybe<PaginatedAccount>;
  me: Account;
  config: Config;
  myCalls: PaginatedCall;
  calls: PaginatedCall;
  call: Call;
  getPresignedS3Url?: Maybe<PresignedUrlResponse>;
  getPresignedPublicS3Url?: Maybe<PresignedUrlResponse>;
  getMedia: Media;
  myMedicalCards: Array<Maybe<MedicalCard>>;
  getMedicalCards: Array<Maybe<MedicalCard>>;
  getMedicalCard?: Maybe<MedicalCard>;
  getMedicalCardDocument: Document;
  getRecipeEmailTextForMedicalCard: Scalars['String'];
  getEvent: Event;
  getEvents: Array<Maybe<Event>>;
  getEventsNotUserScoped: Array<Maybe<Event>>;
  languages: Array<Maybe<Language>>;
  countries: Array<Maybe<Country>>;
  country?: Maybe<Country>;
  cities: Array<Maybe<City>>;
  city?: Maybe<City>;
  healthCenters: Array<Maybe<HealthCenter>>;
  healthCenter?: Maybe<HealthCenter>;
  specialities: Array<Maybe<Speciality>>;
  speciality?: Maybe<Speciality>;
  insurancePolicies: Array<Maybe<InsurancePolicy>>;
  insurancePolicy?: Maybe<InsurancePolicy>;
  tiers: Array<Maybe<Tier>>;
  tier?: Maybe<Tier>;
  tierByTierId: Tier;
  benefits: Array<Maybe<Benefit>>;
  benefit?: Maybe<Benefit>;
  mySubscriptions: Array<Maybe<AccountSubscription>>;
  myHealthInsuranceCard?: Maybe<HealthInsuranceCard>;
  authors: Array<Maybe<Account>>;
  admins: Array<Maybe<Account>>;
  articles: PaginatedArticle;
  myArticles: PaginatedArticle;
  article?: Maybe<Article>;
  advertisements: Array<Maybe<Advertisement>>;
  advertisement?: Maybe<Advertisement>;
  notifications: PaginatedNotification;
  code?: Maybe<TierCode>;
  codeStats: Array<Maybe<CodeStatsResponse>>;
  subscriptions: PaginatedAccountSubscription;
  subscription?: Maybe<AccountSubscription>;
  frequentlyAskedQuestions?: Maybe<Array<Maybe<Faq>>>;
  frequentlyAskedQuestion?: Maybe<Faq>;
  getSubscriptionsThatNeedReview?: Maybe<SubscriptionsThatNeedReviewResponse>;
  callsReport: Array<Maybe<ReportItem>>;
  medicalCardsByMedicalConcernReport: Array<Maybe<SimpleReportItem>>;
  subscriptionsReport: Array<Maybe<ReportItem>>;
  subscriptionsByTier: Array<Maybe<SubscriptionsByTier>>;
  damagesStatus: Array<Maybe<Damage>>;
  allWaitingQueue: Array<Maybe<AllWaitingQueueResponseItem>>;
  stories: Array<Maybe<Story>>;
  story?: Maybe<Story>;
  temporaryBlockages: Array<Maybe<TemporaryBlockage>>;
  medicalConcernCategories: Array<Maybe<MedicalConcernCategory>>;
  medicalConcernCategory?: Maybe<MedicalConcernCategory>;
  mediaLibraryItems: PaginatedMediaLibrary;
  mediaLibraryItem?: Maybe<MediaLibrary>;
  callsByDoctorStats: CallStatsReport;
};


export type QueryAccountArgs = {
  where: ClientAccountQuery;
};


export type QueryAccountsArgs = {
  where: AccountsQueryInput;
  page: Scalars['Int'];
  pageLimit: Scalars['Int'];
};


export type QueryDoctorRequestArgs = {
  where: WhereIdUnique;
};


export type QueryMyContactsArgs = {
  where?: Maybe<FilterMyPAtients>;
  page: Scalars['Int'];
  pageLimit: Scalars['Int'];
};


export type QueryMyCallsArgs = {
  where?: Maybe<MyCallsWhereInput>;
  page?: Maybe<Scalars['Int']>;
  pageLimit?: Maybe<Scalars['Int']>;
};


export type QueryCallsArgs = {
  where?: Maybe<CallsWhereInput>;
  page: Scalars['Int'];
  pageLimit: Scalars['Int'];
};


export type QueryCallArgs = {
  where?: Maybe<CallWhereInput>;
};


export type QueryGetPresignedS3UrlArgs = {
  data?: Maybe<PresignedUrlInput>;
};


export type QueryGetPresignedPublicS3UrlArgs = {
  data?: Maybe<PresignedUrlInput>;
};


export type QueryGetMediaArgs = {
  id: Scalars['Int'];
  resize?: Maybe<GetMediaResizeInput>;
};


export type QueryGetMedicalCardsArgs = {
  patientId: Scalars['Int'];
};


export type QueryGetMedicalCardArgs = {
  id: Scalars['Int'];
};


export type QueryGetMedicalCardDocumentArgs = {
  id: Scalars['Int'];
};


export type QueryGetRecipeEmailTextForMedicalCardArgs = {
  id: Scalars['Int'];
};


export type QueryGetEventArgs = {
  id: Scalars['Int'];
};


export type QueryGetEventsArgs = {
  where?: Maybe<GetEventsInput>;
};


export type QueryGetEventsNotUserScopedArgs = {
  where?: Maybe<GetEventsInput>;
};


export type QueryCountryArgs = {
  where: WhereIdUnique;
};


export type QueryCitiesArgs = {
  countryId?: Maybe<Scalars['Int']>;
};


export type QueryCityArgs = {
  where: WhereIdUnique;
};


export type QueryHealthCentersArgs = {
  cityId?: Maybe<Scalars['Int']>;
};


export type QueryHealthCenterArgs = {
  where: WhereIdUnique;
};


export type QuerySpecialityArgs = {
  where: WhereIdUnique;
};


export type QueryInsurancePolicyArgs = {
  where: WhereIdUnique;
};


export type QueryTierArgs = {
  where: WhereIdUnique;
};


export type QueryTierByTierIdArgs = {
  tierId: Scalars['String'];
};


export type QueryBenefitArgs = {
  where: WhereIdUnique;
};


export type QueryMySubscriptionsArgs = {
  current?: Maybe<Scalars['Boolean']>;
};


export type QueryArticlesArgs = {
  page?: Maybe<Scalars['Int']>;
  pageLimit?: Maybe<Scalars['Int']>;
};


export type QueryMyArticlesArgs = {
  page?: Maybe<Scalars['Int']>;
  pageLimit?: Maybe<Scalars['Int']>;
};


export type QueryArticleArgs = {
  id: Scalars['Int'];
};


export type QueryAdvertisementArgs = {
  position: AdvertisementPosition;
};


export type QueryNotificationsArgs = {
  page: Scalars['Int'];
  pageLimit: Scalars['Int'];
};


export type QueryCodeArgs = {
  code: Scalars['String'];
};


export type QuerySubscriptionsArgs = {
  range?: Maybe<DateRange>;
  endRange?: Maybe<DateRange>;
  tierId?: Maybe<Scalars['Int']>;
  page: Scalars['Int'];
  pageLimit: Scalars['Int'];
};


export type QuerySubscriptionArgs = {
  id: Scalars['Int'];
};


export type QueryFrequentlyAskedQuestionsArgs = {
  search?: Maybe<Scalars['String']>;
};


export type QueryFrequentlyAskedQuestionArgs = {
  id: Scalars['Int'];
};


export type QueryCallsReportArgs = {
  range: DateRange;
};


export type QueryMedicalCardsByMedicalConcernReportArgs = {
  range: DateRange;
};


export type QuerySubscriptionsReportArgs = {
  range: DateRange;
};


export type QueryStoryArgs = {
  id: Scalars['Int'];
};


export type QueryTemporaryBlockagesArgs = {
  accountId: Scalars['Int'];
};


export type QueryMedicalConcernCategoryArgs = {
  id: Scalars['Int'];
};


export type QueryMediaLibraryItemsArgs = {
  where?: Maybe<MediaLibraryItemsWhereInput>;
  page: Scalars['Int'];
  pageLimit: Scalars['Int'];
};


export type QueryMediaLibraryItemArgs = {
  where: MediaLibraryItemWhereInput;
};

export type QueueCallWhereInput = {
  callId: Scalars['Int'];
};

export type QueueUpdateSubscriptionPayload = {
  __typename?: 'QueueUpdateSubscriptionPayload';
  count: Scalars['Int'];
};

export type RegisterFcmTokenPayload = {
  device: DeviceType;
  token: Scalars['String'];
};

export type ReportItem = {
  __typename?: 'ReportItem';
  day: Scalars['Int'];
  month: Scalars['Int'];
  year: Scalars['Int'];
  date: Scalars['DateTime'];
  value: Scalars['Int'];
};

export type RequestCall = {
  to?: Maybe<Scalars['Int']>;
  except: Array<Maybe<Scalars['Int']>>;
};

export type RequestPasswordResetPayload = {
  email: Scalars['String'];
};

export type ResetPasswordPayload = {
  email: Scalars['String'];
  verificationCode: Scalars['String'];
  password: Scalars['String'];
};

export type RetryCallNotification = {
  callId: Scalars['Int'];
};

export type SimpleReportItem = {
  __typename?: 'SimpleReportItem';
  name: Scalars['String'];
  value: Scalars['Int'];
};

export type SpecialistSignupPayload = {
  email: Scalars['String'];
  password: Scalars['String'];
  phoneNumber: Scalars['String'];
  name: Scalars['String'];
  lastname: Scalars['String'];
  birthday: Scalars['Date'];
  sex: Gender;
  licenceNumber: Scalars['String'];
  bio?: Maybe<Scalars['String']>;
  cityId: Scalars['Int'];
  countryId: Scalars['Int'];
  healthCenterId: Scalars['Int'];
  specialityId: Scalars['Int'];
  languageCode: LanguageCode;
};

export type Speciality = {
  __typename?: 'Speciality';
  id: Scalars['Int'];
  name: Scalars['String'];
  rawName: MultiLangStringType;
};

export enum StorableNotificationType {
  Unknown = 'UNKNOWN',
  CallRetry = 'CALL_RETRY',
  EventStartedForClient = 'EVENT_STARTED_FOR_CLIENT',
  EventStartedForDoctor = 'EVENT_STARTED_FOR_DOCTOR',
  EventWillStartForClient = 'EVENT_WILL_START_FOR_CLIENT',
  EventWillStartForDoctor = 'EVENT_WILL_START_FOR_DOCTOR',
  MedicalCardCreated = 'MEDICAL_CARD_CREATED',
  MedicalCardCommentCreated = 'MEDICAL_CARD_COMMENT_CREATED',
  MedicalCardDocumentCreated = 'MEDICAL_CARD_DOCUMENT_CREATED',
  MedicalCardDocumentCommentCreated = 'MEDICAL_CARD_DOCUMENT_COMMENT_CREATED',
  System = 'SYSTEM'
}

export type Story = {
  __typename?: 'Story';
  id: Scalars['Int'];
  order: Scalars['Int'];
  author: Account;
  icon?: Maybe<Media>;
  title: Scalars['String'];
  rawTitle: MultiLangStringType;
  items: Array<Maybe<StoryItem>>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  isActive: Scalars['Boolean'];
};


export type StoryIconArgs = {
  size?: Maybe<Image_Size>;
  resize?: Maybe<GetMediaResizeInput>;
};

export type StoryItem = {
  __typename?: 'StoryItem';
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  type: StoryItemType;
  linkURL?: Maybe<Scalars['String']>;
  linkLabel?: Maybe<Scalars['String']>;
  bgColor: Scalars['String'];
  media?: Maybe<Media>;
  author: Account;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  language: Language;
};


export type StoryItemMediaArgs = {
  size?: Maybe<Image_Size>;
  resize?: Maybe<GetMediaResizeInput>;
};

export enum StoryItemType {
  Video = 'VIDEO',
  Image = 'IMAGE'
}

export type Subscription = {
  __typename?: 'Subscription';
  callUpdate?: Maybe<CallUpdateSubscriptionPayload>;
  queueUpdate?: Maybe<QueueUpdateSubscriptionPayload>;
  incomingCall?: Maybe<IncomingCallSubscriptionPayload>;
  myWaitingQueue: Array<Maybe<Call>>;
};


export type SubscriptionCallUpdateArgs = {
  where: CallWhereInput;
};


export type SubscriptionQueueUpdateArgs = {
  where: QueueCallWhereInput;
};

export type SubscriptionAuthorization = InsurancePolicyHolderSubscriptionAuthorization | TierCardHolderSubscriptionAuthorization;

export enum SubscriptionAuthorizationInsuranceCodeType {
  Card = 'CARD',
  Serial = 'SERIAL'
}

export enum SubscriptionAuthorizationInsuranceUsageType {
  Personal = 'PERSONAL',
  Company = 'COMPANY'
}

export enum SubscriptionAuthorizationStatus {
  Verified = 'VERIFIED',
  RequiredVerification = 'REQUIRED_VERIFICATION'
}

export enum SubscriptionAuthorizerType {
  InsurancePolicyHolder = 'INSURANCE_POLICY_HOLDER',
  TierCardHolder = 'TIER_CARD_HOLDER',
  TierCardTransaction = 'TIER_CARD_TRANSACTION',
  ExternalClient = 'EXTERNAL_CLIENT'
}

export type SubscriptionsByTier = {
  __typename?: 'SubscriptionsByTier';
  tierId: Scalars['Int'];
  tierName: Scalars['String'];
  subscriptions: Scalars['Int'];
};

export type SubscriptionsThatNeedReviewResponse = {
  __typename?: 'SubscriptionsThatNeedReviewResponse';
  totalCount: Scalars['Int'];
  nodes: Array<Maybe<AccountSubscription>>;
};

export type SystemNotificationRelatedResources = {
  __typename?: 'SystemNotificationRelatedResources';
  type: Scalars['String'];
  externalURL?: Maybe<Scalars['String']>;
};

export type SystemUserProfile = {
  __typename?: 'SystemUserProfile';
  type: AccountType;
  id: Scalars['Int'];
  name: Scalars['String'];
  lastname: Scalars['String'];
};

export type SystemUserSignupPayload = {
  email: Scalars['String'];
  name: Scalars['String'];
  lastname: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
};

export type TemporaryBlockage = {
  __typename?: 'TemporaryBlockage';
  id: Scalars['Int'];
  author: Account;
  reason: Scalars['String'];
  validUntil: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

export type Tier = {
  __typename?: 'Tier';
  id: Scalars['Int'];
  tierId: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  rawName: MultiLangStringType;
  rawDescription: MultiLangStringType;
  color: Scalars['String'];
  activeDays: Scalars['Int'];
  eventsPerMonth: Scalars['Int'];
  pricePerYear: Scalars['Int'];
  isPublic: Scalars['Boolean'];
  isDefaultForSigalClients: Scalars['Boolean'];
  isDefaultForDemo: Scalars['Boolean'];
  benefits: Array<Maybe<Benefit>>;
  sigalHealthInsuranceType?: Maybe<HealthInsuranceCardType>;
};

export type TierCardHolderSubscriptionAuthorization = {
  __typename?: 'TierCardHolderSubscriptionAuthorization';
  type: SubscriptionAuthorizerType;
  payment: Payment;
  tier: Tier;
  tierCode?: Maybe<TierCode>;
  createdAt: Scalars['DateTime'];
  subscription: AccountSubscription;
};

export type TierCode = {
  __typename?: 'TierCode';
  id: Scalars['Int'];
  code: Scalars['String'];
  type: TierCodeType;
  status: TierCodeStatus;
  issueDate: Scalars['DateTime'];
  claimDate?: Maybe<Scalars['DateTime']>;
  tier: Tier;
  client?: Maybe<Account>;
};

export enum TierCodeStatus {
  Unused = 'UNUSED',
  Used = 'USED'
}

export enum TierCodeType {
  Card = 'CARD',
  Buy = 'BUY'
}

export type TimeTableItem = {
  dayOfWeek: DayOfWeek;
  startHour: Scalars['Int'];
  startMinute: Scalars['Int'];
  endHour: Scalars['Int'];
  endMinute: Scalars['Int'];
};

export type UpdateAccountLanguagePayload = {
  languageCode: LanguageCode;
};

export type UpdateClientPayload = {
  phoneNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['Date']>;
  sex?: Maybe<Gender>;
  languageCode?: Maybe<LanguageCode>;
};

export type UpdateDoctorPayload = {
  phoneNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['Date']>;
  sex?: Maybe<Gender>;
  licenceNumber?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  cityId?: Maybe<Scalars['Int']>;
  countryId?: Maybe<Scalars['Int']>;
  healthCenterId?: Maybe<Scalars['Int']>;
  languageCode?: Maybe<LanguageCode>;
};

export type UpdateEventPayload = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  coverMediaKey?: Maybe<Scalars['String']>;
  specialistId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  durationMinutes?: Maybe<Scalars['Int']>;
  maxParticipantsNumber?: Maybe<Scalars['Int']>;
};

export type UpdateMedicalCardPayload = {
  symptoms?: Maybe<Scalars['String']>;
  diagnosis?: Maybe<Scalars['String']>;
  recommendation?: Maybe<Scalars['String']>;
  recipe?: Maybe<Scalars['String']>;
  privateNote?: Maybe<Scalars['String']>;
  medicalConcernCategoryId?: Maybe<Scalars['Int']>;
};

export type UpdateSpecialistPayload = {
  phoneNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['Date']>;
  sex?: Maybe<Gender>;
  licenceNumber?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  cityId?: Maybe<Scalars['Int']>;
  countryId?: Maybe<Scalars['Int']>;
  healthCenterId?: Maybe<Scalars['Int']>;
  specialityId?: Maybe<Scalars['Int']>;
  languageCode?: Maybe<LanguageCode>;
};


export type WhereIdUnique = {
  id: Scalars['Int'];
};

export type WhereStringIdUnique = {
  id: Scalars['String'];
};

export type UpdateSystemUser = {
  name?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type ShortAccountDataFragmentFragment = (
  { __typename?: 'Account' }
  & Pick<Account, 'id' | 'role' | 'profileImage' | 'createdAt'>
  & { profile?: Maybe<(
    { __typename: 'ClientProfile' }
    & Pick<ClientProfile, 'id' | 'name' | 'lastname'>
  ) | (
    { __typename: 'DoctorProfile' }
    & Pick<DoctorProfile, 'name' | 'lastname'>
  ) | (
    { __typename: 'SystemUserProfile' }
    & Pick<SystemUserProfile, 'name' | 'lastname'>
  )> }
);

export type ShortAccountDataFragment = (
  { __typename?: 'Account' }
  & Pick<Account, 'id' | 'role' | 'profileImage'>
  & { profile?: Maybe<(
    { __typename: 'ClientProfile' }
    & Pick<ClientProfile, 'id' | 'name' | 'lastname'>
  ) | (
    { __typename: 'DoctorProfile' }
    & Pick<DoctorProfile, 'name' | 'lastname'>
  ) | { __typename: 'SystemUserProfile' }> }
);

export type AddDocumentToMedicalCardMutationVariables = Exact<{
  medicalCardId: Scalars['Int'];
  key: Scalars['String'];
  description: Scalars['String'];
}>;


export type AddDocumentToMedicalCardMutation = (
  { __typename?: 'Mutation' }
  & { addDocumentToMedicalCard: (
    { __typename?: 'Document' }
    & Pick<Document, 'id' | 'description'>
    & { author: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), thumbnail: (
      { __typename?: 'Media' }
      & Pick<Media, 'url' | 'contentType'>
    ), media: (
      { __typename?: 'Media' }
      & Pick<Media, 'url' | 'contentType'>
    ) }
  ) }
);

export type AddTimetableMutationVariables = Exact<{
  id: Scalars['Int'];
  data: Array<TimeTableItem>;
}>;


export type AddTimetableMutation = (
  { __typename?: 'Mutation' }
  & { updateTimetable?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'id'>
  )> }
);

export type AnswerCallMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AnswerCallMutation = (
  { __typename?: 'Mutation' }
  & { answerCall: (
    { __typename?: 'Call' }
    & Pick<Call, 'id' | 'status' | 'room' | 'requestTime' | 'startTime' | 'endTime'>
    & { participants: Array<(
      { __typename?: 'Participant' }
      & Pick<Participant, 'id' | 'role' | 'status' | 'joinTime' | 'twilioToken'>
      & { account: (
        { __typename?: 'Account' }
        & Pick<Account, 'id' | 'email' | 'accountStatus' | 'subscriptionStatus' | 'role' | 'createdAt'>
        & { profile?: Maybe<(
          { __typename: 'ClientProfile' }
          & Pick<ClientProfile, 'id' | 'name' | 'lastname' | 'birthday' | 'sex'>
        ) | (
          { __typename: 'DoctorProfile' }
          & Pick<DoctorProfile, 'id' | 'name' | 'lastname' | 'birthday' | 'sex'>
        ) | (
          { __typename: 'SystemUserProfile' }
          & Pick<SystemUserProfile, 'id' | 'type'>
        )> }
      ) }
    )> }
  ) }
);

export type ApproveDoctorRequestAsSpecialistMutationVariables = Exact<{
  id: Scalars['Int'];
  specialityId: Scalars['Int'];
}>;


export type ApproveDoctorRequestAsSpecialistMutation = (
  { __typename?: 'Mutation' }
  & { approveDoctorRequestAsSpecialist: (
    { __typename?: 'Account' }
    & Pick<Account, 'id'>
  ) }
);

export type ApproveDoctorRequestMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ApproveDoctorRequestMutation = (
  { __typename?: 'Mutation' }
  & { approveDoctorRequest: (
    { __typename?: 'Account' }
    & Pick<Account, 'id'>
  ) }
);

export type ApproveSubscriptionsThatNeedReviewMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ApproveSubscriptionsThatNeedReviewMutation = (
  { __typename?: 'Mutation' }
  & { approveSubscriptionsThatNeedReview?: Maybe<(
    { __typename?: 'AccountSubscription' }
    & Pick<AccountSubscription, 'id'>
  )> }
);

export type ChangePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type ChangePasswordMutation = (
  { __typename?: 'Mutation' }
  & { changePassword?: Maybe<(
    { __typename?: 'AuthResponse' }
    & Pick<AuthResponse, 'token'>
  )> }
);

export type ClientSignupUsingSigalInsurancePolicyMutationVariables = Exact<{
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  name: Scalars['String'];
  lastname: Scalars['String'];
  birthday: Scalars['Date'];
  sex: Gender;
  languageCode: LanguageCode;
  insurancePoliceId: Scalars['Int'];
  insurancePolicyCode: Scalars['String'];
}>;


export type ClientSignupUsingSigalInsurancePolicyMutation = (
  { __typename?: 'Mutation' }
  & { clientSignupUsingSigalInsurancePolicy?: Maybe<(
    { __typename?: 'AuthResponse' }
    & Pick<AuthResponse, 'token'>
  )> }
);

export type ClientSignupAdminMutationVariables = Exact<{
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  name: Scalars['String'];
  lastname: Scalars['String'];
  birthday: Scalars['Date'];
  sex: Gender;
  languageCode: LanguageCode;
  tierId: Scalars['Int'];
}>;


export type ClientSignupAdminMutation = (
  { __typename?: 'Mutation' }
  & { clientSignupAdmin?: Maybe<(
    { __typename?: 'AuthResponse' }
    & Pick<AuthResponse, 'token'>
  )> }
);

export type Clients2csvMutationVariables = Exact<{ [key: string]: never; }>;


export type Clients2csvMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'clients2csv'>
);

export type CreateAdminMutationVariables = Exact<{
  email: Scalars['String'];
  name: Scalars['String'];
  lastname: Scalars['String'];
  phoneNumber: Scalars['String'];
}>;


export type CreateAdminMutation = (
  { __typename?: 'Mutation' }
  & { createAdmin: (
    { __typename?: 'Account' }
    & Pick<Account, 'id' | 'email'>
  ) }
);

export type CreateArticleMutationVariables = Exact<{
  languageCode: LanguageCode;
  title: Scalars['String'];
  body: Scalars['String'];
  coverMediaKey: Scalars['String'];
  excerpt: Scalars['String'];
}>;


export type CreateArticleMutation = (
  { __typename?: 'Mutation' }
  & { createArticle: (
    { __typename?: 'Article' }
    & Pick<Article, 'id'>
  ) }
);

export type CreateAuthorMutationVariables = Exact<{
  email: Scalars['String'];
  name: Scalars['String'];
  lastname: Scalars['String'];
}>;


export type CreateAuthorMutation = (
  { __typename?: 'Mutation' }
  & { createAuthor: (
    { __typename?: 'Account' }
    & Pick<Account, 'id' | 'email'>
  ) }
);

export type CreateBenefitMutationVariables = Exact<{
  title: MultiLanguageString;
  descriptioin: MultiLanguageString;
  imageMediaKey: Scalars['String'];
  externalURL?: Maybe<Scalars['String']>;
  externalUrlLabel?: Maybe<MultiLanguageString>;
}>;


export type CreateBenefitMutation = (
  { __typename?: 'Mutation' }
  & { createBenefit?: Maybe<(
    { __typename?: 'Benefit' }
    & Pick<Benefit, 'id' | 'title' | 'description' | 'externalUrlLabel' | 'externalURL' | 'createdAt' | 'updatedAt'>
    & { image?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'id' | 'url' | 'key'>
    )>, rawTitle: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ), rawDescription: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ), rawExternalUrlLabel?: Maybe<(
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    )>, tiers: Array<Maybe<(
      { __typename?: 'Tier' }
      & Pick<Tier, 'id' | 'name'>
    )>> }
  )> }
);

export type CreateCityMutationVariables = Exact<{
  name: MultiLanguageString;
  countryId: Scalars['Int'];
}>;


export type CreateCityMutation = (
  { __typename?: 'Mutation' }
  & { createCity?: Maybe<(
    { __typename?: 'City' }
    & Pick<City, 'id' | 'name'>
  )> }
);

export type CreateCountryMutationVariables = Exact<{
  name: MultiLanguageString;
}>;


export type CreateCountryMutation = (
  { __typename?: 'Mutation' }
  & { createCountry?: Maybe<(
    { __typename?: 'Country' }
    & Pick<Country, 'id' | 'name'>
  )> }
);

export type CreateDoctorRequestMutationVariables = Exact<{
  name: Scalars['String'];
  lastname: Scalars['String'];
  languageCode: LanguageCode;
  email: Scalars['String'];
  password: Scalars['String'];
  birthday: Scalars['Date'];
  phoneNumber: Scalars['String'];
  licenceNumber: Scalars['String'];
  cvKey: Scalars['String'];
  sex: Gender;
  countryId: Scalars['Int'];
  cityId: Scalars['Int'];
  healthCenterId: Scalars['Int'];
}>;


export type CreateDoctorRequestMutation = (
  { __typename?: 'Mutation' }
  & { createDoctorRequest: (
    { __typename?: 'DoctorAccountRequest' }
    & Pick<DoctorAccountRequest, 'id' | 'name' | 'lastname'>
  ) }
);

export type CreateDocumentCommentMutationVariables = Exact<{
  documentId: Scalars['Int'];
  content: Scalars['String'];
}>;


export type CreateDocumentCommentMutation = (
  { __typename?: 'Mutation' }
  & { createDocumentComment: (
    { __typename?: 'DocumentComment' }
    & Pick<DocumentComment, 'id' | 'content' | 'createdAt' | 'updatedAt'>
    & { author: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ) }
  ) }
);

export type CreateEventMutationVariables = Exact<{
  title: Scalars['String'];
  description: Scalars['String'];
  coverMediaKey: Scalars['String'];
  specialistId: Scalars['Int'];
  startDate: Scalars['DateTime'];
  durationMinutes: Scalars['Int'];
  maxParticipantsNumber: Scalars['Int'];
}>;


export type CreateEventMutation = (
  { __typename?: 'Mutation' }
  & { createEvent: (
    { __typename?: 'Event' }
    & Pick<Event, 'id' | 'title' | 'description' | 'roomName' | 'startDate' | 'endDate' | 'durationMinutes' | 'participationStatus' | 'createdAt' | 'updatedAt'>
    & { cover?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'id' | 'url' | 'createdAt' | 'contentType'>
    )>, specialist: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), creator: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), participants: (
      { __typename?: 'EventParticipants' }
      & Pick<EventParticipants, 'maxNumber' | 'currentCount'>
      & { list: Array<Maybe<(
        { __typename?: 'Account' }
        & ShortAccountDataFragment
      )>> }
    ) }
  ) }
);

export type SendRetryCallNotificationMutationVariables = Exact<{
  callId: Scalars['Int'];
}>;


export type SendRetryCallNotificationMutation = (
  { __typename?: 'Mutation' }
  & { sendRetryCallNotification: (
    { __typename?: 'Notification' }
    & Pick<Notification, 'id' | 'text' | 'createdAt'>
  ) }
);

export type CreateFaqMutationVariables = Exact<{
  title: MultiLanguageString;
  body: MultiLanguageString;
}>;


export type CreateFaqMutation = (
  { __typename?: 'Mutation' }
  & { createFaq?: Maybe<(
    { __typename?: 'Faq' }
    & Pick<Faq, 'id' | 'title' | 'body'>
    & { rawTitle: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ), rawBody: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ) }
  )> }
);

export type CreateHealthCenterMutationVariables = Exact<{
  name: MultiLanguageString;
  cityId: Scalars['Int'];
}>;


export type CreateHealthCenterMutation = (
  { __typename?: 'Mutation' }
  & { createHealthCenter?: Maybe<(
    { __typename?: 'HealthCenter' }
    & Pick<HealthCenter, 'id' | 'name'>
  )> }
);

export type CreateInsurancePolicyMutationVariables = Exact<{
  name: MultiLanguageString;
}>;


export type CreateInsurancePolicyMutation = (
  { __typename?: 'Mutation' }
  & { createInsurancePolicy?: Maybe<(
    { __typename?: 'InsurancePolicy' }
    & Pick<InsurancePolicy, 'id' | 'name'>
  )> }
);

export type CreateMediaLibraryItemMutationVariables = Exact<{
  title: Scalars['String'];
  mediaKey: Scalars['String'];
}>;


export type CreateMediaLibraryItemMutation = (
  { __typename?: 'Mutation' }
  & { createMediaLibraryItem: (
    { __typename?: 'MediaLibrary' }
    & Pick<MediaLibrary, 'id'>
  ) }
);

export type CreateMedicalCardCommentMutationVariables = Exact<{
  medicalCardId: Scalars['Int'];
  content: Scalars['String'];
}>;


export type CreateMedicalCardCommentMutation = (
  { __typename?: 'Mutation' }
  & { createMedicalCardComment: (
    { __typename?: 'MedicalCardComment' }
    & Pick<MedicalCardComment, 'id' | 'content' | 'createdAt' | 'updatedAt'>
    & { author: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ) }
  ) }
);

export type CreateMedicalCardMutationVariables = Exact<{
  patientId: Scalars['Int'];
  symptoms: Scalars['String'];
  diagnosis: Scalars['String'];
  recommendation: Scalars['String'];
  recipe: Scalars['String'];
  privateNote?: Maybe<Scalars['String']>;
  medicalConcernCategoryId: Scalars['Int'];
}>;


export type CreateMedicalCardMutation = (
  { __typename?: 'Mutation' }
  & { createMedicalCard: (
    { __typename?: 'MedicalCard' }
    & Pick<MedicalCard, 'id' | 'symptoms' | 'diagnosis' | 'recommendation' | 'recipe' | 'privateNote' | 'createdAt' | 'updatedAt'>
    & { patient: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), doctor: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), concernCategory?: Maybe<(
      { __typename?: 'MedicalConcernCategory' }
      & Pick<MedicalConcernCategory, 'id' | 'name'>
    )>, documents: Array<Maybe<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'description'>
      & { author: (
        { __typename?: 'Account' }
        & ShortAccountDataFragment
      ), thumbnail: (
        { __typename?: 'Media' }
        & Pick<Media, 'id' | 'url' | 'createdAt' | 'contentType' | 'byteSize'>
      ), media: (
        { __typename?: 'Media' }
        & Pick<Media, 'url'>
      ), comments: Array<Maybe<(
        { __typename?: 'DocumentComment' }
        & Pick<DocumentComment, 'content' | 'createdAt' | 'updatedAt'>
        & { author: (
          { __typename?: 'Account' }
          & ShortAccountDataFragment
        ) }
      )>> }
    )>>, comments: Array<Maybe<(
      { __typename?: 'MedicalCardComment' }
      & Pick<MedicalCardComment, 'id' | 'content' | 'createdAt' | 'updatedAt'>
      & { author: (
        { __typename?: 'Account' }
        & ShortAccountDataFragment
      ) }
    )>> }
  ) }
);

export type CreateMedicalConcernCategoryMutationVariables = Exact<{
  name: MultiLanguageString;
}>;


export type CreateMedicalConcernCategoryMutation = (
  { __typename?: 'Mutation' }
  & { createMedicalConcernCategory: (
    { __typename?: 'MedicalConcernCategory' }
    & Pick<MedicalConcernCategory, 'id' | 'name'>
  ) }
);

export type CreateSpecialityMutationVariables = Exact<{
  name: MultiLanguageString;
}>;


export type CreateSpecialityMutation = (
  { __typename?: 'Mutation' }
  & { createSpeciality?: Maybe<(
    { __typename?: 'Speciality' }
    & Pick<Speciality, 'id' | 'name'>
  )> }
);

export type CreateStoryItemMutationVariables = Exact<{
  isActive: Scalars['Boolean'];
  mediaKey: Scalars['String'];
  linkURL?: Maybe<Scalars['String']>;
  linkLabel?: Maybe<Scalars['String']>;
  bgColor?: Maybe<Scalars['String']>;
  storyId: Scalars['Int'];
  language: LanguageCode;
}>;


export type CreateStoryItemMutation = (
  { __typename?: 'Mutation' }
  & { createStoryItem?: Maybe<(
    { __typename?: 'StoryItem' }
    & Pick<StoryItem, 'id'>
  )> }
);

export type CreateStoryMutationVariables = Exact<{
  mediaKey: Scalars['String'];
  title: MultiLanguageString;
}>;


export type CreateStoryMutation = (
  { __typename?: 'Mutation' }
  & { createStory?: Maybe<(
    { __typename?: 'Story' }
    & Pick<Story, 'id' | 'order' | 'title' | 'createdAt' | 'updatedAt'>
    & { author: (
      { __typename?: 'Account' }
      & ShortAccountDataFragmentFragment
    ), icon?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'url'>
    )>, rawTitle: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ), items: Array<Maybe<(
      { __typename?: 'StoryItem' }
      & Pick<StoryItem, 'id' | 'isActive'>
    )>> }
  )> }
);

export type CreateTierMutationVariables = Exact<{
  nameSq: Scalars['String'];
  nameEn: Scalars['String'];
  nameMk: Scalars['String'];
  descriptionSq: Scalars['String'];
  descriptionEn: Scalars['String'];
  descriptionMk: Scalars['String'];
  color: Scalars['String'];
  activeDays: Scalars['Int'];
  eventsPerMonth: Scalars['Int'];
  pricePerYear: Scalars['Int'];
  default: Scalars['Boolean'];
  demo: Scalars['Boolean'];
  benefitIDs: Array<Scalars['Int']>;
  sigalHealthInsuranceType?: Maybe<HealthInsuranceCardType>;
}>;


export type CreateTierMutation = (
  { __typename?: 'Mutation' }
  & { createTier?: Maybe<(
    { __typename?: 'Tier' }
    & Pick<Tier, 'id' | 'name' | 'description' | 'color' | 'activeDays' | 'eventsPerMonth' | 'pricePerYear' | 'isPublic' | 'isDefaultForSigalClients' | 'isDefaultForDemo'>
  )> }
);

export type CreateUpdateAdvertisementMutationVariables = Exact<{
  position: AdvertisementPosition;
  isActive: Scalars['Boolean'];
  clickUrl?: Maybe<Scalars['String']>;
  mediaKey?: Maybe<Scalars['String']>;
}>;


export type CreateUpdateAdvertisementMutation = (
  { __typename?: 'Mutation' }
  & { createUpdateAdvertisement: (
    { __typename?: 'Advertisement' }
    & Pick<Advertisement, 'id' | 'position' | 'isActive' | 'clickUrl' | 'createdAt'>
    & { media?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'url'>
    )>, author: (
      { __typename?: 'Account' }
      & Pick<Account, 'id' | 'email' | 'profileImage' | 'role'>
      & { profile?: Maybe<{ __typename?: 'ClientProfile' } | { __typename?: 'DoctorProfile' } | (
        { __typename?: 'SystemUserProfile' }
        & Pick<SystemUserProfile, 'name' | 'lastname'>
      )> }
    ) }
  ) }
);

export type DeleteAdminMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteAdminMutation = (
  { __typename?: 'Mutation' }
  & { deleteAdmin?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'id'>
  )> }
);

export type DeleteArticleMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteArticleMutation = (
  { __typename?: 'Mutation' }
  & { deleteArticle: (
    { __typename?: 'Article' }
    & Pick<Article, 'id'>
  ) }
);

export type DeleteAuthorMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteAuthorMutation = (
  { __typename?: 'Mutation' }
  & { deleteAuthor?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'id'>
  )> }
);

export type DeleteBenefitMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteBenefitMutation = (
  { __typename?: 'Mutation' }
  & { deleteBenefit?: Maybe<(
    { __typename?: 'Benefit' }
    & Pick<Benefit, 'id'>
  )> }
);

export type DeleteCityMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteCityMutation = (
  { __typename?: 'Mutation' }
  & { deleteCity?: Maybe<(
    { __typename?: 'City' }
    & Pick<City, 'id'>
  )> }
);

export type DeleteCountryMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteCountryMutation = (
  { __typename?: 'Mutation' }
  & { deleteCountry?: Maybe<(
    { __typename?: 'Country' }
    & Pick<Country, 'id'>
  )> }
);

export type DeleteDoctorRequestMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteDoctorRequestMutation = (
  { __typename?: 'Mutation' }
  & { deleteDoctorRequest: (
    { __typename?: 'DoctorAccountRequest' }
    & Pick<DoctorAccountRequest, 'id'>
  ) }
);

export type DeleteDocumentCommentMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteDocumentCommentMutation = (
  { __typename?: 'Mutation' }
  & { deleteDocumentComment: (
    { __typename?: 'DocumentComment' }
    & Pick<DocumentComment, 'id' | 'content' | 'createdAt' | 'updatedAt'>
    & { author: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ) }
  ) }
);

export type DeleteDocumentFromMedicalCardMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteDocumentFromMedicalCardMutation = (
  { __typename?: 'Mutation' }
  & { deleteDocumentFromMedicalCard: (
    { __typename?: 'Document' }
    & Pick<Document, 'id' | 'description'>
    & { author: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), thumbnail: (
      { __typename?: 'Media' }
      & Pick<Media, 'url' | 'contentType'>
    ), media: (
      { __typename?: 'Media' }
      & Pick<Media, 'url' | 'contentType'>
    ) }
  ) }
);

export type DeleteEventMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteEventMutation = (
  { __typename?: 'Mutation' }
  & { deleteEvent: (
    { __typename?: 'Event' }
    & Pick<Event, 'id'>
  ) }
);

export type DeleteFaqMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteFaqMutation = (
  { __typename?: 'Mutation' }
  & { deleteFaq?: Maybe<(
    { __typename?: 'Faq' }
    & Pick<Faq, 'id' | 'title' | 'body'>
    & { rawTitle: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ), rawBody: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ) }
  )> }
);

export type DeleteFcmTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteFcmTokenMutation = (
  { __typename?: 'Mutation' }
  & { deleteFcmToken?: Maybe<(
    { __typename?: 'Device' }
    & Pick<Device, 'id'>
  )> }
);

export type DeleteHealthCenterMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteHealthCenterMutation = (
  { __typename?: 'Mutation' }
  & { deleteHealthCenter?: Maybe<(
    { __typename?: 'HealthCenter' }
    & Pick<HealthCenter, 'id'>
  )> }
);

export type DeleteInsurancePolicyMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteInsurancePolicyMutation = (
  { __typename?: 'Mutation' }
  & { deleteInsurancePolicy?: Maybe<(
    { __typename?: 'InsurancePolicy' }
    & Pick<InsurancePolicy, 'id'>
  )> }
);

export type DeleteMediaLibraryItemMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteMediaLibraryItemMutation = (
  { __typename?: 'Mutation' }
  & { deleteMediaLibraryItem?: Maybe<(
    { __typename?: 'MediaLibrary' }
    & Pick<MediaLibrary, 'id'>
  )> }
);

export type DeleteMedicalCardCommentMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteMedicalCardCommentMutation = (
  { __typename?: 'Mutation' }
  & { deleteMedicalCardComment: (
    { __typename?: 'MedicalCardComment' }
    & Pick<MedicalCardComment, 'id'>
  ) }
);

export type DeleteMedicalConcernCategoryMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteMedicalConcernCategoryMutation = (
  { __typename?: 'Mutation' }
  & { deleteMedicalConcernCategory?: Maybe<(
    { __typename?: 'MedicalConcernCategory' }
    & Pick<MedicalConcernCategory, 'id'>
  )> }
);

export type DeleteSpecialityMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteSpecialityMutation = (
  { __typename?: 'Mutation' }
  & { deleteSpeciality?: Maybe<(
    { __typename?: 'Speciality' }
    & Pick<Speciality, 'id'>
  )> }
);

export type DeleteStoryItemMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteStoryItemMutation = (
  { __typename?: 'Mutation' }
  & { deleteStoryItem?: Maybe<(
    { __typename?: 'StoryItem' }
    & Pick<StoryItem, 'id'>
  )> }
);

export type DeleteStoryMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteStoryMutation = (
  { __typename?: 'Mutation' }
  & { deleteStory?: Maybe<(
    { __typename?: 'Story' }
    & Pick<Story, 'id'>
  )> }
);

export type DeleteSubscriptionsThatNeedReviewMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteSubscriptionsThatNeedReviewMutation = (
  { __typename?: 'Mutation' }
  & { deleteSubscriptionsThatNeedReview?: Maybe<(
    { __typename?: 'AccountSubscription' }
    & Pick<AccountSubscription, 'id'>
  )> }
);

export type DeleteTierMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteTierMutation = (
  { __typename?: 'Mutation' }
  & { deleteTier?: Maybe<(
    { __typename?: 'Tier' }
    & Pick<Tier, 'id'>
  )> }
);

export type DoctorSignupMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  phoneNumber: Scalars['String'];
  name: Scalars['String'];
  lastname: Scalars['String'];
  birthday: Scalars['Date'];
  sex: Gender;
  licenceNumber: Scalars['String'];
  bio?: Maybe<Scalars['String']>;
  cityId: Scalars['Int'];
  countryId: Scalars['Int'];
  healthCenterId: Scalars['Int'];
  languageCode: LanguageCode;
}>;


export type DoctorSignupMutation = (
  { __typename?: 'Mutation' }
  & { doctorSignup?: Maybe<(
    { __typename?: 'AuthResponse' }
    & Pick<AuthResponse, 'token'>
  )> }
);

export type SpecialistSignupMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  phoneNumber: Scalars['String'];
  name: Scalars['String'];
  lastname: Scalars['String'];
  birthday: Scalars['Date'];
  sex: Gender;
  licenceNumber: Scalars['String'];
  bio?: Maybe<Scalars['String']>;
  cityId: Scalars['Int'];
  countryId: Scalars['Int'];
  healthCenterId: Scalars['Int'];
  languageCode: LanguageCode;
  specialityId: Scalars['Int'];
}>;


export type SpecialistSignupMutation = (
  { __typename?: 'Mutation' }
  & { specialistSignup?: Maybe<(
    { __typename?: 'AuthResponse' }
    & Pick<AuthResponse, 'token'>
  )> }
);

export type GenerateMedicalCardPdfMutationVariables = Exact<{
  medicalCardId: Scalars['Int'];
}>;


export type GenerateMedicalCardPdfMutation = (
  { __typename?: 'Mutation' }
  & { generateMedicalCardPDF?: Maybe<(
    { __typename?: 'GetMedicalCardPDFResponse' }
    & Pick<GetMedicalCardPdfResponse, 'url'>
  )> }
);

export type GenerateTierCodesMutationVariables = Exact<{
  tierIds: Array<Maybe<Scalars['Int']>>;
  type: TierCodeType;
}>;


export type GenerateTierCodesMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'generateTierCodes'>
);

export type GetRecipeEmailTextForMedicalCardMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetRecipeEmailTextForMedicalCardMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'getRecipeEmailTextForMedicalCard'>
);

export type InviteMutationVariables = Exact<{
  callId: Scalars['Int'];
  accountId: Scalars['Int'];
}>;


export type InviteMutation = (
  { __typename?: 'Mutation' }
  & { inviteGuestInCall: (
    { __typename?: 'Call' }
    & Pick<Call, 'id'>
    & { participants: Array<(
      { __typename?: 'Participant' }
      & Pick<Participant, 'twilioToken' | 'id' | 'role' | 'status' | 'joinTime'>
      & { account: (
        { __typename?: 'Account' }
        & Pick<Account, 'email'>
      ) }
    )> }
  ) }
);

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  tfaCode?: Maybe<Scalars['String']>;
}>;


export type LoginMutation = (
  { __typename?: 'Mutation' }
  & { login?: Maybe<(
    { __typename?: 'AuthResponse' }
    & Pick<AuthResponse, 'token'>
  )> }
);

export type MoveStoryDownMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type MoveStoryDownMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'moveStoryDown'>
);

export type MoveStoryUpMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type MoveStoryUpMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'moveStoryUp'>
);

export type NotifyAllMutationVariables = Exact<{
  language: LanguageCode;
  title: Scalars['String'];
  body: Scalars['String'];
  role: AccountRole;
  externalURL?: Maybe<Scalars['String']>;
}>;


export type NotifyAllMutation = (
  { __typename?: 'Mutation' }
  & { notifyAll: (
    { __typename?: 'PushNotificationResponse' }
    & Pick<PushNotificationResponse, 'accounts' | 'devices'>
  ) }
);

export type PublishTierMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PublishTierMutation = (
  { __typename?: 'Mutation' }
  & { publishTier: (
    { __typename?: 'Tier' }
    & Pick<Tier, 'id'>
  ) }
);

export type RegisterFcmTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type RegisterFcmTokenMutation = (
  { __typename?: 'Mutation' }
  & { registerFcmToken: (
    { __typename?: 'Device' }
    & Pick<Device, 'id' | 'type' | 'fcmToken' | 'date'>
    & { account: (
      { __typename?: 'Account' }
      & Pick<Account, 'email'>
    ) }
  ) }
);

export type RequestCallForEventMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RequestCallForEventMutation = (
  { __typename?: 'Mutation' }
  & { requestCallForEvent: (
    { __typename?: 'CreateCallResponse' }
    & Pick<CreateCallResponse, 'waitingQueueCount'>
    & { call: (
      { __typename?: 'Call' }
      & Pick<Call, 'id' | 'requestTime' | 'status'>
      & { participants: Array<(
        { __typename?: 'Participant' }
        & Pick<Participant, 'twilioToken' | 'id' | 'role' | 'status' | 'joinTime'>
        & { account: (
          { __typename?: 'Account' }
          & Pick<Account, 'email'>
        ) }
      )> }
    ) }
  ) }
);

export type RequestCallMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestCallMutation = (
  { __typename?: 'Mutation' }
  & { requestCall: (
    { __typename?: 'CreateCallResponse' }
    & Pick<CreateCallResponse, 'waitingQueueCount'>
    & { call: (
      { __typename?: 'Call' }
      & Pick<Call, 'id' | 'requestTime' | 'status'>
      & { participants: Array<(
        { __typename?: 'Participant' }
        & Pick<Participant, 'twilioToken' | 'id' | 'role' | 'status' | 'joinTime'>
        & { account: (
          { __typename?: 'Account' }
          & Pick<Account, 'email'>
        ) }
      )> }
    ) }
  ) }
);

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RequestPasswordResetMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'requestPasswordReset'>
);

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String'];
  verificationCode: Scalars['String'];
  password: Scalars['String'];
}>;


export type ResetPasswordMutation = (
  { __typename?: 'Mutation' }
  & { resetPassword: (
    { __typename?: 'Account' }
    & Pick<Account, 'id' | 'email'>
  ) }
);

export type SetAccountProfilePictureMutationVariables = Exact<{
  key: Scalars['String'];
  contentType: Scalars['String'];
}>;


export type SetAccountProfilePictureMutation = (
  { __typename?: 'Mutation' }
  & { setAccountProfilePicture: (
    { __typename?: 'Account' }
    & Pick<Account, 'id' | 'profileImage'>
  ) }
);

export type TemporaryBlockMutationVariables = Exact<{
  id: Scalars['Int'];
  hours: Scalars['Int'];
  reason: Scalars['String'];
}>;


export type TemporaryBlockMutation = (
  { __typename?: 'Mutation' }
  & { temporaryBlock: (
    { __typename?: 'TemporaryBlockage' }
    & Pick<TemporaryBlockage, 'id' | 'reason' | 'validUntil' | 'createdAt'>
    & { author: (
      { __typename?: 'Account' }
      & ShortAccountDataFragmentFragment
    ) }
  ) }
);

export type TerminateCallMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type TerminateCallMutation = (
  { __typename?: 'Mutation' }
  & { leaveCall: (
    { __typename?: 'Call' }
    & Pick<Call, 'id' | 'status' | 'room' | 'requestTime' | 'startTime' | 'endTime'>
    & { participants: Array<(
      { __typename?: 'Participant' }
      & Pick<Participant, 'twilioToken' | 'id' | 'role' | 'status' | 'joinTime'>
      & { account: (
        { __typename?: 'Account' }
        & Pick<Account, 'id' | 'email' | 'accountStatus' | 'subscriptionStatus' | 'role' | 'createdAt'>
        & { profile?: Maybe<(
          { __typename: 'ClientProfile' }
          & Pick<ClientProfile, 'id' | 'name' | 'lastname' | 'birthday' | 'sex'>
        ) | (
          { __typename: 'DoctorProfile' }
          & Pick<DoctorProfile, 'id' | 'name' | 'lastname' | 'birthday' | 'sex'>
        ) | (
          { __typename: 'SystemUserProfile' }
          & Pick<SystemUserProfile, 'id' | 'type'>
        )> }
      ) }
    )> }
  ) }
);

export type UpdateLanguageMutationVariables = Exact<{
  languageCode: LanguageCode;
}>;


export type UpdateLanguageMutation = (
  { __typename?: 'Mutation' }
  & { setAccountProfileLanguage: (
    { __typename?: 'Account' }
    & Pick<Account, 'id'>
  ) }
);

export type UpdateArticleMutationVariables = Exact<{
  id: Scalars['Int'];
  languageCode: LanguageCode;
  title: Scalars['String'];
  body: Scalars['String'];
  coverMediaKey: Scalars['String'];
  excerpt: Scalars['String'];
}>;


export type UpdateArticleMutation = (
  { __typename?: 'Mutation' }
  & { updateArticle: (
    { __typename?: 'Article' }
    & Pick<Article, 'id'>
  ) }
);

export type UpdateBenefitMutationVariables = Exact<{
  id: Scalars['Int'];
  title: MultiLanguageString;
  descriptioin: MultiLanguageString;
  imageMediaKey: Scalars['String'];
  externalURL?: Maybe<Scalars['String']>;
  externalUrlLabel?: Maybe<MultiLanguageString>;
}>;


export type UpdateBenefitMutation = (
  { __typename?: 'Mutation' }
  & { updateBenefit?: Maybe<(
    { __typename?: 'Benefit' }
    & Pick<Benefit, 'id' | 'title' | 'description' | 'externalUrlLabel' | 'externalURL' | 'createdAt' | 'updatedAt'>
    & { image?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'id' | 'url' | 'key'>
    )>, rawTitle: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ), rawDescription: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ), rawExternalUrlLabel?: Maybe<(
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    )>, tiers: Array<Maybe<(
      { __typename?: 'Tier' }
      & Pick<Tier, 'id' | 'name'>
    )>> }
  )> }
);

export type UpdateCityMutationVariables = Exact<{
  id: Scalars['Int'];
  name: MultiLanguageString;
  countryId: Scalars['Int'];
}>;


export type UpdateCityMutation = (
  { __typename?: 'Mutation' }
  & { updateCity?: Maybe<(
    { __typename?: 'City' }
    & Pick<City, 'id' | 'name'>
  )> }
);

export type UpdateCountryMutationVariables = Exact<{
  id: Scalars['Int'];
  name: MultiLanguageString;
}>;


export type UpdateCountryMutation = (
  { __typename?: 'Mutation' }
  & { updateCountry?: Maybe<(
    { __typename?: 'Country' }
    & Pick<Country, 'id' | 'name'>
  )> }
);

export type UpdateDoctorMutationVariables = Exact<{
  phoneNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['Date']>;
  sex?: Maybe<Gender>;
  licenceNumber?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  cityId?: Maybe<Scalars['Int']>;
  countryId?: Maybe<Scalars['Int']>;
  healthCenterId?: Maybe<Scalars['Int']>;
}>;


export type UpdateDoctorMutation = (
  { __typename?: 'Mutation' }
  & { updateDoctor: (
    { __typename?: 'Account' }
    & Pick<Account, 'id'>
  ) }
);

export type UpdateDocumentCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  content: Scalars['String'];
}>;


export type UpdateDocumentCommentMutation = (
  { __typename?: 'Mutation' }
  & { updateDocumentComment: (
    { __typename?: 'DocumentComment' }
    & Pick<DocumentComment, 'id' | 'content' | 'createdAt' | 'updatedAt'>
    & { author: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ) }
  ) }
);

export type UpdateEventMutationVariables = Exact<{
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  coverMediaKey?: Maybe<Scalars['String']>;
  specialistId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  durationMinutes?: Maybe<Scalars['Int']>;
  maxParticipantsNumber?: Maybe<Scalars['Int']>;
}>;


export type UpdateEventMutation = (
  { __typename?: 'Mutation' }
  & { updateEvent: (
    { __typename?: 'Event' }
    & Pick<Event, 'id' | 'title' | 'description' | 'roomName' | 'startDate' | 'endDate' | 'durationMinutes' | 'participationStatus' | 'createdAt' | 'updatedAt'>
    & { cover?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'id' | 'url' | 'createdAt' | 'contentType'>
    )>, specialist: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), creator: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), participants: (
      { __typename?: 'EventParticipants' }
      & Pick<EventParticipants, 'maxNumber' | 'currentCount'>
      & { list: Array<Maybe<(
        { __typename?: 'Account' }
        & ShortAccountDataFragment
      )>> }
    ) }
  ) }
);

export type UpdateFaqMutationVariables = Exact<{
  id: Scalars['Int'];
  title: MultiLanguageString;
  bodySq: Scalars['String'];
  bodyEn: Scalars['String'];
  bodyMk: Scalars['String'];
}>;


export type UpdateFaqMutation = (
  { __typename?: 'Mutation' }
  & { updateFaq?: Maybe<(
    { __typename?: 'Faq' }
    & Pick<Faq, 'id' | 'title' | 'body'>
    & { rawTitle: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ), rawBody: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ) }
  )> }
);

export type UpdateHealthCenterMutationVariables = Exact<{
  id: Scalars['Int'];
  name: MultiLanguageString;
  cityId: Scalars['Int'];
}>;


export type UpdateHealthCenterMutation = (
  { __typename?: 'Mutation' }
  & { updateHealthCenter?: Maybe<(
    { __typename?: 'HealthCenter' }
    & Pick<HealthCenter, 'id' | 'name'>
  )> }
);

export type UpdateInsurancePolicyMutationVariables = Exact<{
  id: Scalars['Int'];
  name: MultiLanguageString;
}>;


export type UpdateInsurancePolicyMutation = (
  { __typename?: 'Mutation' }
  & { updateInsurancePolicy?: Maybe<(
    { __typename?: 'InsurancePolicy' }
    & Pick<InsurancePolicy, 'id' | 'name'>
  )> }
);

export type UpdateMedicalCardCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  content: Scalars['String'];
}>;


export type UpdateMedicalCardCommentMutation = (
  { __typename?: 'Mutation' }
  & { updateMedicalCardComment: (
    { __typename?: 'MedicalCardComment' }
    & Pick<MedicalCardComment, 'id' | 'content' | 'createdAt' | 'updatedAt'>
    & { author: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ) }
  ) }
);

export type UpdateMedicalCardMutationVariables = Exact<{
  id: Scalars['Int'];
  symptoms?: Maybe<Scalars['String']>;
  diagnosis?: Maybe<Scalars['String']>;
  recommendation?: Maybe<Scalars['String']>;
  recipe?: Maybe<Scalars['String']>;
  privateNote?: Maybe<Scalars['String']>;
  medicalConcernCategoryId: Scalars['Int'];
}>;


export type UpdateMedicalCardMutation = (
  { __typename?: 'Mutation' }
  & { updateMedicalCard: (
    { __typename?: 'MedicalCard' }
    & Pick<MedicalCard, 'id' | 'symptoms' | 'diagnosis' | 'recommendation' | 'recipe' | 'privateNote' | 'createdAt' | 'updatedAt'>
    & { patient: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), doctor: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), concernCategory?: Maybe<(
      { __typename?: 'MedicalConcernCategory' }
      & Pick<MedicalConcernCategory, 'id' | 'name'>
    )>, documents: Array<Maybe<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'description'>
      & { author: (
        { __typename?: 'Account' }
        & ShortAccountDataFragment
      ), thumbnail: (
        { __typename?: 'Media' }
        & Pick<Media, 'id' | 'url' | 'createdAt' | 'contentType' | 'byteSize'>
      ), media: (
        { __typename?: 'Media' }
        & Pick<Media, 'url'>
      ), comments: Array<Maybe<(
        { __typename?: 'DocumentComment' }
        & Pick<DocumentComment, 'content' | 'createdAt' | 'updatedAt'>
        & { author: (
          { __typename?: 'Account' }
          & ShortAccountDataFragment
        ) }
      )>> }
    )>>, comments: Array<Maybe<(
      { __typename?: 'MedicalCardComment' }
      & Pick<MedicalCardComment, 'id' | 'content' | 'createdAt' | 'updatedAt'>
      & { author: (
        { __typename?: 'Account' }
        & ShortAccountDataFragment
      ) }
    )>> }
  ) }
);

export type UpdateMedicalConcernCategoryMutationVariables = Exact<{
  id: Scalars['Int'];
  name: MultiLanguageString;
}>;


export type UpdateMedicalConcernCategoryMutation = (
  { __typename?: 'Mutation' }
  & { updateMedicalConcernCategory?: Maybe<(
    { __typename?: 'MedicalConcernCategory' }
    & Pick<MedicalConcernCategory, 'id' | 'name'>
  )> }
);

export type UpdateSpecialistMutationVariables = Exact<{
  phoneNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['Date']>;
  sex?: Maybe<Gender>;
  licenceNumber?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  cityId?: Maybe<Scalars['Int']>;
  countryId?: Maybe<Scalars['Int']>;
  healthCenterId?: Maybe<Scalars['Int']>;
  specialityId?: Maybe<Scalars['Int']>;
}>;


export type UpdateSpecialistMutation = (
  { __typename?: 'Mutation' }
  & { updateSpecialist: (
    { __typename?: 'Account' }
    & Pick<Account, 'id'>
  ) }
);

export type UpdateSpecialityMutationVariables = Exact<{
  id: Scalars['Int'];
  name: MultiLanguageString;
}>;


export type UpdateSpecialityMutation = (
  { __typename?: 'Mutation' }
  & { updateSpeciality?: Maybe<(
    { __typename?: 'Speciality' }
    & Pick<Speciality, 'id' | 'name'>
  )> }
);

export type UpdateStoryItemMutationVariables = Exact<{
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  mediaKey: Scalars['String'];
  linkURL?: Maybe<Scalars['String']>;
  linkLabel?: Maybe<Scalars['String']>;
  bgColor: Scalars['String'];
  storyId: Scalars['Int'];
  language: LanguageCode;
}>;


export type UpdateStoryItemMutation = (
  { __typename?: 'Mutation' }
  & { updateStoryItem?: Maybe<(
    { __typename?: 'StoryItem' }
    & Pick<StoryItem, 'id'>
  )> }
);

export type UpdateStoryMutationVariables = Exact<{
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  mediaKey: Scalars['String'];
  title: MultiLanguageString;
}>;


export type UpdateStoryMutation = (
  { __typename?: 'Mutation' }
  & { updateStory?: Maybe<(
    { __typename?: 'Story' }
    & Pick<Story, 'id' | 'order' | 'title' | 'createdAt' | 'updatedAt'>
    & { author: (
      { __typename?: 'Account' }
      & ShortAccountDataFragmentFragment
    ), icon?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'url'>
    )>, rawTitle: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ), items: Array<Maybe<(
      { __typename?: 'StoryItem' }
      & Pick<StoryItem, 'id' | 'isActive'>
    )>> }
  )> }
);

export type UpdateSystemUserMutationVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
}>;


export type UpdateSystemUserMutation = (
  { __typename?: 'Mutation' }
  & { updateSystemUser: (
    { __typename?: 'Account' }
    & Pick<Account, 'id'>
  ) }
);

export type UpdateTierMutationVariables = Exact<{
  id: Scalars['Int'];
  nameSq: Scalars['String'];
  nameEn: Scalars['String'];
  nameMk: Scalars['String'];
  descriptionSq: Scalars['String'];
  descriptionEn: Scalars['String'];
  descriptionMk: Scalars['String'];
  color: Scalars['String'];
  activeDays: Scalars['Int'];
  eventsPerMonth: Scalars['Int'];
  pricePerYear: Scalars['Int'];
  default: Scalars['Boolean'];
  demo: Scalars['Boolean'];
  benefitIDs: Array<Scalars['Int']>;
  sigalHealthInsuranceType?: Maybe<HealthInsuranceCardType>;
}>;


export type UpdateTierMutation = (
  { __typename?: 'Mutation' }
  & { updateTier?: Maybe<(
    { __typename?: 'Tier' }
    & Pick<Tier, 'id' | 'name' | 'description' | 'color' | 'activeDays' | 'eventsPerMonth' | 'pricePerYear' | 'isPublic' | 'isDefaultForSigalClients' | 'isDefaultForDemo' | 'sigalHealthInsuranceType'>
  )> }
);

export type VerifyAccountUsingVerificationCodeMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type VerifyAccountUsingVerificationCodeMutation = (
  { __typename?: 'Mutation' }
  & { verifyAccountUsingVerificationCode?: Maybe<(
    { __typename?: 'MessageResponse' }
    & Pick<MessageResponse, 'message'>
  )> }
);

export type AccountSubscriptionQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AccountSubscriptionQuery = (
  { __typename?: 'Query' }
  & { subscription?: Maybe<(
    { __typename?: 'AccountSubscription' }
    & Pick<AccountSubscription, 'id' | 'startDate' | 'expirationDate' | 'isActive'>
    & { account: (
      { __typename?: 'Account' }
      & Pick<Account, 'id' | 'email' | 'profileImage' | 'role'>
      & { profile?: Maybe<(
        { __typename?: 'ClientProfile' }
        & Pick<ClientProfile, 'name' | 'lastname'>
      ) | { __typename?: 'DoctorProfile' } | { __typename?: 'SystemUserProfile' }> }
    ), tier: (
      { __typename?: 'Tier' }
      & Pick<Tier, 'id' | 'name' | 'description' | 'color' | 'pricePerYear'>
    ), authorization: (
      { __typename: 'InsurancePolicyHolderSubscriptionAuthorization' }
      & Pick<InsurancePolicyHolderSubscriptionAuthorization, 'type' | 'insurancePolicySerialNumber' | 'status' | 'insuranceUsageType' | 'insuranceCodeType' | 'createdAt'>
      & { insurancePolicy: (
        { __typename?: 'InsurancePolicy' }
        & Pick<InsurancePolicy, 'name'>
      ), tier: (
        { __typename?: 'Tier' }
        & Pick<Tier, 'name'>
      ) }
    ) | (
      { __typename: 'TierCardHolderSubscriptionAuthorization' }
      & Pick<TierCardHolderSubscriptionAuthorization, 'type' | 'createdAt'>
      & { payment: (
        { __typename?: 'Payment' }
        & Pick<Payment, 'amount'>
      ), tier: (
        { __typename?: 'Tier' }
        & Pick<Tier, 'name'>
      ), tierCode?: Maybe<(
        { __typename?: 'TierCode' }
        & Pick<TierCode, 'code' | 'id' | 'type' | 'status' | 'claimDate' | 'issueDate'>
      )> }
    ) }
  )> }
);

export type AccountSubscriptionsQueryVariables = Exact<{
  range?: Maybe<DateRange>;
  endRange?: Maybe<DateRange>;
  tierId?: Maybe<Scalars['Int']>;
  page: Scalars['Int'];
  pageLimit: Scalars['Int'];
}>;


export type AccountSubscriptionsQuery = (
  { __typename?: 'Query' }
  & { subscriptions: (
    { __typename?: 'PaginatedAccountSubscription' }
    & Pick<PaginatedAccountSubscription, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'nextPage'>
    ), nodes: Array<Maybe<(
      { __typename?: 'AccountSubscription' }
      & Pick<AccountSubscription, 'id' | 'startDate' | 'expirationDate' | 'isActive'>
      & { account: (
        { __typename?: 'Account' }
        & Pick<Account, 'id' | 'email' | 'profileImage' | 'role'>
        & { profile?: Maybe<(
          { __typename?: 'ClientProfile' }
          & Pick<ClientProfile, 'name' | 'lastname'>
        ) | { __typename?: 'DoctorProfile' } | { __typename?: 'SystemUserProfile' }> }
      ), tier: (
        { __typename?: 'Tier' }
        & Pick<Tier, 'id' | 'name' | 'description' | 'color' | 'pricePerYear'>
      ), authorization: (
        { __typename: 'InsurancePolicyHolderSubscriptionAuthorization' }
        & Pick<InsurancePolicyHolderSubscriptionAuthorization, 'type' | 'insurancePolicySerialNumber' | 'status' | 'insuranceUsageType' | 'insuranceCodeType' | 'createdAt'>
        & { insurancePolicy: (
          { __typename?: 'InsurancePolicy' }
          & Pick<InsurancePolicy, 'name'>
        ), tier: (
          { __typename?: 'Tier' }
          & Pick<Tier, 'name'>
        ) }
      ) | (
        { __typename: 'TierCardHolderSubscriptionAuthorization' }
        & Pick<TierCardHolderSubscriptionAuthorization, 'type' | 'createdAt'>
        & { payment: (
          { __typename?: 'Payment' }
          & Pick<Payment, 'amount'>
        ), tier: (
          { __typename?: 'Tier' }
          & Pick<Tier, 'name'>
        ), tierCode?: Maybe<(
          { __typename?: 'TierCode' }
          & Pick<TierCode, 'code' | 'id' | 'type' | 'status' | 'claimDate' | 'issueDate'>
        )> }
      ) }
    )>> }
  ) }
);

export type AccountQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AccountQuery = (
  { __typename?: 'Query' }
  & { account?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'id' | 'email' | 'accountStatus' | 'subscriptionStatus' | 'role' | 'createdAt' | 'phoneNumber' | 'profileImage'>
    & { language: (
      { __typename?: 'Language' }
      & Pick<Language, 'code' | 'name'>
    ), profile?: Maybe<(
      { __typename: 'ClientProfile' }
      & Pick<ClientProfile, 'id' | 'type' | 'name' | 'lastname' | 'birthday' | 'sex'>
      & { subscription?: Maybe<(
        { __typename?: 'AccountSubscription' }
        & Pick<AccountSubscription, 'id' | 'startDate' | 'expirationDate' | 'isActive' | 'remainingDays'>
        & { tier: (
          { __typename?: 'Tier' }
          & Pick<Tier, 'id' | 'tierId' | 'name' | 'description' | 'color' | 'activeDays' | 'eventsPerMonth'>
        ) }
      )> }
    ) | (
      { __typename: 'DoctorProfile' }
      & Pick<DoctorProfile, 'id' | 'type' | 'name' | 'lastname' | 'birthday' | 'licenceNumber' | 'sex' | 'bio'>
      & { country: (
        { __typename?: 'Country' }
        & Pick<Country, 'id' | 'name'>
      ), city: (
        { __typename?: 'City' }
        & Pick<City, 'id' | 'name'>
      ), healthCenter: (
        { __typename?: 'HealthCenter' }
        & Pick<HealthCenter, 'id' | 'name'>
      ), speciality?: Maybe<(
        { __typename?: 'Speciality' }
        & Pick<Speciality, 'id' | 'name'>
      )>, timetable?: Maybe<Array<Maybe<(
        { __typename?: 'DoctorTimeTable' }
        & Pick<DoctorTimeTable, 'dayOfWeek' | 'startHour' | 'startMinute' | 'endHour' | 'endMinute'>
      )>>> }
    ) | (
      { __typename: 'SystemUserProfile' }
      & Pick<SystemUserProfile, 'id' | 'type' | 'name' | 'lastname'>
    )> }
  )> }
);

export type AccountsQueryVariables = Exact<{
  role: AccountRole;
  accountStatus?: Maybe<AccountStatus>;
  search?: Maybe<Scalars['String']>;
  page: Scalars['Int'];
  pageLimit: Scalars['Int'];
}>;


export type AccountsQuery = (
  { __typename?: 'Query' }
  & { accounts: (
    { __typename?: 'PaginatedAccount' }
    & Pick<PaginatedAccount, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'nextPage'>
    ), nodes: Array<Maybe<(
      { __typename?: 'Account' }
      & Pick<Account, 'id' | 'email' | 'accountStatus' | 'subscriptionStatus' | 'role' | 'createdAt' | 'phoneNumber' | 'profileImage'>
      & { language: (
        { __typename?: 'Language' }
        & Pick<Language, 'code' | 'name'>
      ), profile?: Maybe<(
        { __typename: 'ClientProfile' }
        & Pick<ClientProfile, 'id' | 'type' | 'name' | 'lastname' | 'birthday' | 'sex'>
        & { subscription?: Maybe<(
          { __typename?: 'AccountSubscription' }
          & Pick<AccountSubscription, 'id' | 'startDate' | 'expirationDate' | 'remainingDays'>
          & { tier: (
            { __typename?: 'Tier' }
            & Pick<Tier, 'id' | 'name' | 'description' | 'color'>
          ) }
        )> }
      ) | (
        { __typename: 'DoctorProfile' }
        & Pick<DoctorProfile, 'id' | 'type' | 'name' | 'lastname' | 'birthday' | 'licenceNumber' | 'sex' | 'bio'>
        & { country: (
          { __typename?: 'Country' }
          & Pick<Country, 'id' | 'name'>
        ), city: (
          { __typename?: 'City' }
          & Pick<City, 'id' | 'name'>
        ), healthCenter: (
          { __typename?: 'HealthCenter' }
          & Pick<HealthCenter, 'id' | 'name'>
        ), speciality?: Maybe<(
          { __typename?: 'Speciality' }
          & Pick<Speciality, 'id' | 'name'>
        )> }
      ) | (
        { __typename: 'SystemUserProfile' }
        & Pick<SystemUserProfile, 'id' | 'type' | 'name' | 'lastname'>
      )> }
    )>> }
  ) }
);

export type AdvertisementsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdvertisementsQuery = (
  { __typename?: 'Query' }
  & { advertisements: Array<Maybe<(
    { __typename?: 'Advertisement' }
    & Pick<Advertisement, 'id' | 'position' | 'isActive' | 'clickUrl' | 'createdAt'>
    & { media?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'url'>
    )>, author: (
      { __typename?: 'Account' }
      & Pick<Account, 'id' | 'email' | 'profileImage' | 'role'>
      & { profile?: Maybe<{ __typename?: 'ClientProfile' } | { __typename?: 'DoctorProfile' } | (
        { __typename?: 'SystemUserProfile' }
        & Pick<SystemUserProfile, 'name' | 'lastname'>
      )> }
    ) }
  )>> }
);

export type ArticleQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ArticleQuery = (
  { __typename?: 'Query' }
  & { article?: Maybe<(
    { __typename?: 'Article' }
    & Pick<Article, 'id' | 'title' | 'body' | 'excerpt' | 'createdAt'>
    & { language: (
      { __typename?: 'Language' }
      & Pick<Language, 'code' | 'name'>
    ), cover?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'url' | 'key'>
    )>, author: (
      { __typename?: 'Account' }
      & Pick<Account, 'id' | 'email' | 'profileImage' | 'role'>
      & { profile?: Maybe<{ __typename?: 'ClientProfile' } | { __typename?: 'DoctorProfile' } | (
        { __typename?: 'SystemUserProfile' }
        & Pick<SystemUserProfile, 'name' | 'lastname'>
      )> }
    ) }
  )> }
);

export type ArticlesQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  pageLimit?: Maybe<Scalars['Int']>;
}>;


export type ArticlesQuery = (
  { __typename?: 'Query' }
  & { articles: (
    { __typename?: 'PaginatedArticle' }
    & Pick<PaginatedArticle, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'nextPage'>
    ), nodes: Array<Maybe<(
      { __typename?: 'Article' }
      & Pick<Article, 'id' | 'title' | 'body' | 'excerpt' | 'createdAt'>
      & { language: (
        { __typename?: 'Language' }
        & Pick<Language, 'code' | 'name'>
      ), cover?: Maybe<(
        { __typename?: 'Media' }
        & Pick<Media, 'url' | 'key'>
      )>, author: (
        { __typename?: 'Account' }
        & Pick<Account, 'id' | 'email' | 'profileImage' | 'role'>
        & { profile?: Maybe<{ __typename?: 'ClientProfile' } | { __typename?: 'DoctorProfile' } | (
          { __typename?: 'SystemUserProfile' }
          & Pick<SystemUserProfile, 'name' | 'lastname'>
        )> }
      ) }
    )>> }
  ) }
);

export type BenefitQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type BenefitQuery = (
  { __typename?: 'Query' }
  & { benefit?: Maybe<(
    { __typename?: 'Benefit' }
    & Pick<Benefit, 'id' | 'title' | 'description' | 'externalUrlLabel' | 'externalURL' | 'createdAt' | 'updatedAt'>
    & { image?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'id' | 'url' | 'key' | 'createdAt' | 'contentType' | 'byteSize'>
    )>, rawTitle: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ), rawDescription: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ), rawExternalUrlLabel?: Maybe<(
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    )>, tiers: Array<Maybe<(
      { __typename?: 'Tier' }
      & Pick<Tier, 'id' | 'name'>
    )>> }
  )> }
);

export type BenefitsQueryVariables = Exact<{ [key: string]: never; }>;


export type BenefitsQuery = (
  { __typename?: 'Query' }
  & { benefits: Array<Maybe<(
    { __typename?: 'Benefit' }
    & Pick<Benefit, 'id' | 'title' | 'description' | 'externalUrlLabel' | 'externalURL' | 'createdAt' | 'updatedAt'>
    & { image?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'id' | 'url' | 'key' | 'createdAt' | 'contentType' | 'byteSize'>
    )>, rawTitle: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ), rawDescription: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ), rawExternalUrlLabel?: Maybe<(
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    )>, tiers: Array<Maybe<(
      { __typename?: 'Tier' }
      & Pick<Tier, 'id' | 'name'>
    )>> }
  )>> }
);

export type CallQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CallQuery = (
  { __typename?: 'Query' }
  & { call: (
    { __typename?: 'Call' }
    & Pick<Call, 'id' | 'status' | 'room' | 'requestTime' | 'startTime' | 'endTime' | 'duration' | 'recordings'>
    & { review?: Maybe<(
      { __typename?: 'CallReview' }
      & Pick<CallReview, 'rating' | 'description'>
    )>, participants: Array<(
      { __typename?: 'Participant' }
      & Pick<Participant, 'twilioToken' | 'id' | 'role' | 'status' | 'joinTime'>
      & { account: (
        { __typename?: 'Account' }
        & Pick<Account, 'id' | 'email' | 'accountStatus' | 'subscriptionStatus' | 'role' | 'createdAt' | 'phoneNumber' | 'profileImage'>
        & { profile?: Maybe<(
          { __typename: 'ClientProfile' }
          & Pick<ClientProfile, 'id' | 'type' | 'name' | 'lastname' | 'birthday' | 'sex'>
        ) | (
          { __typename: 'DoctorProfile' }
          & Pick<DoctorProfile, 'id' | 'type' | 'name' | 'lastname' | 'birthday' | 'licenceNumber' | 'sex' | 'bio'>
        ) | (
          { __typename: 'SystemUserProfile' }
          & Pick<SystemUserProfile, 'id' | 'type' | 'name' | 'lastname'>
        )> }
      ) }
    )> }
  ) }
);

export type CallsByDoctorStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type CallsByDoctorStatsQuery = (
  { __typename?: 'Query' }
  & { callsByDoctorStats: (
    { __typename?: 'CallStatsReport' }
    & { callsByDoctor: Array<Maybe<(
      { __typename?: 'DoctorCallsReportItem' }
      & Pick<DoctorCallsReportItem, 'doctorName'>
      & { info: (
        { __typename?: 'CallsReportItem' }
        & Pick<CallsReportItem, 'callsSuccess' | 'callsExpired' | 'callsClosed' | 'callsMinutes'>
      ) }
    )>>, totalCalls: (
      { __typename?: 'CallsReportItem' }
      & Pick<CallsReportItem, 'callsSuccess' | 'callsExpired' | 'callsClosed' | 'callsMinutes'>
    ) }
  ) }
);

export type CallsReportQueryVariables = Exact<{
  range: DateRange;
}>;


export type CallsReportQuery = (
  { __typename?: 'Query' }
  & { callsReport: Array<Maybe<(
    { __typename?: 'ReportItem' }
    & Pick<ReportItem, 'month' | 'year' | 'day' | 'date' | 'value'>
  )>> }
);

export type CallsQueryVariables = Exact<{
  where?: Maybe<CallsWhereInput>;
  page: Scalars['Int'];
  pageLimit: Scalars['Int'];
}>;


export type CallsQuery = (
  { __typename?: 'Query' }
  & { calls: (
    { __typename?: 'PaginatedCall' }
    & Pick<PaginatedCall, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'nextPage'>
    ), nodes: Array<Maybe<(
      { __typename?: 'Call' }
      & Pick<Call, 'id' | 'status' | 'room' | 'requestTime' | 'startTime' | 'endTime' | 'duration'>
      & { participants: Array<(
        { __typename?: 'Participant' }
        & Pick<Participant, 'twilioToken' | 'id' | 'role' | 'status' | 'joinTime'>
        & { account: (
          { __typename?: 'Account' }
          & Pick<Account, 'id' | 'email' | 'accountStatus' | 'subscriptionStatus' | 'role' | 'createdAt' | 'phoneNumber' | 'profileImage'>
          & { profile?: Maybe<(
            { __typename: 'ClientProfile' }
            & Pick<ClientProfile, 'id' | 'type' | 'name' | 'lastname' | 'birthday' | 'sex'>
          ) | (
            { __typename: 'DoctorProfile' }
            & Pick<DoctorProfile, 'id' | 'type' | 'name' | 'lastname' | 'birthday' | 'licenceNumber' | 'sex' | 'bio'>
          ) | (
            { __typename: 'SystemUserProfile' }
            & Pick<SystemUserProfile, 'id' | 'type' | 'name' | 'lastname'>
          )> }
        ) }
      )> }
    )>> }
  ) }
);

export type Calls2CsvMutationVariables = Exact<{
  where?: Maybe<CallsWhereInput>;
  page: Scalars['Int'];
  pageLimit: Scalars['Int'];
}>;


export type Calls2CsvMutation = (
  { __typename?: 'Mutation' }
  & { calls2csv: (
    { __typename?: 'CallCSV' }
    & Pick<CallCsv, 'url'>
  ) }
);

export type CitiesQueryVariables = Exact<{
  countryId?: Maybe<Scalars['Int']>;
}>;


export type CitiesQuery = (
  { __typename?: 'Query' }
  & { cities: Array<Maybe<(
    { __typename?: 'City' }
    & Pick<City, 'id' | 'name'>
    & { rawName: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'mk' | 'en'>
    ), country: (
      { __typename?: 'Country' }
      & Pick<Country, 'id' | 'name'>
    ) }
  )>> }
);

export type CodeStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type CodeStatsQuery = (
  { __typename?: 'Query' }
  & { codeStats: Array<Maybe<(
    { __typename?: 'CodeStatsResponse' }
    & Pick<CodeStatsResponse, 'totalCount' | 'usedCount' | 'unusedCount'>
    & { tier: (
      { __typename?: 'Tier' }
      & Pick<Tier, 'id' | 'name' | 'pricePerYear' | 'isPublic'>
    ) }
  )>> }
);

export type CodeQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type CodeQuery = (
  { __typename?: 'Query' }
  & { code?: Maybe<(
    { __typename?: 'TierCode' }
    & Pick<TierCode, 'id' | 'code' | 'type' | 'status' | 'issueDate' | 'claimDate'>
    & { tier: (
      { __typename?: 'Tier' }
      & Pick<Tier, 'name'>
    ), client?: Maybe<(
      { __typename?: 'Account' }
      & Pick<Account, 'id' | 'email' | 'accountStatus' | 'subscriptionStatus' | 'role' | 'createdAt' | 'phoneNumber' | 'profileImage'>
      & { language: (
        { __typename?: 'Language' }
        & Pick<Language, 'code' | 'name'>
      ), profile?: Maybe<(
        { __typename: 'ClientProfile' }
        & Pick<ClientProfile, 'id' | 'type' | 'name' | 'lastname' | 'birthday' | 'sex'>
        & { subscription?: Maybe<(
          { __typename?: 'AccountSubscription' }
          & Pick<AccountSubscription, 'id' | 'startDate' | 'expirationDate' | 'isActive' | 'remainingDays'>
          & { tier: (
            { __typename?: 'Tier' }
            & Pick<Tier, 'id' | 'tierId' | 'name' | 'description' | 'color' | 'activeDays' | 'eventsPerMonth'>
          ) }
        )> }
      ) | { __typename: 'DoctorProfile' } | { __typename: 'SystemUserProfile' }> }
    )> }
  )> }
);

export type Codes2csvMutationVariables = Exact<{ [key: string]: never; }>;


export type Codes2csvMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'codes2csv'>
);

export type ConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfigQuery = (
  { __typename?: 'Query' }
  & { config: (
    { __typename?: 'Config' }
    & Pick<Config, 'policy' | 'terms'>
  ) }
);

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = (
  { __typename?: 'Query' }
  & { countries: Array<Maybe<(
    { __typename?: 'Country' }
    & Pick<Country, 'id' | 'name'>
    & { rawName: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'mk' | 'en'>
    ) }
  )>> }
);

export type DoctorRequestQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DoctorRequestQuery = (
  { __typename?: 'Query' }
  & { doctorRequest: (
    { __typename?: 'DoctorAccountRequest' }
    & Pick<DoctorAccountRequest, 'id' | 'name' | 'lastname' | 'email' | 'birthday' | 'createdAt' | 'phoneNumber' | 'licenceNumber' | 'cvUrl' | 'sex'>
    & { language: (
      { __typename?: 'Language' }
      & Pick<Language, 'code' | 'name'>
    ), country: (
      { __typename?: 'Country' }
      & Pick<Country, 'id' | 'name'>
    ), city: (
      { __typename?: 'City' }
      & Pick<City, 'id' | 'name'>
    ), healthCenter: (
      { __typename?: 'HealthCenter' }
      & Pick<HealthCenter, 'id' | 'name'>
    ) }
  ) }
);

export type AllDoctorRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDoctorRequestsQuery = (
  { __typename?: 'Query' }
  & { doctorRequests: Array<Maybe<(
    { __typename?: 'DoctorAccountRequest' }
    & Pick<DoctorAccountRequest, 'id' | 'name' | 'lastname' | 'email' | 'birthday' | 'createdAt' | 'phoneNumber' | 'licenceNumber' | 'cvUrl' | 'sex'>
    & { language: (
      { __typename?: 'Language' }
      & Pick<Language, 'code' | 'name'>
    ), country: (
      { __typename?: 'Country' }
      & Pick<Country, 'id' | 'name'>
    ), city: (
      { __typename?: 'City' }
      & Pick<City, 'id' | 'name'>
    ), healthCenter: (
      { __typename?: 'HealthCenter' }
      & Pick<HealthCenter, 'id' | 'name'>
    ) }
  )>> }
);

export type FaqQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FaqQuery = (
  { __typename?: 'Query' }
  & { frequentlyAskedQuestion?: Maybe<(
    { __typename?: 'Faq' }
    & Pick<Faq, 'id' | 'title' | 'body'>
    & { rawTitle: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ), rawBody: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ) }
  )> }
);

export type FaqsQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
}>;


export type FaqsQuery = (
  { __typename?: 'Query' }
  & { frequentlyAskedQuestions?: Maybe<Array<Maybe<(
    { __typename?: 'Faq' }
    & Pick<Faq, 'id' | 'title' | 'body'>
    & { rawTitle: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ), rawBody: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ) }
  )>>> }
);

export type GetEventQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetEventQuery = (
  { __typename?: 'Query' }
  & { getEvent: (
    { __typename?: 'Event' }
    & Pick<Event, 'id' | 'title' | 'description' | 'roomName' | 'startDate' | 'endDate' | 'durationMinutes' | 'participationStatus' | 'createdAt' | 'updatedAt'>
    & { cover?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'id' | 'url' | 'createdAt' | 'contentType'>
    )>, specialist: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), creator: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), participants: (
      { __typename?: 'EventParticipants' }
      & Pick<EventParticipants, 'maxNumber' | 'currentCount'>
      & { list: Array<Maybe<(
        { __typename?: 'Account' }
        & ShortAccountDataFragment
      )>> }
    ) }
  ) }
);

export type GetEventsNotUserScopedQueryVariables = Exact<{
  epoch?: Maybe<Event_Epoch>;
}>;


export type GetEventsNotUserScopedQuery = (
  { __typename?: 'Query' }
  & { getEventsNotUserScoped: Array<Maybe<(
    { __typename?: 'Event' }
    & Pick<Event, 'id' | 'title' | 'description' | 'roomName' | 'startDate' | 'endDate' | 'durationMinutes' | 'participationStatus' | 'createdAt' | 'updatedAt'>
    & { cover?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'id' | 'url' | 'createdAt' | 'contentType'>
    )>, specialist: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), creator: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), participants: (
      { __typename?: 'EventParticipants' }
      & Pick<EventParticipants, 'maxNumber' | 'currentCount'>
      & { list: Array<Maybe<(
        { __typename?: 'Account' }
        & ShortAccountDataFragment
      )>> }
    ) }
  )>> }
);

export type GetEventsQueryVariables = Exact<{
  epoch?: Maybe<Event_Epoch>;
}>;


export type GetEventsQuery = (
  { __typename?: 'Query' }
  & { getEvents: Array<Maybe<(
    { __typename?: 'Event' }
    & Pick<Event, 'id' | 'title' | 'description' | 'roomName' | 'startDate' | 'endDate' | 'durationMinutes' | 'participationStatus' | 'createdAt' | 'updatedAt'>
    & { cover?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'id' | 'url' | 'createdAt' | 'contentType'>
    )>, specialist: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), creator: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), participants: (
      { __typename?: 'EventParticipants' }
      & Pick<EventParticipants, 'maxNumber' | 'currentCount'>
      & { list: Array<Maybe<(
        { __typename?: 'Account' }
        & ShortAccountDataFragment
      )>> }
    ) }
  )>> }
);

export type GetHostedEventsQueryVariables = Exact<{
  epoch?: Maybe<Event_Epoch>;
}>;


export type GetHostedEventsQuery = (
  { __typename?: 'Query' }
  & { getEvents: Array<Maybe<(
    { __typename?: 'Event' }
    & Pick<Event, 'id' | 'title' | 'description' | 'roomName' | 'startDate' | 'endDate' | 'durationMinutes' | 'participationStatus' | 'createdAt' | 'updatedAt'>
    & { cover?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'id' | 'url' | 'createdAt' | 'contentType'>
    )>, specialist: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), creator: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), participants: (
      { __typename?: 'EventParticipants' }
      & Pick<EventParticipants, 'maxNumber' | 'currentCount'>
      & { list: Array<Maybe<(
        { __typename?: 'Account' }
        & ShortAccountDataFragment
      )>> }
    ) }
  )>> }
);

export type GetMedicalCardDocumentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetMedicalCardDocumentQuery = (
  { __typename?: 'Query' }
  & { getMedicalCardDocument: (
    { __typename?: 'Document' }
    & Pick<Document, 'id' | 'createdAt' | 'updatedAt' | 'description'>
    & { author: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), medicalCard: (
      { __typename?: 'MedicalCard' }
      & { patient: (
        { __typename?: 'Account' }
        & ShortAccountDataFragment
      ) }
    ), thumbnail: (
      { __typename?: 'Media' }
      & Pick<Media, 'id' | 'url' | 'createdAt' | 'contentType' | 'byteSize'>
    ), media: (
      { __typename?: 'Media' }
      & Pick<Media, 'contentType' | 'url'>
    ), comments: Array<Maybe<(
      { __typename?: 'DocumentComment' }
      & Pick<DocumentComment, 'id' | 'content' | 'createdAt' | 'updatedAt'>
      & { author: (
        { __typename?: 'Account' }
        & ShortAccountDataFragment
      ) }
    )>> }
  ) }
);

export type GetMedicalCardQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetMedicalCardQuery = (
  { __typename?: 'Query' }
  & { getMedicalCard?: Maybe<(
    { __typename?: 'MedicalCard' }
    & Pick<MedicalCard, 'id' | 'symptoms' | 'diagnosis' | 'recommendation' | 'recipe' | 'privateNote' | 'createdAt' | 'updatedAt'>
    & { patient: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), doctor: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), concernCategory?: Maybe<(
      { __typename?: 'MedicalConcernCategory' }
      & Pick<MedicalConcernCategory, 'id' | 'name'>
    )>, documents: Array<Maybe<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'description'>
      & { author: (
        { __typename?: 'Account' }
        & ShortAccountDataFragment
      ), thumbnail: (
        { __typename?: 'Media' }
        & Pick<Media, 'id' | 'url' | 'createdAt' | 'contentType' | 'byteSize'>
      ), media: (
        { __typename?: 'Media' }
        & Pick<Media, 'url'>
      ), comments: Array<Maybe<(
        { __typename?: 'DocumentComment' }
        & Pick<DocumentComment, 'content' | 'createdAt' | 'updatedAt'>
        & { author: (
          { __typename?: 'Account' }
          & ShortAccountDataFragment
        ) }
      )>> }
    )>>, comments: Array<Maybe<(
      { __typename?: 'MedicalCardComment' }
      & Pick<MedicalCardComment, 'id' | 'content' | 'createdAt' | 'updatedAt'>
      & { author: (
        { __typename?: 'Account' }
        & ShortAccountDataFragment
      ) }
    )>> }
  )> }
);

export type GetMedicalCardsQueryVariables = Exact<{
  patientId: Scalars['Int'];
}>;


export type GetMedicalCardsQuery = (
  { __typename?: 'Query' }
  & { getMedicalCards: Array<Maybe<(
    { __typename?: 'MedicalCard' }
    & Pick<MedicalCard, 'id' | 'symptoms' | 'diagnosis' | 'recommendation' | 'recipe' | 'privateNote' | 'createdAt' | 'updatedAt'>
    & { patient: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), doctor: (
      { __typename?: 'Account' }
      & ShortAccountDataFragment
    ), documents: Array<Maybe<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'description'>
      & { author: (
        { __typename?: 'Account' }
        & ShortAccountDataFragment
      ), thumbnail: (
        { __typename?: 'Media' }
        & Pick<Media, 'id' | 'url' | 'createdAt' | 'contentType' | 'byteSize'>
      ), media: (
        { __typename?: 'Media' }
        & Pick<Media, 'url'>
      ), comments: Array<Maybe<(
        { __typename?: 'DocumentComment' }
        & Pick<DocumentComment, 'content' | 'createdAt' | 'updatedAt'>
        & { author: (
          { __typename?: 'Account' }
          & ShortAccountDataFragment
        ) }
      )>> }
    )>>, comments: Array<Maybe<(
      { __typename?: 'MedicalCardComment' }
      & Pick<MedicalCardComment, 'id' | 'content' | 'createdAt' | 'updatedAt'>
      & { author: (
        { __typename?: 'Account' }
        & ShortAccountDataFragment
      ) }
    )>> }
  )>> }
);

export type GetPresignedPublicS3UrlQueryVariables = Exact<{
  fileName: Scalars['String'];
}>;


export type GetPresignedPublicS3UrlQuery = (
  { __typename?: 'Query' }
  & { getPresignedPublicS3Url?: Maybe<(
    { __typename?: 'PresignedUrlResponse' }
    & Pick<PresignedUrlResponse, 'key' | 'url' | 'expiry' | 'contentType'>
  )> }
);

export type GetPresignedS3UrlQueryVariables = Exact<{
  fileName: Scalars['String'];
}>;


export type GetPresignedS3UrlQuery = (
  { __typename?: 'Query' }
  & { getPresignedS3Url?: Maybe<(
    { __typename?: 'PresignedUrlResponse' }
    & Pick<PresignedUrlResponse, 'key' | 'url' | 'expiry' | 'contentType'>
  )> }
);

export type GetSubscriptionsThatNeedReviewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionsThatNeedReviewQuery = (
  { __typename?: 'Query' }
  & { getSubscriptionsThatNeedReview?: Maybe<(
    { __typename?: 'SubscriptionsThatNeedReviewResponse' }
    & Pick<SubscriptionsThatNeedReviewResponse, 'totalCount'>
    & { nodes: Array<Maybe<(
      { __typename?: 'AccountSubscription' }
      & Pick<AccountSubscription, 'id' | 'startDate' | 'expirationDate' | 'isActive'>
      & { account: (
        { __typename?: 'Account' }
        & Pick<Account, 'id' | 'email' | 'profileImage' | 'role'>
        & { profile?: Maybe<(
          { __typename?: 'ClientProfile' }
          & Pick<ClientProfile, 'name' | 'lastname'>
        ) | { __typename?: 'DoctorProfile' } | { __typename?: 'SystemUserProfile' }> }
      ), tier: (
        { __typename?: 'Tier' }
        & Pick<Tier, 'id' | 'name' | 'description' | 'color' | 'pricePerYear'>
      ), authorization: (
        { __typename: 'InsurancePolicyHolderSubscriptionAuthorization' }
        & Pick<InsurancePolicyHolderSubscriptionAuthorization, 'type' | 'insurancePolicySerialNumber' | 'status' | 'insuranceUsageType' | 'insuranceCodeType' | 'createdAt'>
        & { insurancePolicy: (
          { __typename?: 'InsurancePolicy' }
          & Pick<InsurancePolicy, 'name'>
        ), tier: (
          { __typename?: 'Tier' }
          & Pick<Tier, 'name'>
        ) }
      ) | (
        { __typename: 'TierCardHolderSubscriptionAuthorization' }
        & Pick<TierCardHolderSubscriptionAuthorization, 'type' | 'createdAt'>
        & { payment: (
          { __typename?: 'Payment' }
          & Pick<Payment, 'amount'>
        ), tier: (
          { __typename?: 'Tier' }
          & Pick<Tier, 'name'>
        ), tierCode?: Maybe<(
          { __typename?: 'TierCode' }
          & Pick<TierCode, 'code' | 'id' | 'type' | 'status' | 'claimDate' | 'issueDate'>
        )> }
      ) }
    )>> }
  )> }
);

export type HealthCentersQueryVariables = Exact<{
  cityId?: Maybe<Scalars['Int']>;
}>;


export type HealthCentersQuery = (
  { __typename?: 'Query' }
  & { healthCenters: Array<Maybe<(
    { __typename?: 'HealthCenter' }
    & Pick<HealthCenter, 'id' | 'name'>
    & { rawName: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'mk' | 'en'>
    ), city: (
      { __typename?: 'City' }
      & Pick<City, 'id' | 'name'>
    ) }
  )>> }
);

export type InsurancePoliciesQueryVariables = Exact<{ [key: string]: never; }>;


export type InsurancePoliciesQuery = (
  { __typename?: 'Query' }
  & { insurancePolicies: Array<Maybe<(
    { __typename?: 'InsurancePolicy' }
    & Pick<InsurancePolicy, 'id' | 'name'>
    & { rawName: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'mk' | 'en'>
    ) }
  )>> }
);

export type LanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type LanguagesQuery = (
  { __typename?: 'Query' }
  & { languages: Array<Maybe<(
    { __typename?: 'Language' }
    & Pick<Language, 'code' | 'name'>
  )>> }
);

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'Account' }
    & Pick<Account, 'id' | 'email' | 'accountStatus' | 'subscriptionStatus' | 'role' | 'createdAt' | 'phoneNumber' | 'profileImage'>
    & { language: (
      { __typename?: 'Language' }
      & Pick<Language, 'code' | 'name'>
    ), profile?: Maybe<(
      { __typename: 'ClientProfile' }
      & Pick<ClientProfile, 'id' | 'type' | 'name' | 'lastname' | 'birthday' | 'sex'>
      & { subscription?: Maybe<(
        { __typename?: 'AccountSubscription' }
        & Pick<AccountSubscription, 'id' | 'startDate' | 'expirationDate' | 'isActive' | 'remainingDays'>
        & { tier: (
          { __typename?: 'Tier' }
          & Pick<Tier, 'id' | 'tierId' | 'name' | 'description' | 'color' | 'activeDays' | 'eventsPerMonth'>
        ) }
      )> }
    ) | (
      { __typename: 'DoctorProfile' }
      & Pick<DoctorProfile, 'id' | 'type' | 'name' | 'lastname' | 'birthday' | 'licenceNumber' | 'sex' | 'bio'>
      & { country: (
        { __typename?: 'Country' }
        & Pick<Country, 'id' | 'name'>
      ), city: (
        { __typename?: 'City' }
        & Pick<City, 'id' | 'name'>
      ), healthCenter: (
        { __typename?: 'HealthCenter' }
        & Pick<HealthCenter, 'id' | 'name'>
      ), speciality?: Maybe<(
        { __typename?: 'Speciality' }
        & Pick<Speciality, 'id' | 'name'>
      )> }
    ) | (
      { __typename: 'SystemUserProfile' }
      & Pick<SystemUserProfile, 'id' | 'type' | 'name' | 'lastname'>
    )> }
  ) }
);

export type MediaLibraryItemQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type MediaLibraryItemQuery = (
  { __typename?: 'Query' }
  & { mediaLibraryItem?: Maybe<(
    { __typename?: 'MediaLibrary' }
    & Pick<MediaLibrary, 'id' | 'title' | 'createdAt'>
    & { thumbnail: (
      { __typename?: 'Media' }
      & Pick<Media, 'url' | 'contentType'>
    ), medium: (
      { __typename?: 'Media' }
      & Pick<Media, 'url' | 'contentType'>
    ), large: (
      { __typename?: 'Media' }
      & Pick<Media, 'url' | 'contentType'>
    ) }
  )> }
);

export type MediaLibraryItemsQueryVariables = Exact<{
  search: Scalars['String'];
  page: Scalars['Int'];
  pageLimit: Scalars['Int'];
}>;


export type MediaLibraryItemsQuery = (
  { __typename?: 'Query' }
  & { mediaLibraryItems: (
    { __typename?: 'PaginatedMediaLibrary' }
    & Pick<PaginatedMediaLibrary, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'nextPage'>
    ), nodes: Array<Maybe<(
      { __typename?: 'MediaLibrary' }
      & Pick<MediaLibrary, 'id' | 'title' | 'createdAt'>
      & { thumbnail: (
        { __typename?: 'Media' }
        & Pick<Media, 'url' | 'contentType'>
      ), medium: (
        { __typename?: 'Media' }
        & Pick<Media, 'url' | 'contentType'>
      ), large: (
        { __typename?: 'Media' }
        & Pick<Media, 'url' | 'contentType'>
      ) }
    )>> }
  ) }
);

export type MedicalCardsByMedicalConcernReportQueryVariables = Exact<{
  range: DateRange;
}>;


export type MedicalCardsByMedicalConcernReportQuery = (
  { __typename?: 'Query' }
  & { medicalCardsByMedicalConcernReport: Array<Maybe<(
    { __typename?: 'SimpleReportItem' }
    & Pick<SimpleReportItem, 'name' | 'value'>
  )>> }
);

export type MedicalConcernCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type MedicalConcernCategoriesQuery = (
  { __typename?: 'Query' }
  & { medicalConcernCategories: Array<Maybe<(
    { __typename?: 'MedicalConcernCategory' }
    & Pick<MedicalConcernCategory, 'id' | 'name'>
    & { rawName: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'mk' | 'en'>
    ) }
  )>> }
);

export type MyCallsQueryVariables = Exact<{
  where?: Maybe<MyCallsWhereInput>;
  page?: Maybe<Scalars['Int']>;
  pageLimit?: Maybe<Scalars['Int']>;
}>;


export type MyCallsQuery = (
  { __typename?: 'Query' }
  & { myCalls: (
    { __typename?: 'PaginatedCall' }
    & Pick<PaginatedCall, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'nextPage'>
    ), nodes: Array<Maybe<(
      { __typename?: 'Call' }
      & Pick<Call, 'id' | 'status' | 'room' | 'requestTime' | 'startTime' | 'endTime' | 'duration'>
      & { participants: Array<(
        { __typename?: 'Participant' }
        & Pick<Participant, 'twilioToken' | 'id' | 'role' | 'status' | 'joinTime'>
        & { account: (
          { __typename?: 'Account' }
          & Pick<Account, 'id' | 'email' | 'accountStatus' | 'subscriptionStatus' | 'role' | 'createdAt'>
          & { language: (
            { __typename?: 'Language' }
            & Pick<Language, 'code' | 'name'>
          ), profile?: Maybe<(
            { __typename: 'ClientProfile' }
            & Pick<ClientProfile, 'id' | 'name' | 'lastname' | 'birthday' | 'sex'>
          ) | (
            { __typename: 'DoctorProfile' }
            & Pick<DoctorProfile, 'id' | 'name' | 'lastname' | 'birthday' | 'sex'>
          ) | (
            { __typename: 'SystemUserProfile' }
            & Pick<SystemUserProfile, 'id' | 'type'>
          )> }
        ) }
      )> }
    )>> }
  ) }
);

export type MyContactsQueryVariables = Exact<{
  contains?: Maybe<Scalars['String']>;
  callDate?: Maybe<FromToDate>;
  page: Scalars['Int'];
  pageLimit: Scalars['Int'];
}>;


export type MyContactsQuery = (
  { __typename?: 'Query' }
  & { myContacts?: Maybe<(
    { __typename?: 'PaginatedAccount' }
    & Pick<PaginatedAccount, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'nextPage'>
    ), nodes: Array<Maybe<(
      { __typename?: 'Account' }
      & Pick<Account, 'id' | 'email' | 'accountStatus' | 'subscriptionStatus' | 'role' | 'createdAt' | 'phoneNumber'>
      & { profile?: Maybe<(
        { __typename: 'ClientProfile' }
        & Pick<ClientProfile, 'id' | 'name' | 'lastname' | 'birthday' | 'sex'>
      ) | (
        { __typename: 'DoctorProfile' }
        & Pick<DoctorProfile, 'id' | 'name' | 'lastname' | 'birthday' | 'sex'>
      ) | (
        { __typename: 'SystemUserProfile' }
        & Pick<SystemUserProfile, 'id' | 'type' | 'name' | 'lastname'>
      )> }
    )>> }
  )> }
);

export type SpecialitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type SpecialitiesQuery = (
  { __typename?: 'Query' }
  & { specialities: Array<Maybe<(
    { __typename?: 'Speciality' }
    & Pick<Speciality, 'id' | 'name'>
    & { rawName: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'mk' | 'en'>
    ) }
  )>> }
);

export type StoriesQueryVariables = Exact<{
  iconWidth: Scalars['Int'];
}>;


export type StoriesQuery = (
  { __typename?: 'Query' }
  & { stories: Array<Maybe<(
    { __typename?: 'Story' }
    & Pick<Story, 'id' | 'title' | 'isActive' | 'order' | 'createdAt' | 'updatedAt'>
    & { author: (
      { __typename?: 'Account' }
      & ShortAccountDataFragmentFragment
    ), icon?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'contentType' | 'url' | 'key'>
    )>, items: Array<Maybe<(
      { __typename?: 'StoryItem' }
      & Pick<StoryItem, 'id' | 'type' | 'linkURL' | 'linkLabel' | 'bgColor' | 'createdAt' | 'updatedAt'>
      & { language: (
        { __typename?: 'Language' }
        & Pick<Language, 'code' | 'name'>
      ), media?: Maybe<(
        { __typename?: 'Media' }
        & Pick<Media, 'contentType' | 'url' | 'key'>
      )> }
    )>>, rawTitle: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ) }
  )>> }
);

export type StoryQueryVariables = Exact<{
  id: Scalars['Int'];
  iconWidth: Scalars['Int'];
}>;


export type StoryQuery = (
  { __typename?: 'Query' }
  & { story?: Maybe<(
    { __typename?: 'Story' }
    & Pick<Story, 'id' | 'title' | 'isActive' | 'order' | 'createdAt' | 'updatedAt'>
    & { author: (
      { __typename?: 'Account' }
      & ShortAccountDataFragmentFragment
    ), icon?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'contentType' | 'url' | 'key'>
    )>, items: Array<Maybe<(
      { __typename?: 'StoryItem' }
      & Pick<StoryItem, 'id' | 'type' | 'isActive' | 'linkURL' | 'linkLabel' | 'bgColor' | 'createdAt' | 'updatedAt'>
      & { author: (
        { __typename?: 'Account' }
        & ShortAccountDataFragmentFragment
      ), language: (
        { __typename?: 'Language' }
        & Pick<Language, 'code' | 'name'>
      ), media?: Maybe<(
        { __typename?: 'Media' }
        & Pick<Media, 'contentType' | 'url' | 'key'>
      )> }
    )>>, rawTitle: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ) }
  )> }
);

export type SubscriptionsByTierQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionsByTierQuery = (
  { __typename?: 'Query' }
  & { subscriptionsByTier: Array<Maybe<(
    { __typename?: 'SubscriptionsByTier' }
    & Pick<SubscriptionsByTier, 'tierId' | 'tierName' | 'subscriptions'>
  )>> }
);

export type SubscriptionsReportQueryVariables = Exact<{
  range: DateRange;
}>;


export type SubscriptionsReportQuery = (
  { __typename?: 'Query' }
  & { subscriptionsReport: Array<Maybe<(
    { __typename?: 'ReportItem' }
    & Pick<ReportItem, 'month' | 'year' | 'day' | 'date' | 'value'>
  )>> }
);

export type Subscriptions2CsvMutationVariables = Exact<{
  range?: Maybe<DateRange>;
  endRange?: Maybe<DateRange>;
  tierId?: Maybe<Scalars['Int']>;
}>;


export type Subscriptions2CsvMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'subscriptions2csv'>
);

export type TemporaryBlockagesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type TemporaryBlockagesQuery = (
  { __typename?: 'Query' }
  & { temporaryBlockages: Array<Maybe<(
    { __typename?: 'TemporaryBlockage' }
    & Pick<TemporaryBlockage, 'id' | 'reason' | 'validUntil' | 'createdAt'>
    & { author: (
      { __typename?: 'Account' }
      & ShortAccountDataFragmentFragment
    ) }
  )>> }
);

export type TierByTierIdQueryVariables = Exact<{
  tierId: Scalars['String'];
}>;


export type TierByTierIdQuery = (
  { __typename?: 'Query' }
  & { tierByTierId: (
    { __typename?: 'Tier' }
    & Pick<Tier, 'id' | 'tierId' | 'name' | 'description' | 'color' | 'activeDays' | 'eventsPerMonth' | 'pricePerYear' | 'isPublic' | 'isDefaultForSigalClients' | 'sigalHealthInsuranceType' | 'isDefaultForDemo'>
    & { rawName: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ), rawDescription: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ), benefits: Array<Maybe<(
      { __typename?: 'Benefit' }
      & Pick<Benefit, 'id' | 'title'>
    )>> }
  ) }
);

export type TierQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type TierQuery = (
  { __typename?: 'Query' }
  & { tier?: Maybe<(
    { __typename?: 'Tier' }
    & Pick<Tier, 'id' | 'tierId' | 'name' | 'description' | 'color' | 'activeDays' | 'eventsPerMonth' | 'pricePerYear' | 'isPublic' | 'isDefaultForSigalClients' | 'sigalHealthInsuranceType' | 'isDefaultForDemo'>
    & { rawName: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ), rawDescription: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ), benefits: Array<Maybe<(
      { __typename?: 'Benefit' }
      & Pick<Benefit, 'id' | 'title'>
    )>> }
  )> }
);

export type TiersQueryVariables = Exact<{ [key: string]: never; }>;


export type TiersQuery = (
  { __typename?: 'Query' }
  & { tiers: Array<Maybe<(
    { __typename?: 'Tier' }
    & Pick<Tier, 'id' | 'tierId' | 'name' | 'description' | 'color' | 'activeDays' | 'eventsPerMonth' | 'pricePerYear' | 'isPublic' | 'isDefaultForSigalClients' | 'sigalHealthInsuranceType' | 'isDefaultForDemo'>
    & { rawName: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ), rawDescription: (
      { __typename?: 'MultiLangStringType' }
      & Pick<MultiLangStringType, 'sq' | 'en' | 'mk'>
    ), benefits: Array<Maybe<(
      { __typename?: 'Benefit' }
      & Pick<Benefit, 'id' | 'title'>
    )>> }
  )>> }
);

export type AllWaitingQueueQueryVariables = Exact<{ [key: string]: never; }>;


export type AllWaitingQueueQuery = (
  { __typename?: 'Query' }
  & { allWaitingQueue: Array<Maybe<(
    { __typename?: 'AllWaitingQueueResponseItem' }
    & { profile?: Maybe<(
      { __typename?: 'Participant' }
      & Pick<Participant, 'id'>
      & { account: (
        { __typename?: 'Account' }
        & Pick<Account, 'email' | 'id' | 'role' | 'profileImage'>
        & { profile?: Maybe<{ __typename?: 'ClientProfile' } | (
          { __typename?: 'DoctorProfile' }
          & Pick<DoctorProfile, 'id' | 'type' | 'name' | 'lastname'>
        ) | { __typename?: 'SystemUserProfile' }> }
      ) }
    )>, calls: Array<Maybe<(
      { __typename?: 'Call' }
      & Pick<Call, 'id' | 'room' | 'requestTime' | 'startTime' | 'status'>
      & { participants: Array<(
        { __typename?: 'Participant' }
        & Pick<Participant, 'twilioToken' | 'id' | 'role' | 'status' | 'joinTime'>
        & { account: (
          { __typename?: 'Account' }
          & Pick<Account, 'id' | 'email' | 'role' | 'profileImage'>
          & { profile?: Maybe<(
            { __typename: 'ClientProfile' }
            & Pick<ClientProfile, 'id' | 'name' | 'lastname'>
          ) | { __typename: 'DoctorProfile' } | { __typename: 'SystemUserProfile' }> }
        ) }
      )> }
    )>> }
  )>> }
);

export type IncomingCallSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IncomingCallSubscription = (
  { __typename?: 'Subscription' }
  & { incomingCall?: Maybe<(
    { __typename?: 'IncomingCallSubscriptionPayload' }
    & { call: (
      { __typename?: 'Call' }
      & Pick<Call, 'id' | 'room' | 'requestTime' | 'startTime' | 'endTime' | 'status'>
      & { participants: Array<(
        { __typename?: 'Participant' }
        & Pick<Participant, 'twilioToken' | 'role' | 'status' | 'joinTime'>
        & { account: (
          { __typename?: 'Account' }
          & Pick<Account, 'id' | 'email' | 'role'>
          & { profile?: Maybe<(
            { __typename: 'ClientProfile' }
            & Pick<ClientProfile, 'id' | 'name' | 'lastname' | 'birthday' | 'sex'>
          ) | (
            { __typename: 'DoctorProfile' }
            & Pick<DoctorProfile, 'id' | 'name' | 'lastname' | 'birthday' | 'sex'>
          ) | (
            { __typename: 'SystemUserProfile' }
            & Pick<SystemUserProfile, 'id' | 'type'>
          )> }
        ) }
      )> }
    ) }
  )> }
);

export type MyWaitingQueueSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type MyWaitingQueueSubscription = (
  { __typename?: 'Subscription' }
  & { myWaitingQueue: Array<Maybe<(
    { __typename?: 'Call' }
    & Pick<Call, 'id' | 'status' | 'room' | 'requestTime' | 'startTime' | 'endTime'>
    & { participants: Array<(
      { __typename?: 'Participant' }
      & Pick<Participant, 'id' | 'role' | 'status' | 'joinTime'>
      & { account: (
        { __typename?: 'Account' }
        & Pick<Account, 'id' | 'email' | 'accountStatus' | 'subscriptionStatus' | 'profileImage' | 'role' | 'createdAt'>
        & { profile?: Maybe<(
          { __typename: 'ClientProfile' }
          & Pick<ClientProfile, 'id' | 'name' | 'lastname' | 'birthday' | 'sex'>
        ) | (
          { __typename: 'DoctorProfile' }
          & Pick<DoctorProfile, 'id' | 'name' | 'lastname' | 'birthday' | 'sex'>
        ) | (
          { __typename: 'SystemUserProfile' }
          & Pick<SystemUserProfile, 'id' | 'type'>
        )> }
      ) }
    )> }
  )>> }
);

export type SubscribeToCallSubscriptionVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SubscribeToCallSubscription = (
  { __typename?: 'Subscription' }
  & { callUpdate?: Maybe<(
    { __typename?: 'CallUpdateSubscriptionPayload' }
    & Pick<CallUpdateSubscriptionPayload, 'waitingCalls'>
    & { call: (
      { __typename?: 'Call' }
      & Pick<Call, 'id' | 'requestTime' | 'status' | 'room'>
      & { participants: Array<(
        { __typename?: 'Participant' }
        & Pick<Participant, 'id' | 'role' | 'status' | 'joinTime'>
      )> }
    ) }
  )> }
);

export const ShortAccountDataFragmentFragmentDoc = gql`
    fragment ShortAccountDataFragment on Account {
  id
  role
  profileImage
  createdAt
  profile {
    __typename
    ... on ClientProfile {
      id
      name
      lastname
    }
    ... on DoctorProfile {
      name
      lastname
    }
    ... on SystemUserProfile {
      name
      lastname
    }
  }
}
    `;
export const ShortAccountDataFragmentDoc = gql`
    fragment ShortAccountData on Account {
  id
  role
  profileImage
  profile {
    __typename
    ... on ClientProfile {
      id
      name
      lastname
    }
    ... on DoctorProfile {
      name
      lastname
    }
  }
}
    `;
export const AddDocumentToMedicalCardDocument = gql`
    mutation AddDocumentToMedicalCard($medicalCardId: Int!, $key: String!, $description: String!) {
  addDocumentToMedicalCard(
    where: {id: $medicalCardId}
    data: {key: $key, description: $description}
  ) {
    id
    author {
      ...ShortAccountData
    }
    thumbnail: media(size: MEDIUM) {
      url
      contentType
    }
    media {
      url
      contentType
    }
    description
  }
}
    ${ShortAccountDataFragmentDoc}`;
export type AddDocumentToMedicalCardMutationFn = Apollo.MutationFunction<AddDocumentToMedicalCardMutation, AddDocumentToMedicalCardMutationVariables>;

/**
 * __useAddDocumentToMedicalCardMutation__
 *
 * To run a mutation, you first call `useAddDocumentToMedicalCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDocumentToMedicalCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDocumentToMedicalCardMutation, { data, loading, error }] = useAddDocumentToMedicalCardMutation({
 *   variables: {
 *      medicalCardId: // value for 'medicalCardId'
 *      key: // value for 'key'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useAddDocumentToMedicalCardMutation(baseOptions?: Apollo.MutationHookOptions<AddDocumentToMedicalCardMutation, AddDocumentToMedicalCardMutationVariables>) {
        return Apollo.useMutation<AddDocumentToMedicalCardMutation, AddDocumentToMedicalCardMutationVariables>(AddDocumentToMedicalCardDocument, baseOptions);
      }
export type AddDocumentToMedicalCardMutationHookResult = ReturnType<typeof useAddDocumentToMedicalCardMutation>;
export type AddDocumentToMedicalCardMutationResult = Apollo.MutationResult<AddDocumentToMedicalCardMutation>;
export type AddDocumentToMedicalCardMutationOptions = Apollo.BaseMutationOptions<AddDocumentToMedicalCardMutation, AddDocumentToMedicalCardMutationVariables>;
export const AddTimetableDocument = gql`
    mutation AddTimetable($id: Int!, $data: [TimeTableItem!]!) {
  updateTimetable(id: $id, data: $data) {
    id
  }
}
    `;
export type AddTimetableMutationFn = Apollo.MutationFunction<AddTimetableMutation, AddTimetableMutationVariables>;

/**
 * __useAddTimetableMutation__
 *
 * To run a mutation, you first call `useAddTimetableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTimetableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTimetableMutation, { data, loading, error }] = useAddTimetableMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddTimetableMutation(baseOptions?: Apollo.MutationHookOptions<AddTimetableMutation, AddTimetableMutationVariables>) {
        return Apollo.useMutation<AddTimetableMutation, AddTimetableMutationVariables>(AddTimetableDocument, baseOptions);
      }
export type AddTimetableMutationHookResult = ReturnType<typeof useAddTimetableMutation>;
export type AddTimetableMutationResult = Apollo.MutationResult<AddTimetableMutation>;
export type AddTimetableMutationOptions = Apollo.BaseMutationOptions<AddTimetableMutation, AddTimetableMutationVariables>;
export const AnswerCallDocument = gql`
    mutation AnswerCall($id: Int!) {
  answerCall(where: {id: $id}) {
    id
    status
    room
    requestTime
    startTime
    endTime
    participants {
      id
      role
      status
      joinTime
      twilioToken
      account {
        id
        email
        accountStatus
        subscriptionStatus
        role
        createdAt
        profile {
          __typename
          ... on ClientProfile {
            id
            name
            lastname
            birthday
            sex
          }
          ... on DoctorProfile {
            id
            name
            lastname
            birthday
            sex
          }
          ... on SystemUserProfile {
            id
            type
          }
        }
      }
    }
  }
}
    `;
export type AnswerCallMutationFn = Apollo.MutationFunction<AnswerCallMutation, AnswerCallMutationVariables>;

/**
 * __useAnswerCallMutation__
 *
 * To run a mutation, you first call `useAnswerCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerCallMutation, { data, loading, error }] = useAnswerCallMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAnswerCallMutation(baseOptions?: Apollo.MutationHookOptions<AnswerCallMutation, AnswerCallMutationVariables>) {
        return Apollo.useMutation<AnswerCallMutation, AnswerCallMutationVariables>(AnswerCallDocument, baseOptions);
      }
export type AnswerCallMutationHookResult = ReturnType<typeof useAnswerCallMutation>;
export type AnswerCallMutationResult = Apollo.MutationResult<AnswerCallMutation>;
export type AnswerCallMutationOptions = Apollo.BaseMutationOptions<AnswerCallMutation, AnswerCallMutationVariables>;
export const ApproveDoctorRequestAsSpecialistDocument = gql`
    mutation ApproveDoctorRequestAsSpecialist($id: Int!, $specialityId: Int!) {
  approveDoctorRequestAsSpecialist(
    data: {requestId: $id, specialityId: $specialityId}
  ) {
    id
  }
}
    `;
export type ApproveDoctorRequestAsSpecialistMutationFn = Apollo.MutationFunction<ApproveDoctorRequestAsSpecialistMutation, ApproveDoctorRequestAsSpecialistMutationVariables>;

/**
 * __useApproveDoctorRequestAsSpecialistMutation__
 *
 * To run a mutation, you first call `useApproveDoctorRequestAsSpecialistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveDoctorRequestAsSpecialistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveDoctorRequestAsSpecialistMutation, { data, loading, error }] = useApproveDoctorRequestAsSpecialistMutation({
 *   variables: {
 *      id: // value for 'id'
 *      specialityId: // value for 'specialityId'
 *   },
 * });
 */
export function useApproveDoctorRequestAsSpecialistMutation(baseOptions?: Apollo.MutationHookOptions<ApproveDoctorRequestAsSpecialistMutation, ApproveDoctorRequestAsSpecialistMutationVariables>) {
        return Apollo.useMutation<ApproveDoctorRequestAsSpecialistMutation, ApproveDoctorRequestAsSpecialistMutationVariables>(ApproveDoctorRequestAsSpecialistDocument, baseOptions);
      }
export type ApproveDoctorRequestAsSpecialistMutationHookResult = ReturnType<typeof useApproveDoctorRequestAsSpecialistMutation>;
export type ApproveDoctorRequestAsSpecialistMutationResult = Apollo.MutationResult<ApproveDoctorRequestAsSpecialistMutation>;
export type ApproveDoctorRequestAsSpecialistMutationOptions = Apollo.BaseMutationOptions<ApproveDoctorRequestAsSpecialistMutation, ApproveDoctorRequestAsSpecialistMutationVariables>;
export const ApproveDoctorRequestDocument = gql`
    mutation ApproveDoctorRequest($id: Int!) {
  approveDoctorRequest(data: {requestId: $id}) {
    id
  }
}
    `;
export type ApproveDoctorRequestMutationFn = Apollo.MutationFunction<ApproveDoctorRequestMutation, ApproveDoctorRequestMutationVariables>;

/**
 * __useApproveDoctorRequestMutation__
 *
 * To run a mutation, you first call `useApproveDoctorRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveDoctorRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveDoctorRequestMutation, { data, loading, error }] = useApproveDoctorRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveDoctorRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApproveDoctorRequestMutation, ApproveDoctorRequestMutationVariables>) {
        return Apollo.useMutation<ApproveDoctorRequestMutation, ApproveDoctorRequestMutationVariables>(ApproveDoctorRequestDocument, baseOptions);
      }
export type ApproveDoctorRequestMutationHookResult = ReturnType<typeof useApproveDoctorRequestMutation>;
export type ApproveDoctorRequestMutationResult = Apollo.MutationResult<ApproveDoctorRequestMutation>;
export type ApproveDoctorRequestMutationOptions = Apollo.BaseMutationOptions<ApproveDoctorRequestMutation, ApproveDoctorRequestMutationVariables>;
export const ApproveSubscriptionsThatNeedReviewDocument = gql`
    mutation ApproveSubscriptionsThatNeedReview($id: Int!) {
  approveSubscriptionsThatNeedReview(id: $id) {
    id
  }
}
    `;
export type ApproveSubscriptionsThatNeedReviewMutationFn = Apollo.MutationFunction<ApproveSubscriptionsThatNeedReviewMutation, ApproveSubscriptionsThatNeedReviewMutationVariables>;

/**
 * __useApproveSubscriptionsThatNeedReviewMutation__
 *
 * To run a mutation, you first call `useApproveSubscriptionsThatNeedReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveSubscriptionsThatNeedReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveSubscriptionsThatNeedReviewMutation, { data, loading, error }] = useApproveSubscriptionsThatNeedReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveSubscriptionsThatNeedReviewMutation(baseOptions?: Apollo.MutationHookOptions<ApproveSubscriptionsThatNeedReviewMutation, ApproveSubscriptionsThatNeedReviewMutationVariables>) {
        return Apollo.useMutation<ApproveSubscriptionsThatNeedReviewMutation, ApproveSubscriptionsThatNeedReviewMutationVariables>(ApproveSubscriptionsThatNeedReviewDocument, baseOptions);
      }
export type ApproveSubscriptionsThatNeedReviewMutationHookResult = ReturnType<typeof useApproveSubscriptionsThatNeedReviewMutation>;
export type ApproveSubscriptionsThatNeedReviewMutationResult = Apollo.MutationResult<ApproveSubscriptionsThatNeedReviewMutation>;
export type ApproveSubscriptionsThatNeedReviewMutationOptions = Apollo.BaseMutationOptions<ApproveSubscriptionsThatNeedReviewMutation, ApproveSubscriptionsThatNeedReviewMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($oldPassword: String!, $newPassword: String!) {
  changePassword(oldPassword: $oldPassword, newPassword: $newPassword) {
    token
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, baseOptions);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const ClientSignupUsingSigalInsurancePolicyDocument = gql`
    mutation ClientSignupUsingSigalInsurancePolicy($email: String!, $phoneNumber: String!, $name: String!, $lastname: String!, $birthday: Date!, $sex: Gender!, $languageCode: LanguageCode!, $insurancePoliceId: Int!, $insurancePolicyCode: String!) {
  clientSignupUsingSigalInsurancePolicy(
    data: {email: $email, phoneNumber: $phoneNumber, name: $name, lastname: $lastname, birthday: $birthday, sex: $sex, languageCode: $languageCode, insurancePoliceId: $insurancePoliceId, insurancePolicyCode: $insurancePolicyCode}
  ) {
    token
  }
}
    `;
export type ClientSignupUsingSigalInsurancePolicyMutationFn = Apollo.MutationFunction<ClientSignupUsingSigalInsurancePolicyMutation, ClientSignupUsingSigalInsurancePolicyMutationVariables>;

/**
 * __useClientSignupUsingSigalInsurancePolicyMutation__
 *
 * To run a mutation, you first call `useClientSignupUsingSigalInsurancePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientSignupUsingSigalInsurancePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientSignupUsingSigalInsurancePolicyMutation, { data, loading, error }] = useClientSignupUsingSigalInsurancePolicyMutation({
 *   variables: {
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *      name: // value for 'name'
 *      lastname: // value for 'lastname'
 *      birthday: // value for 'birthday'
 *      sex: // value for 'sex'
 *      languageCode: // value for 'languageCode'
 *      insurancePoliceId: // value for 'insurancePoliceId'
 *      insurancePolicyCode: // value for 'insurancePolicyCode'
 *   },
 * });
 */
export function useClientSignupUsingSigalInsurancePolicyMutation(baseOptions?: Apollo.MutationHookOptions<ClientSignupUsingSigalInsurancePolicyMutation, ClientSignupUsingSigalInsurancePolicyMutationVariables>) {
        return Apollo.useMutation<ClientSignupUsingSigalInsurancePolicyMutation, ClientSignupUsingSigalInsurancePolicyMutationVariables>(ClientSignupUsingSigalInsurancePolicyDocument, baseOptions);
      }
export type ClientSignupUsingSigalInsurancePolicyMutationHookResult = ReturnType<typeof useClientSignupUsingSigalInsurancePolicyMutation>;
export type ClientSignupUsingSigalInsurancePolicyMutationResult = Apollo.MutationResult<ClientSignupUsingSigalInsurancePolicyMutation>;
export type ClientSignupUsingSigalInsurancePolicyMutationOptions = Apollo.BaseMutationOptions<ClientSignupUsingSigalInsurancePolicyMutation, ClientSignupUsingSigalInsurancePolicyMutationVariables>;
export const ClientSignupAdminDocument = gql`
    mutation ClientSignupAdmin($email: String!, $phoneNumber: String!, $name: String!, $lastname: String!, $birthday: Date!, $sex: Gender!, $languageCode: LanguageCode!, $tierId: Int!) {
  clientSignupAdmin(
    data: {email: $email, phoneNumber: $phoneNumber, name: $name, lastname: $lastname, birthday: $birthday, sex: $sex, languageCode: $languageCode, tierId: $tierId}
  ) {
    token
  }
}
    `;
export type ClientSignupAdminMutationFn = Apollo.MutationFunction<ClientSignupAdminMutation, ClientSignupAdminMutationVariables>;

/**
 * __useClientSignupAdminMutation__
 *
 * To run a mutation, you first call `useClientSignupAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientSignupAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientSignupAdminMutation, { data, loading, error }] = useClientSignupAdminMutation({
 *   variables: {
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *      name: // value for 'name'
 *      lastname: // value for 'lastname'
 *      birthday: // value for 'birthday'
 *      sex: // value for 'sex'
 *      languageCode: // value for 'languageCode'
 *      tierId: // value for 'tierId'
 *   },
 * });
 */
export function useClientSignupAdminMutation(baseOptions?: Apollo.MutationHookOptions<ClientSignupAdminMutation, ClientSignupAdminMutationVariables>) {
        return Apollo.useMutation<ClientSignupAdminMutation, ClientSignupAdminMutationVariables>(ClientSignupAdminDocument, baseOptions);
      }
export type ClientSignupAdminMutationHookResult = ReturnType<typeof useClientSignupAdminMutation>;
export type ClientSignupAdminMutationResult = Apollo.MutationResult<ClientSignupAdminMutation>;
export type ClientSignupAdminMutationOptions = Apollo.BaseMutationOptions<ClientSignupAdminMutation, ClientSignupAdminMutationVariables>;
export const Clients2csvDocument = gql`
    mutation Clients2csv {
  clients2csv
}
    `;
export type Clients2csvMutationFn = Apollo.MutationFunction<Clients2csvMutation, Clients2csvMutationVariables>;

/**
 * __useClients2csvMutation__
 *
 * To run a mutation, you first call `useClients2csvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClients2csvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clients2csvMutation, { data, loading, error }] = useClients2csvMutation({
 *   variables: {
 *   },
 * });
 */
export function useClients2csvMutation(baseOptions?: Apollo.MutationHookOptions<Clients2csvMutation, Clients2csvMutationVariables>) {
        return Apollo.useMutation<Clients2csvMutation, Clients2csvMutationVariables>(Clients2csvDocument, baseOptions);
      }
export type Clients2csvMutationHookResult = ReturnType<typeof useClients2csvMutation>;
export type Clients2csvMutationResult = Apollo.MutationResult<Clients2csvMutation>;
export type Clients2csvMutationOptions = Apollo.BaseMutationOptions<Clients2csvMutation, Clients2csvMutationVariables>;
export const CreateAdminDocument = gql`
    mutation CreateAdmin($email: String!, $name: String!, $lastname: String!, $phoneNumber: String!) {
  createAdmin(
    data: {email: $email, name: $name, lastname: $lastname, phoneNumber: $phoneNumber}
  ) {
    id
    email
  }
}
    `;
export type CreateAdminMutationFn = Apollo.MutationFunction<CreateAdminMutation, CreateAdminMutationVariables>;

/**
 * __useCreateAdminMutation__
 *
 * To run a mutation, you first call `useCreateAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminMutation, { data, loading, error }] = useCreateAdminMutation({
 *   variables: {
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      lastname: // value for 'lastname'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useCreateAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminMutation, CreateAdminMutationVariables>) {
        return Apollo.useMutation<CreateAdminMutation, CreateAdminMutationVariables>(CreateAdminDocument, baseOptions);
      }
export type CreateAdminMutationHookResult = ReturnType<typeof useCreateAdminMutation>;
export type CreateAdminMutationResult = Apollo.MutationResult<CreateAdminMutation>;
export type CreateAdminMutationOptions = Apollo.BaseMutationOptions<CreateAdminMutation, CreateAdminMutationVariables>;
export const CreateArticleDocument = gql`
    mutation CreateArticle($languageCode: LanguageCode!, $title: String!, $body: String!, $coverMediaKey: String!, $excerpt: String!) {
  createArticle(
    data: {excerpt: $excerpt, languageCode: $languageCode, title: $title, body: $body, coverMediaKey: $coverMediaKey}
  ) {
    id
  }
}
    `;
export type CreateArticleMutationFn = Apollo.MutationFunction<CreateArticleMutation, CreateArticleMutationVariables>;

/**
 * __useCreateArticleMutation__
 *
 * To run a mutation, you first call `useCreateArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArticleMutation, { data, loading, error }] = useCreateArticleMutation({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      title: // value for 'title'
 *      body: // value for 'body'
 *      coverMediaKey: // value for 'coverMediaKey'
 *      excerpt: // value for 'excerpt'
 *   },
 * });
 */
export function useCreateArticleMutation(baseOptions?: Apollo.MutationHookOptions<CreateArticleMutation, CreateArticleMutationVariables>) {
        return Apollo.useMutation<CreateArticleMutation, CreateArticleMutationVariables>(CreateArticleDocument, baseOptions);
      }
export type CreateArticleMutationHookResult = ReturnType<typeof useCreateArticleMutation>;
export type CreateArticleMutationResult = Apollo.MutationResult<CreateArticleMutation>;
export type CreateArticleMutationOptions = Apollo.BaseMutationOptions<CreateArticleMutation, CreateArticleMutationVariables>;
export const CreateAuthorDocument = gql`
    mutation CreateAuthor($email: String!, $name: String!, $lastname: String!) {
  createAuthor(data: {email: $email, name: $name, lastname: $lastname}) {
    id
    email
  }
}
    `;
export type CreateAuthorMutationFn = Apollo.MutationFunction<CreateAuthorMutation, CreateAuthorMutationVariables>;

/**
 * __useCreateAuthorMutation__
 *
 * To run a mutation, you first call `useCreateAuthorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuthorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuthorMutation, { data, loading, error }] = useCreateAuthorMutation({
 *   variables: {
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      lastname: // value for 'lastname'
 *   },
 * });
 */
export function useCreateAuthorMutation(baseOptions?: Apollo.MutationHookOptions<CreateAuthorMutation, CreateAuthorMutationVariables>) {
        return Apollo.useMutation<CreateAuthorMutation, CreateAuthorMutationVariables>(CreateAuthorDocument, baseOptions);
      }
export type CreateAuthorMutationHookResult = ReturnType<typeof useCreateAuthorMutation>;
export type CreateAuthorMutationResult = Apollo.MutationResult<CreateAuthorMutation>;
export type CreateAuthorMutationOptions = Apollo.BaseMutationOptions<CreateAuthorMutation, CreateAuthorMutationVariables>;
export const CreateBenefitDocument = gql`
    mutation CreateBenefit($title: MultiLanguageString!, $descriptioin: MultiLanguageString!, $imageMediaKey: String!, $externalURL: String, $externalUrlLabel: MultiLanguageString) {
  createBenefit(
    data: {title: $title, description: $descriptioin, imageMediaKey: $imageMediaKey, externalURL: $externalURL, externalUrlLabel: $externalUrlLabel}
  ) {
    id
    title
    description
    image {
      id
      url
      key
    }
    rawTitle {
      sq
      en
      mk
    }
    rawDescription {
      sq
      en
      mk
    }
    rawExternalUrlLabel {
      sq
      en
      mk
    }
    externalUrlLabel
    externalURL
    createdAt
    updatedAt
    tiers {
      id
      name
    }
  }
}
    `;
export type CreateBenefitMutationFn = Apollo.MutationFunction<CreateBenefitMutation, CreateBenefitMutationVariables>;

/**
 * __useCreateBenefitMutation__
 *
 * To run a mutation, you first call `useCreateBenefitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBenefitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBenefitMutation, { data, loading, error }] = useCreateBenefitMutation({
 *   variables: {
 *      title: // value for 'title'
 *      descriptioin: // value for 'descriptioin'
 *      imageMediaKey: // value for 'imageMediaKey'
 *      externalURL: // value for 'externalURL'
 *      externalUrlLabel: // value for 'externalUrlLabel'
 *   },
 * });
 */
export function useCreateBenefitMutation(baseOptions?: Apollo.MutationHookOptions<CreateBenefitMutation, CreateBenefitMutationVariables>) {
        return Apollo.useMutation<CreateBenefitMutation, CreateBenefitMutationVariables>(CreateBenefitDocument, baseOptions);
      }
export type CreateBenefitMutationHookResult = ReturnType<typeof useCreateBenefitMutation>;
export type CreateBenefitMutationResult = Apollo.MutationResult<CreateBenefitMutation>;
export type CreateBenefitMutationOptions = Apollo.BaseMutationOptions<CreateBenefitMutation, CreateBenefitMutationVariables>;
export const CreateCityDocument = gql`
    mutation CreateCity($name: MultiLanguageString!, $countryId: Int!) {
  createCity(data: {countryId: $countryId, name: $name}) {
    id
    name
  }
}
    `;
export type CreateCityMutationFn = Apollo.MutationFunction<CreateCityMutation, CreateCityMutationVariables>;

/**
 * __useCreateCityMutation__
 *
 * To run a mutation, you first call `useCreateCityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCityMutation, { data, loading, error }] = useCreateCityMutation({
 *   variables: {
 *      name: // value for 'name'
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useCreateCityMutation(baseOptions?: Apollo.MutationHookOptions<CreateCityMutation, CreateCityMutationVariables>) {
        return Apollo.useMutation<CreateCityMutation, CreateCityMutationVariables>(CreateCityDocument, baseOptions);
      }
export type CreateCityMutationHookResult = ReturnType<typeof useCreateCityMutation>;
export type CreateCityMutationResult = Apollo.MutationResult<CreateCityMutation>;
export type CreateCityMutationOptions = Apollo.BaseMutationOptions<CreateCityMutation, CreateCityMutationVariables>;
export const CreateCountryDocument = gql`
    mutation CreateCountry($name: MultiLanguageString!) {
  createCountry(data: {name: $name}) {
    id
    name
  }
}
    `;
export type CreateCountryMutationFn = Apollo.MutationFunction<CreateCountryMutation, CreateCountryMutationVariables>;

/**
 * __useCreateCountryMutation__
 *
 * To run a mutation, you first call `useCreateCountryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCountryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCountryMutation, { data, loading, error }] = useCreateCountryMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateCountryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCountryMutation, CreateCountryMutationVariables>) {
        return Apollo.useMutation<CreateCountryMutation, CreateCountryMutationVariables>(CreateCountryDocument, baseOptions);
      }
export type CreateCountryMutationHookResult = ReturnType<typeof useCreateCountryMutation>;
export type CreateCountryMutationResult = Apollo.MutationResult<CreateCountryMutation>;
export type CreateCountryMutationOptions = Apollo.BaseMutationOptions<CreateCountryMutation, CreateCountryMutationVariables>;
export const CreateDoctorRequestDocument = gql`
    mutation CreateDoctorRequest($name: String!, $lastname: String!, $languageCode: LanguageCode!, $email: String!, $password: String!, $birthday: Date!, $phoneNumber: String!, $licenceNumber: String!, $cvKey: String!, $sex: Gender!, $countryId: Int!, $cityId: Int!, $healthCenterId: Int!) {
  createDoctorRequest(
    data: {name: $name, lastname: $lastname, languageCode: $languageCode, email: $email, password: $password, birthday: $birthday, phoneNumber: $phoneNumber, licenceNumber: $licenceNumber, cvKey: $cvKey, sex: $sex, countryId: $countryId, cityId: $cityId, healthCenterId: $healthCenterId}
  ) {
    id
    name
    lastname
  }
}
    `;
export type CreateDoctorRequestMutationFn = Apollo.MutationFunction<CreateDoctorRequestMutation, CreateDoctorRequestMutationVariables>;

/**
 * __useCreateDoctorRequestMutation__
 *
 * To run a mutation, you first call `useCreateDoctorRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDoctorRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDoctorRequestMutation, { data, loading, error }] = useCreateDoctorRequestMutation({
 *   variables: {
 *      name: // value for 'name'
 *      lastname: // value for 'lastname'
 *      languageCode: // value for 'languageCode'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      birthday: // value for 'birthday'
 *      phoneNumber: // value for 'phoneNumber'
 *      licenceNumber: // value for 'licenceNumber'
 *      cvKey: // value for 'cvKey'
 *      sex: // value for 'sex'
 *      countryId: // value for 'countryId'
 *      cityId: // value for 'cityId'
 *      healthCenterId: // value for 'healthCenterId'
 *   },
 * });
 */
export function useCreateDoctorRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateDoctorRequestMutation, CreateDoctorRequestMutationVariables>) {
        return Apollo.useMutation<CreateDoctorRequestMutation, CreateDoctorRequestMutationVariables>(CreateDoctorRequestDocument, baseOptions);
      }
export type CreateDoctorRequestMutationHookResult = ReturnType<typeof useCreateDoctorRequestMutation>;
export type CreateDoctorRequestMutationResult = Apollo.MutationResult<CreateDoctorRequestMutation>;
export type CreateDoctorRequestMutationOptions = Apollo.BaseMutationOptions<CreateDoctorRequestMutation, CreateDoctorRequestMutationVariables>;
export const CreateDocumentCommentDocument = gql`
    mutation CreateDocumentComment($documentId: Int!, $content: String!) {
  createDocumentComment(where: {id: $documentId}, data: {content: $content}) {
    id
    author {
      ...ShortAccountData
    }
    content
    createdAt
    updatedAt
  }
}
    ${ShortAccountDataFragmentDoc}`;
export type CreateDocumentCommentMutationFn = Apollo.MutationFunction<CreateDocumentCommentMutation, CreateDocumentCommentMutationVariables>;

/**
 * __useCreateDocumentCommentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentCommentMutation, { data, loading, error }] = useCreateDocumentCommentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useCreateDocumentCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentCommentMutation, CreateDocumentCommentMutationVariables>) {
        return Apollo.useMutation<CreateDocumentCommentMutation, CreateDocumentCommentMutationVariables>(CreateDocumentCommentDocument, baseOptions);
      }
export type CreateDocumentCommentMutationHookResult = ReturnType<typeof useCreateDocumentCommentMutation>;
export type CreateDocumentCommentMutationResult = Apollo.MutationResult<CreateDocumentCommentMutation>;
export type CreateDocumentCommentMutationOptions = Apollo.BaseMutationOptions<CreateDocumentCommentMutation, CreateDocumentCommentMutationVariables>;
export const CreateEventDocument = gql`
    mutation CreateEvent($title: String!, $description: String!, $coverMediaKey: String!, $specialistId: Int!, $startDate: DateTime!, $durationMinutes: Int!, $maxParticipantsNumber: Int!) {
  createEvent(
    data: {title: $title, description: $description, coverMediaKey: $coverMediaKey, specialistId: $specialistId, startDate: $startDate, durationMinutes: $durationMinutes, maxParticipantsNumber: $maxParticipantsNumber}
  ) {
    id
    title
    description
    cover(resize: {width: 800}) {
      id
      url
      createdAt
      contentType
    }
    specialist {
      ...ShortAccountData
    }
    roomName
    creator {
      ...ShortAccountData
    }
    startDate
    endDate
    durationMinutes
    participants {
      maxNumber
      currentCount
      list {
        ...ShortAccountData
      }
    }
    participationStatus
    createdAt
    updatedAt
  }
}
    ${ShortAccountDataFragmentDoc}`;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      coverMediaKey: // value for 'coverMediaKey'
 *      specialistId: // value for 'specialistId'
 *      startDate: // value for 'startDate'
 *      durationMinutes: // value for 'durationMinutes'
 *      maxParticipantsNumber: // value for 'maxParticipantsNumber'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, baseOptions);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const SendRetryCallNotificationDocument = gql`
    mutation SendRetryCallNotification($callId: Int!) {
  sendRetryCallNotification(data: {callId: $callId}) {
    id
    text
    createdAt
  }
}
    `;
export type SendRetryCallNotificationMutationFn = Apollo.MutationFunction<SendRetryCallNotificationMutation, SendRetryCallNotificationMutationVariables>;

/**
 * __useSendRetryCallNotificationMutation__
 *
 * To run a mutation, you first call `useSendRetryCallNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRetryCallNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRetryCallNotificationMutation, { data, loading, error }] = useSendRetryCallNotificationMutation({
 *   variables: {
 *      callId: // value for 'callId'
 *   },
 * });
 */
export function useSendRetryCallNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SendRetryCallNotificationMutation, SendRetryCallNotificationMutationVariables>) {
        return Apollo.useMutation<SendRetryCallNotificationMutation, SendRetryCallNotificationMutationVariables>(SendRetryCallNotificationDocument, baseOptions);
      }
export type SendRetryCallNotificationMutationHookResult = ReturnType<typeof useSendRetryCallNotificationMutation>;
export type SendRetryCallNotificationMutationResult = Apollo.MutationResult<SendRetryCallNotificationMutation>;
export type SendRetryCallNotificationMutationOptions = Apollo.BaseMutationOptions<SendRetryCallNotificationMutation, SendRetryCallNotificationMutationVariables>;
export const CreateFaqDocument = gql`
    mutation CreateFaq($title: MultiLanguageString!, $body: MultiLanguageString!) {
  createFaq(data: {title: $title, body: $body}) {
    id
    title
    rawTitle {
      sq
      en
      mk
    }
    body
    rawBody {
      sq
      en
      mk
    }
  }
}
    `;
export type CreateFaqMutationFn = Apollo.MutationFunction<CreateFaqMutation, CreateFaqMutationVariables>;

/**
 * __useCreateFaqMutation__
 *
 * To run a mutation, you first call `useCreateFaqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFaqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFaqMutation, { data, loading, error }] = useCreateFaqMutation({
 *   variables: {
 *      title: // value for 'title'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateFaqMutation(baseOptions?: Apollo.MutationHookOptions<CreateFaqMutation, CreateFaqMutationVariables>) {
        return Apollo.useMutation<CreateFaqMutation, CreateFaqMutationVariables>(CreateFaqDocument, baseOptions);
      }
export type CreateFaqMutationHookResult = ReturnType<typeof useCreateFaqMutation>;
export type CreateFaqMutationResult = Apollo.MutationResult<CreateFaqMutation>;
export type CreateFaqMutationOptions = Apollo.BaseMutationOptions<CreateFaqMutation, CreateFaqMutationVariables>;
export const CreateHealthCenterDocument = gql`
    mutation CreateHealthCenter($name: MultiLanguageString!, $cityId: Int!) {
  createHealthCenter(data: {cityId: $cityId, name: $name}) {
    id
    name
  }
}
    `;
export type CreateHealthCenterMutationFn = Apollo.MutationFunction<CreateHealthCenterMutation, CreateHealthCenterMutationVariables>;

/**
 * __useCreateHealthCenterMutation__
 *
 * To run a mutation, you first call `useCreateHealthCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHealthCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHealthCenterMutation, { data, loading, error }] = useCreateHealthCenterMutation({
 *   variables: {
 *      name: // value for 'name'
 *      cityId: // value for 'cityId'
 *   },
 * });
 */
export function useCreateHealthCenterMutation(baseOptions?: Apollo.MutationHookOptions<CreateHealthCenterMutation, CreateHealthCenterMutationVariables>) {
        return Apollo.useMutation<CreateHealthCenterMutation, CreateHealthCenterMutationVariables>(CreateHealthCenterDocument, baseOptions);
      }
export type CreateHealthCenterMutationHookResult = ReturnType<typeof useCreateHealthCenterMutation>;
export type CreateHealthCenterMutationResult = Apollo.MutationResult<CreateHealthCenterMutation>;
export type CreateHealthCenterMutationOptions = Apollo.BaseMutationOptions<CreateHealthCenterMutation, CreateHealthCenterMutationVariables>;
export const CreateInsurancePolicyDocument = gql`
    mutation CreateInsurancePolicy($name: MultiLanguageString!) {
  createInsurancePolicy(data: {name: $name}) {
    id
    name
  }
}
    `;
export type CreateInsurancePolicyMutationFn = Apollo.MutationFunction<CreateInsurancePolicyMutation, CreateInsurancePolicyMutationVariables>;

/**
 * __useCreateInsurancePolicyMutation__
 *
 * To run a mutation, you first call `useCreateInsurancePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsurancePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsurancePolicyMutation, { data, loading, error }] = useCreateInsurancePolicyMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateInsurancePolicyMutation(baseOptions?: Apollo.MutationHookOptions<CreateInsurancePolicyMutation, CreateInsurancePolicyMutationVariables>) {
        return Apollo.useMutation<CreateInsurancePolicyMutation, CreateInsurancePolicyMutationVariables>(CreateInsurancePolicyDocument, baseOptions);
      }
export type CreateInsurancePolicyMutationHookResult = ReturnType<typeof useCreateInsurancePolicyMutation>;
export type CreateInsurancePolicyMutationResult = Apollo.MutationResult<CreateInsurancePolicyMutation>;
export type CreateInsurancePolicyMutationOptions = Apollo.BaseMutationOptions<CreateInsurancePolicyMutation, CreateInsurancePolicyMutationVariables>;
export const CreateMediaLibraryItemDocument = gql`
    mutation CreateMediaLibraryItem($title: String!, $mediaKey: String!) {
  createMediaLibraryItem(data: {title: $title, mediaKey: $mediaKey}) {
    id
  }
}
    `;
export type CreateMediaLibraryItemMutationFn = Apollo.MutationFunction<CreateMediaLibraryItemMutation, CreateMediaLibraryItemMutationVariables>;

/**
 * __useCreateMediaLibraryItemMutation__
 *
 * To run a mutation, you first call `useCreateMediaLibraryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMediaLibraryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMediaLibraryItemMutation, { data, loading, error }] = useCreateMediaLibraryItemMutation({
 *   variables: {
 *      title: // value for 'title'
 *      mediaKey: // value for 'mediaKey'
 *   },
 * });
 */
export function useCreateMediaLibraryItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateMediaLibraryItemMutation, CreateMediaLibraryItemMutationVariables>) {
        return Apollo.useMutation<CreateMediaLibraryItemMutation, CreateMediaLibraryItemMutationVariables>(CreateMediaLibraryItemDocument, baseOptions);
      }
export type CreateMediaLibraryItemMutationHookResult = ReturnType<typeof useCreateMediaLibraryItemMutation>;
export type CreateMediaLibraryItemMutationResult = Apollo.MutationResult<CreateMediaLibraryItemMutation>;
export type CreateMediaLibraryItemMutationOptions = Apollo.BaseMutationOptions<CreateMediaLibraryItemMutation, CreateMediaLibraryItemMutationVariables>;
export const CreateMedicalCardCommentDocument = gql`
    mutation CreateMedicalCardComment($medicalCardId: Int!, $content: String!) {
  createMedicalCardComment(where: {id: $medicalCardId}, data: {content: $content}) {
    id
    author {
      ...ShortAccountData
    }
    content
    createdAt
    updatedAt
  }
}
    ${ShortAccountDataFragmentDoc}`;
export type CreateMedicalCardCommentMutationFn = Apollo.MutationFunction<CreateMedicalCardCommentMutation, CreateMedicalCardCommentMutationVariables>;

/**
 * __useCreateMedicalCardCommentMutation__
 *
 * To run a mutation, you first call `useCreateMedicalCardCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMedicalCardCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMedicalCardCommentMutation, { data, loading, error }] = useCreateMedicalCardCommentMutation({
 *   variables: {
 *      medicalCardId: // value for 'medicalCardId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useCreateMedicalCardCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateMedicalCardCommentMutation, CreateMedicalCardCommentMutationVariables>) {
        return Apollo.useMutation<CreateMedicalCardCommentMutation, CreateMedicalCardCommentMutationVariables>(CreateMedicalCardCommentDocument, baseOptions);
      }
export type CreateMedicalCardCommentMutationHookResult = ReturnType<typeof useCreateMedicalCardCommentMutation>;
export type CreateMedicalCardCommentMutationResult = Apollo.MutationResult<CreateMedicalCardCommentMutation>;
export type CreateMedicalCardCommentMutationOptions = Apollo.BaseMutationOptions<CreateMedicalCardCommentMutation, CreateMedicalCardCommentMutationVariables>;
export const CreateMedicalCardDocument = gql`
    mutation CreateMedicalCard($patientId: Int!, $symptoms: String!, $diagnosis: String!, $recommendation: String!, $recipe: String!, $privateNote: String, $medicalConcernCategoryId: Int!) {
  createMedicalCard(
    data: {patientId: $patientId, symptoms: $symptoms, diagnosis: $diagnosis, recommendation: $recommendation, recipe: $recipe, privateNote: $privateNote, medicalConcernCategoryId: $medicalConcernCategoryId}
  ) {
    id
    patient {
      ...ShortAccountData
    }
    doctor {
      ...ShortAccountData
    }
    symptoms
    diagnosis
    diagnosis
    recommendation
    recipe
    privateNote
    createdAt
    updatedAt
    concernCategory {
      id
      name
    }
    documents {
      id
      author {
        ...ShortAccountData
      }
      thumbnail: media(size: MEDIUM) {
        id
        url
        createdAt
        contentType
        byteSize
      }
      media {
        url
      }
      description
      comments {
        author {
          ...ShortAccountData
        }
        content
        createdAt
        updatedAt
      }
    }
    comments {
      id
      author {
        ...ShortAccountData
      }
      content
      createdAt
      updatedAt
    }
  }
}
    ${ShortAccountDataFragmentDoc}`;
export type CreateMedicalCardMutationFn = Apollo.MutationFunction<CreateMedicalCardMutation, CreateMedicalCardMutationVariables>;

/**
 * __useCreateMedicalCardMutation__
 *
 * To run a mutation, you first call `useCreateMedicalCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMedicalCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMedicalCardMutation, { data, loading, error }] = useCreateMedicalCardMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      symptoms: // value for 'symptoms'
 *      diagnosis: // value for 'diagnosis'
 *      recommendation: // value for 'recommendation'
 *      recipe: // value for 'recipe'
 *      privateNote: // value for 'privateNote'
 *      medicalConcernCategoryId: // value for 'medicalConcernCategoryId'
 *   },
 * });
 */
export function useCreateMedicalCardMutation(baseOptions?: Apollo.MutationHookOptions<CreateMedicalCardMutation, CreateMedicalCardMutationVariables>) {
        return Apollo.useMutation<CreateMedicalCardMutation, CreateMedicalCardMutationVariables>(CreateMedicalCardDocument, baseOptions);
      }
export type CreateMedicalCardMutationHookResult = ReturnType<typeof useCreateMedicalCardMutation>;
export type CreateMedicalCardMutationResult = Apollo.MutationResult<CreateMedicalCardMutation>;
export type CreateMedicalCardMutationOptions = Apollo.BaseMutationOptions<CreateMedicalCardMutation, CreateMedicalCardMutationVariables>;
export const CreateMedicalConcernCategoryDocument = gql`
    mutation CreateMedicalConcernCategory($name: MultiLanguageString!) {
  createMedicalConcernCategory(data: {name: $name}) {
    id
    name
  }
}
    `;
export type CreateMedicalConcernCategoryMutationFn = Apollo.MutationFunction<CreateMedicalConcernCategoryMutation, CreateMedicalConcernCategoryMutationVariables>;

/**
 * __useCreateMedicalConcernCategoryMutation__
 *
 * To run a mutation, you first call `useCreateMedicalConcernCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMedicalConcernCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMedicalConcernCategoryMutation, { data, loading, error }] = useCreateMedicalConcernCategoryMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateMedicalConcernCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateMedicalConcernCategoryMutation, CreateMedicalConcernCategoryMutationVariables>) {
        return Apollo.useMutation<CreateMedicalConcernCategoryMutation, CreateMedicalConcernCategoryMutationVariables>(CreateMedicalConcernCategoryDocument, baseOptions);
      }
export type CreateMedicalConcernCategoryMutationHookResult = ReturnType<typeof useCreateMedicalConcernCategoryMutation>;
export type CreateMedicalConcernCategoryMutationResult = Apollo.MutationResult<CreateMedicalConcernCategoryMutation>;
export type CreateMedicalConcernCategoryMutationOptions = Apollo.BaseMutationOptions<CreateMedicalConcernCategoryMutation, CreateMedicalConcernCategoryMutationVariables>;
export const CreateSpecialityDocument = gql`
    mutation CreateSpeciality($name: MultiLanguageString!) {
  createSpeciality(data: {name: $name}) {
    id
    name
  }
}
    `;
export type CreateSpecialityMutationFn = Apollo.MutationFunction<CreateSpecialityMutation, CreateSpecialityMutationVariables>;

/**
 * __useCreateSpecialityMutation__
 *
 * To run a mutation, you first call `useCreateSpecialityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpecialityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpecialityMutation, { data, loading, error }] = useCreateSpecialityMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateSpecialityMutation(baseOptions?: Apollo.MutationHookOptions<CreateSpecialityMutation, CreateSpecialityMutationVariables>) {
        return Apollo.useMutation<CreateSpecialityMutation, CreateSpecialityMutationVariables>(CreateSpecialityDocument, baseOptions);
      }
export type CreateSpecialityMutationHookResult = ReturnType<typeof useCreateSpecialityMutation>;
export type CreateSpecialityMutationResult = Apollo.MutationResult<CreateSpecialityMutation>;
export type CreateSpecialityMutationOptions = Apollo.BaseMutationOptions<CreateSpecialityMutation, CreateSpecialityMutationVariables>;
export const CreateStoryItemDocument = gql`
    mutation CreateStoryItem($isActive: Boolean!, $mediaKey: String!, $linkURL: String, $linkLabel: String, $bgColor: String, $storyId: Int!, $language: LanguageCode!) {
  createStoryItem(
    data: {isActive: $isActive, linkURL: $linkURL, linkLabel: $linkLabel, bgColor: $bgColor, mediaKey: $mediaKey, storyId: $storyId, language: $language}
  ) {
    id
  }
}
    `;
export type CreateStoryItemMutationFn = Apollo.MutationFunction<CreateStoryItemMutation, CreateStoryItemMutationVariables>;

/**
 * __useCreateStoryItemMutation__
 *
 * To run a mutation, you first call `useCreateStoryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStoryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStoryItemMutation, { data, loading, error }] = useCreateStoryItemMutation({
 *   variables: {
 *      isActive: // value for 'isActive'
 *      mediaKey: // value for 'mediaKey'
 *      linkURL: // value for 'linkURL'
 *      linkLabel: // value for 'linkLabel'
 *      bgColor: // value for 'bgColor'
 *      storyId: // value for 'storyId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useCreateStoryItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateStoryItemMutation, CreateStoryItemMutationVariables>) {
        return Apollo.useMutation<CreateStoryItemMutation, CreateStoryItemMutationVariables>(CreateStoryItemDocument, baseOptions);
      }
export type CreateStoryItemMutationHookResult = ReturnType<typeof useCreateStoryItemMutation>;
export type CreateStoryItemMutationResult = Apollo.MutationResult<CreateStoryItemMutation>;
export type CreateStoryItemMutationOptions = Apollo.BaseMutationOptions<CreateStoryItemMutation, CreateStoryItemMutationVariables>;
export const CreateStoryDocument = gql`
    mutation CreateStory($mediaKey: String!, $title: MultiLanguageString!) {
  createStory(data: {mediaKey: $mediaKey, title: $title}) {
    id
    order
    author {
      ...ShortAccountDataFragment
    }
    icon {
      url
    }
    title
    rawTitle {
      sq
      en
      mk
    }
    items {
      id
      isActive
    }
    createdAt
    updatedAt
  }
}
    ${ShortAccountDataFragmentFragmentDoc}`;
export type CreateStoryMutationFn = Apollo.MutationFunction<CreateStoryMutation, CreateStoryMutationVariables>;

/**
 * __useCreateStoryMutation__
 *
 * To run a mutation, you first call `useCreateStoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStoryMutation, { data, loading, error }] = useCreateStoryMutation({
 *   variables: {
 *      mediaKey: // value for 'mediaKey'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateStoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateStoryMutation, CreateStoryMutationVariables>) {
        return Apollo.useMutation<CreateStoryMutation, CreateStoryMutationVariables>(CreateStoryDocument, baseOptions);
      }
export type CreateStoryMutationHookResult = ReturnType<typeof useCreateStoryMutation>;
export type CreateStoryMutationResult = Apollo.MutationResult<CreateStoryMutation>;
export type CreateStoryMutationOptions = Apollo.BaseMutationOptions<CreateStoryMutation, CreateStoryMutationVariables>;
export const CreateTierDocument = gql`
    mutation CreateTier($nameSq: String!, $nameEn: String!, $nameMk: String!, $descriptionSq: String!, $descriptionEn: String!, $descriptionMk: String!, $color: String!, $activeDays: Int!, $eventsPerMonth: Int!, $pricePerYear: Int!, $default: Boolean!, $demo: Boolean!, $benefitIDs: [Int!]!, $sigalHealthInsuranceType: HealthInsuranceCardType) {
  createTier(
    data: {name: {en: $nameEn, sq: $nameSq, mk: $nameMk}, description: {en: $descriptionEn, sq: $descriptionSq, mk: $descriptionMk}, color: $color, activeDays: $activeDays, eventsPerMonth: $eventsPerMonth, pricePerYear: $pricePerYear, isDefaultForSigalClients: $default, isDefaultForDemo: $demo, benefitIDs: $benefitIDs, sigalHealthInsuranceType: $sigalHealthInsuranceType}
  ) {
    id
    name
    description
    color
    activeDays
    eventsPerMonth
    pricePerYear
    isPublic
    isDefaultForSigalClients
    isDefaultForDemo
  }
}
    `;
export type CreateTierMutationFn = Apollo.MutationFunction<CreateTierMutation, CreateTierMutationVariables>;

/**
 * __useCreateTierMutation__
 *
 * To run a mutation, you first call `useCreateTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTierMutation, { data, loading, error }] = useCreateTierMutation({
 *   variables: {
 *      nameSq: // value for 'nameSq'
 *      nameEn: // value for 'nameEn'
 *      nameMk: // value for 'nameMk'
 *      descriptionSq: // value for 'descriptionSq'
 *      descriptionEn: // value for 'descriptionEn'
 *      descriptionMk: // value for 'descriptionMk'
 *      color: // value for 'color'
 *      activeDays: // value for 'activeDays'
 *      eventsPerMonth: // value for 'eventsPerMonth'
 *      pricePerYear: // value for 'pricePerYear'
 *      default: // value for 'default'
 *      demo: // value for 'demo'
 *      benefitIDs: // value for 'benefitIDs'
 *      sigalHealthInsuranceType: // value for 'sigalHealthInsuranceType'
 *   },
 * });
 */
export function useCreateTierMutation(baseOptions?: Apollo.MutationHookOptions<CreateTierMutation, CreateTierMutationVariables>) {
        return Apollo.useMutation<CreateTierMutation, CreateTierMutationVariables>(CreateTierDocument, baseOptions);
      }
export type CreateTierMutationHookResult = ReturnType<typeof useCreateTierMutation>;
export type CreateTierMutationResult = Apollo.MutationResult<CreateTierMutation>;
export type CreateTierMutationOptions = Apollo.BaseMutationOptions<CreateTierMutation, CreateTierMutationVariables>;
export const CreateUpdateAdvertisementDocument = gql`
    mutation CreateUpdateAdvertisement($position: AdvertisementPosition!, $isActive: Boolean!, $clickUrl: String, $mediaKey: String) {
  createUpdateAdvertisement(
    data: {position: $position, isActive: $isActive, clickUrl: $clickUrl, mediaKey: $mediaKey}
  ) {
    id
    position
    isActive
    clickUrl
    media {
      url
    }
    createdAt
    author {
      id
      email
      profileImage
      role
      profile {
        ... on SystemUserProfile {
          name
          lastname
        }
      }
    }
  }
}
    `;
export type CreateUpdateAdvertisementMutationFn = Apollo.MutationFunction<CreateUpdateAdvertisementMutation, CreateUpdateAdvertisementMutationVariables>;

/**
 * __useCreateUpdateAdvertisementMutation__
 *
 * To run a mutation, you first call `useCreateUpdateAdvertisementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateAdvertisementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateAdvertisementMutation, { data, loading, error }] = useCreateUpdateAdvertisementMutation({
 *   variables: {
 *      position: // value for 'position'
 *      isActive: // value for 'isActive'
 *      clickUrl: // value for 'clickUrl'
 *      mediaKey: // value for 'mediaKey'
 *   },
 * });
 */
export function useCreateUpdateAdvertisementMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateAdvertisementMutation, CreateUpdateAdvertisementMutationVariables>) {
        return Apollo.useMutation<CreateUpdateAdvertisementMutation, CreateUpdateAdvertisementMutationVariables>(CreateUpdateAdvertisementDocument, baseOptions);
      }
export type CreateUpdateAdvertisementMutationHookResult = ReturnType<typeof useCreateUpdateAdvertisementMutation>;
export type CreateUpdateAdvertisementMutationResult = Apollo.MutationResult<CreateUpdateAdvertisementMutation>;
export type CreateUpdateAdvertisementMutationOptions = Apollo.BaseMutationOptions<CreateUpdateAdvertisementMutation, CreateUpdateAdvertisementMutationVariables>;
export const DeleteAdminDocument = gql`
    mutation DeleteAdmin($id: Int!) {
  deleteAdmin(id: $id) {
    id
  }
}
    `;
export type DeleteAdminMutationFn = Apollo.MutationFunction<DeleteAdminMutation, DeleteAdminMutationVariables>;

/**
 * __useDeleteAdminMutation__
 *
 * To run a mutation, you first call `useDeleteAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdminMutation, { data, loading, error }] = useDeleteAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdminMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdminMutation, DeleteAdminMutationVariables>) {
        return Apollo.useMutation<DeleteAdminMutation, DeleteAdminMutationVariables>(DeleteAdminDocument, baseOptions);
      }
export type DeleteAdminMutationHookResult = ReturnType<typeof useDeleteAdminMutation>;
export type DeleteAdminMutationResult = Apollo.MutationResult<DeleteAdminMutation>;
export type DeleteAdminMutationOptions = Apollo.BaseMutationOptions<DeleteAdminMutation, DeleteAdminMutationVariables>;
export const DeleteArticleDocument = gql`
    mutation DeleteArticle($id: Int!) {
  deleteArticle(id: $id) {
    id
  }
}
    `;
export type DeleteArticleMutationFn = Apollo.MutationFunction<DeleteArticleMutation, DeleteArticleMutationVariables>;

/**
 * __useDeleteArticleMutation__
 *
 * To run a mutation, you first call `useDeleteArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArticleMutation, { data, loading, error }] = useDeleteArticleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteArticleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteArticleMutation, DeleteArticleMutationVariables>) {
        return Apollo.useMutation<DeleteArticleMutation, DeleteArticleMutationVariables>(DeleteArticleDocument, baseOptions);
      }
export type DeleteArticleMutationHookResult = ReturnType<typeof useDeleteArticleMutation>;
export type DeleteArticleMutationResult = Apollo.MutationResult<DeleteArticleMutation>;
export type DeleteArticleMutationOptions = Apollo.BaseMutationOptions<DeleteArticleMutation, DeleteArticleMutationVariables>;
export const DeleteAuthorDocument = gql`
    mutation DeleteAuthor($id: Int!) {
  deleteAuthor(id: $id) {
    id
  }
}
    `;
export type DeleteAuthorMutationFn = Apollo.MutationFunction<DeleteAuthorMutation, DeleteAuthorMutationVariables>;

/**
 * __useDeleteAuthorMutation__
 *
 * To run a mutation, you first call `useDeleteAuthorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAuthorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAuthorMutation, { data, loading, error }] = useDeleteAuthorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAuthorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAuthorMutation, DeleteAuthorMutationVariables>) {
        return Apollo.useMutation<DeleteAuthorMutation, DeleteAuthorMutationVariables>(DeleteAuthorDocument, baseOptions);
      }
export type DeleteAuthorMutationHookResult = ReturnType<typeof useDeleteAuthorMutation>;
export type DeleteAuthorMutationResult = Apollo.MutationResult<DeleteAuthorMutation>;
export type DeleteAuthorMutationOptions = Apollo.BaseMutationOptions<DeleteAuthorMutation, DeleteAuthorMutationVariables>;
export const DeleteBenefitDocument = gql`
    mutation DeleteBenefit($id: Int!) {
  deleteBenefit(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteBenefitMutationFn = Apollo.MutationFunction<DeleteBenefitMutation, DeleteBenefitMutationVariables>;

/**
 * __useDeleteBenefitMutation__
 *
 * To run a mutation, you first call `useDeleteBenefitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBenefitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBenefitMutation, { data, loading, error }] = useDeleteBenefitMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBenefitMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBenefitMutation, DeleteBenefitMutationVariables>) {
        return Apollo.useMutation<DeleteBenefitMutation, DeleteBenefitMutationVariables>(DeleteBenefitDocument, baseOptions);
      }
export type DeleteBenefitMutationHookResult = ReturnType<typeof useDeleteBenefitMutation>;
export type DeleteBenefitMutationResult = Apollo.MutationResult<DeleteBenefitMutation>;
export type DeleteBenefitMutationOptions = Apollo.BaseMutationOptions<DeleteBenefitMutation, DeleteBenefitMutationVariables>;
export const DeleteCityDocument = gql`
    mutation DeleteCity($id: Int!) {
  deleteCity(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteCityMutationFn = Apollo.MutationFunction<DeleteCityMutation, DeleteCityMutationVariables>;

/**
 * __useDeleteCityMutation__
 *
 * To run a mutation, you first call `useDeleteCityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCityMutation, { data, loading, error }] = useDeleteCityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCityMutation, DeleteCityMutationVariables>) {
        return Apollo.useMutation<DeleteCityMutation, DeleteCityMutationVariables>(DeleteCityDocument, baseOptions);
      }
export type DeleteCityMutationHookResult = ReturnType<typeof useDeleteCityMutation>;
export type DeleteCityMutationResult = Apollo.MutationResult<DeleteCityMutation>;
export type DeleteCityMutationOptions = Apollo.BaseMutationOptions<DeleteCityMutation, DeleteCityMutationVariables>;
export const DeleteCountryDocument = gql`
    mutation DeleteCountry($id: Int!) {
  deleteCountry(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteCountryMutationFn = Apollo.MutationFunction<DeleteCountryMutation, DeleteCountryMutationVariables>;

/**
 * __useDeleteCountryMutation__
 *
 * To run a mutation, you first call `useDeleteCountryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCountryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCountryMutation, { data, loading, error }] = useDeleteCountryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCountryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCountryMutation, DeleteCountryMutationVariables>) {
        return Apollo.useMutation<DeleteCountryMutation, DeleteCountryMutationVariables>(DeleteCountryDocument, baseOptions);
      }
export type DeleteCountryMutationHookResult = ReturnType<typeof useDeleteCountryMutation>;
export type DeleteCountryMutationResult = Apollo.MutationResult<DeleteCountryMutation>;
export type DeleteCountryMutationOptions = Apollo.BaseMutationOptions<DeleteCountryMutation, DeleteCountryMutationVariables>;
export const DeleteDoctorRequestDocument = gql`
    mutation DeleteDoctorRequest($id: Int!) {
  deleteDoctorRequest(id: $id) {
    id
  }
}
    `;
export type DeleteDoctorRequestMutationFn = Apollo.MutationFunction<DeleteDoctorRequestMutation, DeleteDoctorRequestMutationVariables>;

/**
 * __useDeleteDoctorRequestMutation__
 *
 * To run a mutation, you first call `useDeleteDoctorRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDoctorRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDoctorRequestMutation, { data, loading, error }] = useDeleteDoctorRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDoctorRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDoctorRequestMutation, DeleteDoctorRequestMutationVariables>) {
        return Apollo.useMutation<DeleteDoctorRequestMutation, DeleteDoctorRequestMutationVariables>(DeleteDoctorRequestDocument, baseOptions);
      }
export type DeleteDoctorRequestMutationHookResult = ReturnType<typeof useDeleteDoctorRequestMutation>;
export type DeleteDoctorRequestMutationResult = Apollo.MutationResult<DeleteDoctorRequestMutation>;
export type DeleteDoctorRequestMutationOptions = Apollo.BaseMutationOptions<DeleteDoctorRequestMutation, DeleteDoctorRequestMutationVariables>;
export const DeleteDocumentCommentDocument = gql`
    mutation DeleteDocumentComment($id: Int!) {
  deleteDocumentComment(id: $id) {
    id
    author {
      ...ShortAccountData
    }
    content
    createdAt
    updatedAt
  }
}
    ${ShortAccountDataFragmentDoc}`;
export type DeleteDocumentCommentMutationFn = Apollo.MutationFunction<DeleteDocumentCommentMutation, DeleteDocumentCommentMutationVariables>;

/**
 * __useDeleteDocumentCommentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentCommentMutation, { data, loading, error }] = useDeleteDocumentCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocumentCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocumentCommentMutation, DeleteDocumentCommentMutationVariables>) {
        return Apollo.useMutation<DeleteDocumentCommentMutation, DeleteDocumentCommentMutationVariables>(DeleteDocumentCommentDocument, baseOptions);
      }
export type DeleteDocumentCommentMutationHookResult = ReturnType<typeof useDeleteDocumentCommentMutation>;
export type DeleteDocumentCommentMutationResult = Apollo.MutationResult<DeleteDocumentCommentMutation>;
export type DeleteDocumentCommentMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentCommentMutation, DeleteDocumentCommentMutationVariables>;
export const DeleteDocumentFromMedicalCardDocument = gql`
    mutation DeleteDocumentFromMedicalCard($id: Int!) {
  deleteDocumentFromMedicalCard(id: $id) {
    id
    author {
      ...ShortAccountData
    }
    thumbnail: media(size: MEDIUM) {
      url
      contentType
    }
    media {
      url
      contentType
    }
    description
  }
}
    ${ShortAccountDataFragmentDoc}`;
export type DeleteDocumentFromMedicalCardMutationFn = Apollo.MutationFunction<DeleteDocumentFromMedicalCardMutation, DeleteDocumentFromMedicalCardMutationVariables>;

/**
 * __useDeleteDocumentFromMedicalCardMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentFromMedicalCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentFromMedicalCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentFromMedicalCardMutation, { data, loading, error }] = useDeleteDocumentFromMedicalCardMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocumentFromMedicalCardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocumentFromMedicalCardMutation, DeleteDocumentFromMedicalCardMutationVariables>) {
        return Apollo.useMutation<DeleteDocumentFromMedicalCardMutation, DeleteDocumentFromMedicalCardMutationVariables>(DeleteDocumentFromMedicalCardDocument, baseOptions);
      }
export type DeleteDocumentFromMedicalCardMutationHookResult = ReturnType<typeof useDeleteDocumentFromMedicalCardMutation>;
export type DeleteDocumentFromMedicalCardMutationResult = Apollo.MutationResult<DeleteDocumentFromMedicalCardMutation>;
export type DeleteDocumentFromMedicalCardMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentFromMedicalCardMutation, DeleteDocumentFromMedicalCardMutationVariables>;
export const DeleteEventDocument = gql`
    mutation DeleteEvent($id: Int!) {
  deleteEvent(id: $id) {
    id
  }
}
    `;
export type DeleteEventMutationFn = Apollo.MutationFunction<DeleteEventMutation, DeleteEventMutationVariables>;

/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventMutation, { data, loading, error }] = useDeleteEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventMutation, DeleteEventMutationVariables>) {
        return Apollo.useMutation<DeleteEventMutation, DeleteEventMutationVariables>(DeleteEventDocument, baseOptions);
      }
export type DeleteEventMutationHookResult = ReturnType<typeof useDeleteEventMutation>;
export type DeleteEventMutationResult = Apollo.MutationResult<DeleteEventMutation>;
export type DeleteEventMutationOptions = Apollo.BaseMutationOptions<DeleteEventMutation, DeleteEventMutationVariables>;
export const DeleteFaqDocument = gql`
    mutation DeleteFaq($id: Int!) {
  deleteFaq(id: $id) {
    id
    title
    rawTitle {
      sq
      en
      mk
    }
    body
    rawBody {
      sq
      en
      mk
    }
  }
}
    `;
export type DeleteFaqMutationFn = Apollo.MutationFunction<DeleteFaqMutation, DeleteFaqMutationVariables>;

/**
 * __useDeleteFaqMutation__
 *
 * To run a mutation, you first call `useDeleteFaqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFaqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFaqMutation, { data, loading, error }] = useDeleteFaqMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFaqMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFaqMutation, DeleteFaqMutationVariables>) {
        return Apollo.useMutation<DeleteFaqMutation, DeleteFaqMutationVariables>(DeleteFaqDocument, baseOptions);
      }
export type DeleteFaqMutationHookResult = ReturnType<typeof useDeleteFaqMutation>;
export type DeleteFaqMutationResult = Apollo.MutationResult<DeleteFaqMutation>;
export type DeleteFaqMutationOptions = Apollo.BaseMutationOptions<DeleteFaqMutation, DeleteFaqMutationVariables>;
export const DeleteFcmTokenDocument = gql`
    mutation DeleteFcmToken {
  deleteFcmToken(where: {device: WEB}) {
    id
  }
}
    `;
export type DeleteFcmTokenMutationFn = Apollo.MutationFunction<DeleteFcmTokenMutation, DeleteFcmTokenMutationVariables>;

/**
 * __useDeleteFcmTokenMutation__
 *
 * To run a mutation, you first call `useDeleteFcmTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFcmTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFcmTokenMutation, { data, loading, error }] = useDeleteFcmTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteFcmTokenMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFcmTokenMutation, DeleteFcmTokenMutationVariables>) {
        return Apollo.useMutation<DeleteFcmTokenMutation, DeleteFcmTokenMutationVariables>(DeleteFcmTokenDocument, baseOptions);
      }
export type DeleteFcmTokenMutationHookResult = ReturnType<typeof useDeleteFcmTokenMutation>;
export type DeleteFcmTokenMutationResult = Apollo.MutationResult<DeleteFcmTokenMutation>;
export type DeleteFcmTokenMutationOptions = Apollo.BaseMutationOptions<DeleteFcmTokenMutation, DeleteFcmTokenMutationVariables>;
export const DeleteHealthCenterDocument = gql`
    mutation DeleteHealthCenter($id: Int!) {
  deleteHealthCenter(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteHealthCenterMutationFn = Apollo.MutationFunction<DeleteHealthCenterMutation, DeleteHealthCenterMutationVariables>;

/**
 * __useDeleteHealthCenterMutation__
 *
 * To run a mutation, you first call `useDeleteHealthCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHealthCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHealthCenterMutation, { data, loading, error }] = useDeleteHealthCenterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteHealthCenterMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHealthCenterMutation, DeleteHealthCenterMutationVariables>) {
        return Apollo.useMutation<DeleteHealthCenterMutation, DeleteHealthCenterMutationVariables>(DeleteHealthCenterDocument, baseOptions);
      }
export type DeleteHealthCenterMutationHookResult = ReturnType<typeof useDeleteHealthCenterMutation>;
export type DeleteHealthCenterMutationResult = Apollo.MutationResult<DeleteHealthCenterMutation>;
export type DeleteHealthCenterMutationOptions = Apollo.BaseMutationOptions<DeleteHealthCenterMutation, DeleteHealthCenterMutationVariables>;
export const DeleteInsurancePolicyDocument = gql`
    mutation DeleteInsurancePolicy($id: Int!) {
  deleteInsurancePolicy(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteInsurancePolicyMutationFn = Apollo.MutationFunction<DeleteInsurancePolicyMutation, DeleteInsurancePolicyMutationVariables>;

/**
 * __useDeleteInsurancePolicyMutation__
 *
 * To run a mutation, you first call `useDeleteInsurancePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInsurancePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInsurancePolicyMutation, { data, loading, error }] = useDeleteInsurancePolicyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInsurancePolicyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInsurancePolicyMutation, DeleteInsurancePolicyMutationVariables>) {
        return Apollo.useMutation<DeleteInsurancePolicyMutation, DeleteInsurancePolicyMutationVariables>(DeleteInsurancePolicyDocument, baseOptions);
      }
export type DeleteInsurancePolicyMutationHookResult = ReturnType<typeof useDeleteInsurancePolicyMutation>;
export type DeleteInsurancePolicyMutationResult = Apollo.MutationResult<DeleteInsurancePolicyMutation>;
export type DeleteInsurancePolicyMutationOptions = Apollo.BaseMutationOptions<DeleteInsurancePolicyMutation, DeleteInsurancePolicyMutationVariables>;
export const DeleteMediaLibraryItemDocument = gql`
    mutation DeleteMediaLibraryItem($id: Int!) {
  deleteMediaLibraryItem(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteMediaLibraryItemMutationFn = Apollo.MutationFunction<DeleteMediaLibraryItemMutation, DeleteMediaLibraryItemMutationVariables>;

/**
 * __useDeleteMediaLibraryItemMutation__
 *
 * To run a mutation, you first call `useDeleteMediaLibraryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMediaLibraryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMediaLibraryItemMutation, { data, loading, error }] = useDeleteMediaLibraryItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMediaLibraryItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMediaLibraryItemMutation, DeleteMediaLibraryItemMutationVariables>) {
        return Apollo.useMutation<DeleteMediaLibraryItemMutation, DeleteMediaLibraryItemMutationVariables>(DeleteMediaLibraryItemDocument, baseOptions);
      }
export type DeleteMediaLibraryItemMutationHookResult = ReturnType<typeof useDeleteMediaLibraryItemMutation>;
export type DeleteMediaLibraryItemMutationResult = Apollo.MutationResult<DeleteMediaLibraryItemMutation>;
export type DeleteMediaLibraryItemMutationOptions = Apollo.BaseMutationOptions<DeleteMediaLibraryItemMutation, DeleteMediaLibraryItemMutationVariables>;
export const DeleteMedicalCardCommentDocument = gql`
    mutation DeleteMedicalCardComment($id: Int!) {
  deleteMedicalCardComment(id: $id) {
    id
  }
}
    `;
export type DeleteMedicalCardCommentMutationFn = Apollo.MutationFunction<DeleteMedicalCardCommentMutation, DeleteMedicalCardCommentMutationVariables>;

/**
 * __useDeleteMedicalCardCommentMutation__
 *
 * To run a mutation, you first call `useDeleteMedicalCardCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMedicalCardCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMedicalCardCommentMutation, { data, loading, error }] = useDeleteMedicalCardCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMedicalCardCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMedicalCardCommentMutation, DeleteMedicalCardCommentMutationVariables>) {
        return Apollo.useMutation<DeleteMedicalCardCommentMutation, DeleteMedicalCardCommentMutationVariables>(DeleteMedicalCardCommentDocument, baseOptions);
      }
export type DeleteMedicalCardCommentMutationHookResult = ReturnType<typeof useDeleteMedicalCardCommentMutation>;
export type DeleteMedicalCardCommentMutationResult = Apollo.MutationResult<DeleteMedicalCardCommentMutation>;
export type DeleteMedicalCardCommentMutationOptions = Apollo.BaseMutationOptions<DeleteMedicalCardCommentMutation, DeleteMedicalCardCommentMutationVariables>;
export const DeleteMedicalConcernCategoryDocument = gql`
    mutation DeleteMedicalConcernCategory($id: Int!) {
  deleteMedicalConcernCategory(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteMedicalConcernCategoryMutationFn = Apollo.MutationFunction<DeleteMedicalConcernCategoryMutation, DeleteMedicalConcernCategoryMutationVariables>;

/**
 * __useDeleteMedicalConcernCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteMedicalConcernCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMedicalConcernCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMedicalConcernCategoryMutation, { data, loading, error }] = useDeleteMedicalConcernCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMedicalConcernCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMedicalConcernCategoryMutation, DeleteMedicalConcernCategoryMutationVariables>) {
        return Apollo.useMutation<DeleteMedicalConcernCategoryMutation, DeleteMedicalConcernCategoryMutationVariables>(DeleteMedicalConcernCategoryDocument, baseOptions);
      }
export type DeleteMedicalConcernCategoryMutationHookResult = ReturnType<typeof useDeleteMedicalConcernCategoryMutation>;
export type DeleteMedicalConcernCategoryMutationResult = Apollo.MutationResult<DeleteMedicalConcernCategoryMutation>;
export type DeleteMedicalConcernCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteMedicalConcernCategoryMutation, DeleteMedicalConcernCategoryMutationVariables>;
export const DeleteSpecialityDocument = gql`
    mutation DeleteSpeciality($id: Int!) {
  deleteSpeciality(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteSpecialityMutationFn = Apollo.MutationFunction<DeleteSpecialityMutation, DeleteSpecialityMutationVariables>;

/**
 * __useDeleteSpecialityMutation__
 *
 * To run a mutation, you first call `useDeleteSpecialityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpecialityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpecialityMutation, { data, loading, error }] = useDeleteSpecialityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSpecialityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSpecialityMutation, DeleteSpecialityMutationVariables>) {
        return Apollo.useMutation<DeleteSpecialityMutation, DeleteSpecialityMutationVariables>(DeleteSpecialityDocument, baseOptions);
      }
export type DeleteSpecialityMutationHookResult = ReturnType<typeof useDeleteSpecialityMutation>;
export type DeleteSpecialityMutationResult = Apollo.MutationResult<DeleteSpecialityMutation>;
export type DeleteSpecialityMutationOptions = Apollo.BaseMutationOptions<DeleteSpecialityMutation, DeleteSpecialityMutationVariables>;
export const DeleteStoryItemDocument = gql`
    mutation DeleteStoryItem($id: Int!) {
  deleteStoryItem(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteStoryItemMutationFn = Apollo.MutationFunction<DeleteStoryItemMutation, DeleteStoryItemMutationVariables>;

/**
 * __useDeleteStoryItemMutation__
 *
 * To run a mutation, you first call `useDeleteStoryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStoryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStoryItemMutation, { data, loading, error }] = useDeleteStoryItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStoryItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStoryItemMutation, DeleteStoryItemMutationVariables>) {
        return Apollo.useMutation<DeleteStoryItemMutation, DeleteStoryItemMutationVariables>(DeleteStoryItemDocument, baseOptions);
      }
export type DeleteStoryItemMutationHookResult = ReturnType<typeof useDeleteStoryItemMutation>;
export type DeleteStoryItemMutationResult = Apollo.MutationResult<DeleteStoryItemMutation>;
export type DeleteStoryItemMutationOptions = Apollo.BaseMutationOptions<DeleteStoryItemMutation, DeleteStoryItemMutationVariables>;
export const DeleteStoryDocument = gql`
    mutation DeleteStory($id: Int!) {
  deleteStory(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteStoryMutationFn = Apollo.MutationFunction<DeleteStoryMutation, DeleteStoryMutationVariables>;

/**
 * __useDeleteStoryMutation__
 *
 * To run a mutation, you first call `useDeleteStoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStoryMutation, { data, loading, error }] = useDeleteStoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStoryMutation, DeleteStoryMutationVariables>) {
        return Apollo.useMutation<DeleteStoryMutation, DeleteStoryMutationVariables>(DeleteStoryDocument, baseOptions);
      }
export type DeleteStoryMutationHookResult = ReturnType<typeof useDeleteStoryMutation>;
export type DeleteStoryMutationResult = Apollo.MutationResult<DeleteStoryMutation>;
export type DeleteStoryMutationOptions = Apollo.BaseMutationOptions<DeleteStoryMutation, DeleteStoryMutationVariables>;
export const DeleteSubscriptionsThatNeedReviewDocument = gql`
    mutation DeleteSubscriptionsThatNeedReview($id: Int!) {
  deleteSubscriptionsThatNeedReview(id: $id) {
    id
  }
}
    `;
export type DeleteSubscriptionsThatNeedReviewMutationFn = Apollo.MutationFunction<DeleteSubscriptionsThatNeedReviewMutation, DeleteSubscriptionsThatNeedReviewMutationVariables>;

/**
 * __useDeleteSubscriptionsThatNeedReviewMutation__
 *
 * To run a mutation, you first call `useDeleteSubscriptionsThatNeedReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubscriptionsThatNeedReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubscriptionsThatNeedReviewMutation, { data, loading, error }] = useDeleteSubscriptionsThatNeedReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSubscriptionsThatNeedReviewMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubscriptionsThatNeedReviewMutation, DeleteSubscriptionsThatNeedReviewMutationVariables>) {
        return Apollo.useMutation<DeleteSubscriptionsThatNeedReviewMutation, DeleteSubscriptionsThatNeedReviewMutationVariables>(DeleteSubscriptionsThatNeedReviewDocument, baseOptions);
      }
export type DeleteSubscriptionsThatNeedReviewMutationHookResult = ReturnType<typeof useDeleteSubscriptionsThatNeedReviewMutation>;
export type DeleteSubscriptionsThatNeedReviewMutationResult = Apollo.MutationResult<DeleteSubscriptionsThatNeedReviewMutation>;
export type DeleteSubscriptionsThatNeedReviewMutationOptions = Apollo.BaseMutationOptions<DeleteSubscriptionsThatNeedReviewMutation, DeleteSubscriptionsThatNeedReviewMutationVariables>;
export const DeleteTierDocument = gql`
    mutation DeleteTier($id: Int!) {
  deleteTier(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteTierMutationFn = Apollo.MutationFunction<DeleteTierMutation, DeleteTierMutationVariables>;

/**
 * __useDeleteTierMutation__
 *
 * To run a mutation, you first call `useDeleteTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTierMutation, { data, loading, error }] = useDeleteTierMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTierMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTierMutation, DeleteTierMutationVariables>) {
        return Apollo.useMutation<DeleteTierMutation, DeleteTierMutationVariables>(DeleteTierDocument, baseOptions);
      }
export type DeleteTierMutationHookResult = ReturnType<typeof useDeleteTierMutation>;
export type DeleteTierMutationResult = Apollo.MutationResult<DeleteTierMutation>;
export type DeleteTierMutationOptions = Apollo.BaseMutationOptions<DeleteTierMutation, DeleteTierMutationVariables>;
export const DoctorSignupDocument = gql`
    mutation DoctorSignup($email: String!, $password: String!, $phoneNumber: String!, $name: String!, $lastname: String!, $birthday: Date!, $sex: Gender!, $licenceNumber: String!, $bio: String, $cityId: Int!, $countryId: Int!, $healthCenterId: Int!, $languageCode: LanguageCode!) {
  doctorSignup(
    data: {email: $email, password: $password, phoneNumber: $phoneNumber, name: $name, lastname: $lastname, birthday: $birthday, sex: $sex, licenceNumber: $licenceNumber, bio: $bio, cityId: $cityId, countryId: $countryId, healthCenterId: $healthCenterId, languageCode: $languageCode}
  ) {
    token
  }
}
    `;
export type DoctorSignupMutationFn = Apollo.MutationFunction<DoctorSignupMutation, DoctorSignupMutationVariables>;

/**
 * __useDoctorSignupMutation__
 *
 * To run a mutation, you first call `useDoctorSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorSignupMutation, { data, loading, error }] = useDoctorSignupMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      phoneNumber: // value for 'phoneNumber'
 *      name: // value for 'name'
 *      lastname: // value for 'lastname'
 *      birthday: // value for 'birthday'
 *      sex: // value for 'sex'
 *      licenceNumber: // value for 'licenceNumber'
 *      bio: // value for 'bio'
 *      cityId: // value for 'cityId'
 *      countryId: // value for 'countryId'
 *      healthCenterId: // value for 'healthCenterId'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useDoctorSignupMutation(baseOptions?: Apollo.MutationHookOptions<DoctorSignupMutation, DoctorSignupMutationVariables>) {
        return Apollo.useMutation<DoctorSignupMutation, DoctorSignupMutationVariables>(DoctorSignupDocument, baseOptions);
      }
export type DoctorSignupMutationHookResult = ReturnType<typeof useDoctorSignupMutation>;
export type DoctorSignupMutationResult = Apollo.MutationResult<DoctorSignupMutation>;
export type DoctorSignupMutationOptions = Apollo.BaseMutationOptions<DoctorSignupMutation, DoctorSignupMutationVariables>;
export const SpecialistSignupDocument = gql`
    mutation SpecialistSignup($email: String!, $password: String!, $phoneNumber: String!, $name: String!, $lastname: String!, $birthday: Date!, $sex: Gender!, $licenceNumber: String!, $bio: String, $cityId: Int!, $countryId: Int!, $healthCenterId: Int!, $languageCode: LanguageCode!, $specialityId: Int!) {
  specialistSignup(
    data: {email: $email, password: $password, phoneNumber: $phoneNumber, name: $name, lastname: $lastname, birthday: $birthday, sex: $sex, licenceNumber: $licenceNumber, bio: $bio, cityId: $cityId, countryId: $countryId, healthCenterId: $healthCenterId, languageCode: $languageCode, specialityId: $specialityId}
  ) {
    token
  }
}
    `;
export type SpecialistSignupMutationFn = Apollo.MutationFunction<SpecialistSignupMutation, SpecialistSignupMutationVariables>;

/**
 * __useSpecialistSignupMutation__
 *
 * To run a mutation, you first call `useSpecialistSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSpecialistSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [specialistSignupMutation, { data, loading, error }] = useSpecialistSignupMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      phoneNumber: // value for 'phoneNumber'
 *      name: // value for 'name'
 *      lastname: // value for 'lastname'
 *      birthday: // value for 'birthday'
 *      sex: // value for 'sex'
 *      licenceNumber: // value for 'licenceNumber'
 *      bio: // value for 'bio'
 *      cityId: // value for 'cityId'
 *      countryId: // value for 'countryId'
 *      healthCenterId: // value for 'healthCenterId'
 *      languageCode: // value for 'languageCode'
 *      specialityId: // value for 'specialityId'
 *   },
 * });
 */
export function useSpecialistSignupMutation(baseOptions?: Apollo.MutationHookOptions<SpecialistSignupMutation, SpecialistSignupMutationVariables>) {
        return Apollo.useMutation<SpecialistSignupMutation, SpecialistSignupMutationVariables>(SpecialistSignupDocument, baseOptions);
      }
export type SpecialistSignupMutationHookResult = ReturnType<typeof useSpecialistSignupMutation>;
export type SpecialistSignupMutationResult = Apollo.MutationResult<SpecialistSignupMutation>;
export type SpecialistSignupMutationOptions = Apollo.BaseMutationOptions<SpecialistSignupMutation, SpecialistSignupMutationVariables>;
export const GenerateMedicalCardPdfDocument = gql`
    mutation GenerateMedicalCardPDF($medicalCardId: Int!) {
  generateMedicalCardPDF(id: $medicalCardId) {
    url
  }
}
    `;
export type GenerateMedicalCardPdfMutationFn = Apollo.MutationFunction<GenerateMedicalCardPdfMutation, GenerateMedicalCardPdfMutationVariables>;

/**
 * __useGenerateMedicalCardPdfMutation__
 *
 * To run a mutation, you first call `useGenerateMedicalCardPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMedicalCardPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMedicalCardPdfMutation, { data, loading, error }] = useGenerateMedicalCardPdfMutation({
 *   variables: {
 *      medicalCardId: // value for 'medicalCardId'
 *   },
 * });
 */
export function useGenerateMedicalCardPdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateMedicalCardPdfMutation, GenerateMedicalCardPdfMutationVariables>) {
        return Apollo.useMutation<GenerateMedicalCardPdfMutation, GenerateMedicalCardPdfMutationVariables>(GenerateMedicalCardPdfDocument, baseOptions);
      }
export type GenerateMedicalCardPdfMutationHookResult = ReturnType<typeof useGenerateMedicalCardPdfMutation>;
export type GenerateMedicalCardPdfMutationResult = Apollo.MutationResult<GenerateMedicalCardPdfMutation>;
export type GenerateMedicalCardPdfMutationOptions = Apollo.BaseMutationOptions<GenerateMedicalCardPdfMutation, GenerateMedicalCardPdfMutationVariables>;
export const GenerateTierCodesDocument = gql`
    mutation GenerateTierCodes($tierIds: [Int]!, $type: TierCodeType!) {
  generateTierCodes(tierIds: $tierIds, type: $type)
}
    `;
export type GenerateTierCodesMutationFn = Apollo.MutationFunction<GenerateTierCodesMutation, GenerateTierCodesMutationVariables>;

/**
 * __useGenerateTierCodesMutation__
 *
 * To run a mutation, you first call `useGenerateTierCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTierCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTierCodesMutation, { data, loading, error }] = useGenerateTierCodesMutation({
 *   variables: {
 *      tierIds: // value for 'tierIds'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGenerateTierCodesMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTierCodesMutation, GenerateTierCodesMutationVariables>) {
        return Apollo.useMutation<GenerateTierCodesMutation, GenerateTierCodesMutationVariables>(GenerateTierCodesDocument, baseOptions);
      }
export type GenerateTierCodesMutationHookResult = ReturnType<typeof useGenerateTierCodesMutation>;
export type GenerateTierCodesMutationResult = Apollo.MutationResult<GenerateTierCodesMutation>;
export type GenerateTierCodesMutationOptions = Apollo.BaseMutationOptions<GenerateTierCodesMutation, GenerateTierCodesMutationVariables>;
export const GetRecipeEmailTextForMedicalCardDocument = gql`
    mutation GetRecipeEmailTextForMedicalCard($id: Int!) {
  getRecipeEmailTextForMedicalCard(id: $id)
}
    `;
export type GetRecipeEmailTextForMedicalCardMutationFn = Apollo.MutationFunction<GetRecipeEmailTextForMedicalCardMutation, GetRecipeEmailTextForMedicalCardMutationVariables>;

/**
 * __useGetRecipeEmailTextForMedicalCardMutation__
 *
 * To run a mutation, you first call `useGetRecipeEmailTextForMedicalCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetRecipeEmailTextForMedicalCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getRecipeEmailTextForMedicalCardMutation, { data, loading, error }] = useGetRecipeEmailTextForMedicalCardMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRecipeEmailTextForMedicalCardMutation(baseOptions?: Apollo.MutationHookOptions<GetRecipeEmailTextForMedicalCardMutation, GetRecipeEmailTextForMedicalCardMutationVariables>) {
        return Apollo.useMutation<GetRecipeEmailTextForMedicalCardMutation, GetRecipeEmailTextForMedicalCardMutationVariables>(GetRecipeEmailTextForMedicalCardDocument, baseOptions);
      }
export type GetRecipeEmailTextForMedicalCardMutationHookResult = ReturnType<typeof useGetRecipeEmailTextForMedicalCardMutation>;
export type GetRecipeEmailTextForMedicalCardMutationResult = Apollo.MutationResult<GetRecipeEmailTextForMedicalCardMutation>;
export type GetRecipeEmailTextForMedicalCardMutationOptions = Apollo.BaseMutationOptions<GetRecipeEmailTextForMedicalCardMutation, GetRecipeEmailTextForMedicalCardMutationVariables>;
export const InviteDocument = gql`
    mutation Invite($callId: Int!, $accountId: Int!) {
  inviteGuestInCall(data: {callId: $callId, accountId: $accountId}) {
    id
    participants {
      twilioToken
      id
      account {
        email
      }
      role
      status
      joinTime
    }
  }
}
    `;
export type InviteMutationFn = Apollo.MutationFunction<InviteMutation, InviteMutationVariables>;

/**
 * __useInviteMutation__
 *
 * To run a mutation, you first call `useInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteMutation, { data, loading, error }] = useInviteMutation({
 *   variables: {
 *      callId: // value for 'callId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useInviteMutation(baseOptions?: Apollo.MutationHookOptions<InviteMutation, InviteMutationVariables>) {
        return Apollo.useMutation<InviteMutation, InviteMutationVariables>(InviteDocument, baseOptions);
      }
export type InviteMutationHookResult = ReturnType<typeof useInviteMutation>;
export type InviteMutationResult = Apollo.MutationResult<InviteMutation>;
export type InviteMutationOptions = Apollo.BaseMutationOptions<InviteMutation, InviteMutationVariables>;
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!, $tfaCode: String) {
  login(data: {email: $email, password: $password, tfaCode: $tfaCode}) {
    token
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      tfaCode: // value for 'tfaCode'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, baseOptions);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const MoveStoryDownDocument = gql`
    mutation MoveStoryDown($id: Int!) {
  moveStoryDown(where: {id: $id})
}
    `;
export type MoveStoryDownMutationFn = Apollo.MutationFunction<MoveStoryDownMutation, MoveStoryDownMutationVariables>;

/**
 * __useMoveStoryDownMutation__
 *
 * To run a mutation, you first call `useMoveStoryDownMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveStoryDownMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveStoryDownMutation, { data, loading, error }] = useMoveStoryDownMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMoveStoryDownMutation(baseOptions?: Apollo.MutationHookOptions<MoveStoryDownMutation, MoveStoryDownMutationVariables>) {
        return Apollo.useMutation<MoveStoryDownMutation, MoveStoryDownMutationVariables>(MoveStoryDownDocument, baseOptions);
      }
export type MoveStoryDownMutationHookResult = ReturnType<typeof useMoveStoryDownMutation>;
export type MoveStoryDownMutationResult = Apollo.MutationResult<MoveStoryDownMutation>;
export type MoveStoryDownMutationOptions = Apollo.BaseMutationOptions<MoveStoryDownMutation, MoveStoryDownMutationVariables>;
export const MoveStoryUpDocument = gql`
    mutation MoveStoryUp($id: Int!) {
  moveStoryUp(where: {id: $id})
}
    `;
export type MoveStoryUpMutationFn = Apollo.MutationFunction<MoveStoryUpMutation, MoveStoryUpMutationVariables>;

/**
 * __useMoveStoryUpMutation__
 *
 * To run a mutation, you first call `useMoveStoryUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveStoryUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveStoryUpMutation, { data, loading, error }] = useMoveStoryUpMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMoveStoryUpMutation(baseOptions?: Apollo.MutationHookOptions<MoveStoryUpMutation, MoveStoryUpMutationVariables>) {
        return Apollo.useMutation<MoveStoryUpMutation, MoveStoryUpMutationVariables>(MoveStoryUpDocument, baseOptions);
      }
export type MoveStoryUpMutationHookResult = ReturnType<typeof useMoveStoryUpMutation>;
export type MoveStoryUpMutationResult = Apollo.MutationResult<MoveStoryUpMutation>;
export type MoveStoryUpMutationOptions = Apollo.BaseMutationOptions<MoveStoryUpMutation, MoveStoryUpMutationVariables>;
export const NotifyAllDocument = gql`
    mutation notifyAll($language: LanguageCode!, $title: String!, $body: String!, $role: AccountRole!, $externalURL: String) {
  notifyAll(
    data: {role: $role, language: $language, title: $title, body: $body, externalURL: $externalURL}
  ) {
    accounts
    devices
  }
}
    `;
export type NotifyAllMutationFn = Apollo.MutationFunction<NotifyAllMutation, NotifyAllMutationVariables>;

/**
 * __useNotifyAllMutation__
 *
 * To run a mutation, you first call `useNotifyAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyAllMutation, { data, loading, error }] = useNotifyAllMutation({
 *   variables: {
 *      language: // value for 'language'
 *      title: // value for 'title'
 *      body: // value for 'body'
 *      role: // value for 'role'
 *      externalURL: // value for 'externalURL'
 *   },
 * });
 */
export function useNotifyAllMutation(baseOptions?: Apollo.MutationHookOptions<NotifyAllMutation, NotifyAllMutationVariables>) {
        return Apollo.useMutation<NotifyAllMutation, NotifyAllMutationVariables>(NotifyAllDocument, baseOptions);
      }
export type NotifyAllMutationHookResult = ReturnType<typeof useNotifyAllMutation>;
export type NotifyAllMutationResult = Apollo.MutationResult<NotifyAllMutation>;
export type NotifyAllMutationOptions = Apollo.BaseMutationOptions<NotifyAllMutation, NotifyAllMutationVariables>;
export const PublishTierDocument = gql`
    mutation PublishTier($id: Int!) {
  publishTier(where: {id: $id}) {
    id
  }
}
    `;
export type PublishTierMutationFn = Apollo.MutationFunction<PublishTierMutation, PublishTierMutationVariables>;

/**
 * __usePublishTierMutation__
 *
 * To run a mutation, you first call `usePublishTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishTierMutation, { data, loading, error }] = usePublishTierMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishTierMutation(baseOptions?: Apollo.MutationHookOptions<PublishTierMutation, PublishTierMutationVariables>) {
        return Apollo.useMutation<PublishTierMutation, PublishTierMutationVariables>(PublishTierDocument, baseOptions);
      }
export type PublishTierMutationHookResult = ReturnType<typeof usePublishTierMutation>;
export type PublishTierMutationResult = Apollo.MutationResult<PublishTierMutation>;
export type PublishTierMutationOptions = Apollo.BaseMutationOptions<PublishTierMutation, PublishTierMutationVariables>;
export const RegisterFcmTokenDocument = gql`
    mutation RegisterFCMToken($token: String!) {
  registerFcmToken(data: {device: WEB, token: $token}) {
    id
    type
    fcmToken
    date
    account {
      email
    }
  }
}
    `;
export type RegisterFcmTokenMutationFn = Apollo.MutationFunction<RegisterFcmTokenMutation, RegisterFcmTokenMutationVariables>;

/**
 * __useRegisterFcmTokenMutation__
 *
 * To run a mutation, you first call `useRegisterFcmTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterFcmTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerFcmTokenMutation, { data, loading, error }] = useRegisterFcmTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRegisterFcmTokenMutation(baseOptions?: Apollo.MutationHookOptions<RegisterFcmTokenMutation, RegisterFcmTokenMutationVariables>) {
        return Apollo.useMutation<RegisterFcmTokenMutation, RegisterFcmTokenMutationVariables>(RegisterFcmTokenDocument, baseOptions);
      }
export type RegisterFcmTokenMutationHookResult = ReturnType<typeof useRegisterFcmTokenMutation>;
export type RegisterFcmTokenMutationResult = Apollo.MutationResult<RegisterFcmTokenMutation>;
export type RegisterFcmTokenMutationOptions = Apollo.BaseMutationOptions<RegisterFcmTokenMutation, RegisterFcmTokenMutationVariables>;
export const RequestCallForEventDocument = gql`
    mutation RequestCallForEvent($id: Int!) {
  requestCallForEvent(id: $id) {
    waitingQueueCount
    call {
      id
      participants {
        twilioToken
        id
        role
        status
        account {
          email
        }
        joinTime
      }
      requestTime
      status
    }
  }
}
    `;
export type RequestCallForEventMutationFn = Apollo.MutationFunction<RequestCallForEventMutation, RequestCallForEventMutationVariables>;

/**
 * __useRequestCallForEventMutation__
 *
 * To run a mutation, you first call `useRequestCallForEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCallForEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCallForEventMutation, { data, loading, error }] = useRequestCallForEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRequestCallForEventMutation(baseOptions?: Apollo.MutationHookOptions<RequestCallForEventMutation, RequestCallForEventMutationVariables>) {
        return Apollo.useMutation<RequestCallForEventMutation, RequestCallForEventMutationVariables>(RequestCallForEventDocument, baseOptions);
      }
export type RequestCallForEventMutationHookResult = ReturnType<typeof useRequestCallForEventMutation>;
export type RequestCallForEventMutationResult = Apollo.MutationResult<RequestCallForEventMutation>;
export type RequestCallForEventMutationOptions = Apollo.BaseMutationOptions<RequestCallForEventMutation, RequestCallForEventMutationVariables>;
export const RequestCallDocument = gql`
    mutation RequestCall {
  requestCall {
    waitingQueueCount
    call {
      id
      participants {
        twilioToken
        id
        role
        status
        account {
          email
        }
        joinTime
      }
      requestTime
      status
    }
  }
}
    `;
export type RequestCallMutationFn = Apollo.MutationFunction<RequestCallMutation, RequestCallMutationVariables>;

/**
 * __useRequestCallMutation__
 *
 * To run a mutation, you first call `useRequestCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCallMutation, { data, loading, error }] = useRequestCallMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestCallMutation(baseOptions?: Apollo.MutationHookOptions<RequestCallMutation, RequestCallMutationVariables>) {
        return Apollo.useMutation<RequestCallMutation, RequestCallMutationVariables>(RequestCallDocument, baseOptions);
      }
export type RequestCallMutationHookResult = ReturnType<typeof useRequestCallMutation>;
export type RequestCallMutationResult = Apollo.MutationResult<RequestCallMutation>;
export type RequestCallMutationOptions = Apollo.BaseMutationOptions<RequestCallMutation, RequestCallMutationVariables>;
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($email: String!) {
  requestPasswordReset(data: {email: $email})
}
    `;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>) {
        return Apollo.useMutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, baseOptions);
      }
export type RequestPasswordResetMutationHookResult = ReturnType<typeof useRequestPasswordResetMutation>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($email: String!, $verificationCode: String!, $password: String!) {
  resetPassword(
    data: {email: $email, verificationCode: $verificationCode, password: $password}
  ) {
    id
    email
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      verificationCode: // value for 'verificationCode'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, baseOptions);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SetAccountProfilePictureDocument = gql`
    mutation SetAccountProfilePicture($key: String!, $contentType: String!) {
  setAccountProfilePicture(data: {create: {key: $key, contentType: $contentType}}) {
    id
    profileImage(size: THUMBNAIL)
  }
}
    `;
export type SetAccountProfilePictureMutationFn = Apollo.MutationFunction<SetAccountProfilePictureMutation, SetAccountProfilePictureMutationVariables>;

/**
 * __useSetAccountProfilePictureMutation__
 *
 * To run a mutation, you first call `useSetAccountProfilePictureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAccountProfilePictureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAccountProfilePictureMutation, { data, loading, error }] = useSetAccountProfilePictureMutation({
 *   variables: {
 *      key: // value for 'key'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useSetAccountProfilePictureMutation(baseOptions?: Apollo.MutationHookOptions<SetAccountProfilePictureMutation, SetAccountProfilePictureMutationVariables>) {
        return Apollo.useMutation<SetAccountProfilePictureMutation, SetAccountProfilePictureMutationVariables>(SetAccountProfilePictureDocument, baseOptions);
      }
export type SetAccountProfilePictureMutationHookResult = ReturnType<typeof useSetAccountProfilePictureMutation>;
export type SetAccountProfilePictureMutationResult = Apollo.MutationResult<SetAccountProfilePictureMutation>;
export type SetAccountProfilePictureMutationOptions = Apollo.BaseMutationOptions<SetAccountProfilePictureMutation, SetAccountProfilePictureMutationVariables>;
export const TemporaryBlockDocument = gql`
    mutation TemporaryBlock($id: Int!, $hours: Int!, $reason: String!) {
  temporaryBlock(data: {accountId: $id, hours: $hours, reason: $reason}) {
    id
    author {
      ...ShortAccountDataFragment
    }
    reason
    validUntil
    createdAt
  }
}
    ${ShortAccountDataFragmentFragmentDoc}`;
export type TemporaryBlockMutationFn = Apollo.MutationFunction<TemporaryBlockMutation, TemporaryBlockMutationVariables>;

/**
 * __useTemporaryBlockMutation__
 *
 * To run a mutation, you first call `useTemporaryBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemporaryBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [temporaryBlockMutation, { data, loading, error }] = useTemporaryBlockMutation({
 *   variables: {
 *      id: // value for 'id'
 *      hours: // value for 'hours'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useTemporaryBlockMutation(baseOptions?: Apollo.MutationHookOptions<TemporaryBlockMutation, TemporaryBlockMutationVariables>) {
        return Apollo.useMutation<TemporaryBlockMutation, TemporaryBlockMutationVariables>(TemporaryBlockDocument, baseOptions);
      }
export type TemporaryBlockMutationHookResult = ReturnType<typeof useTemporaryBlockMutation>;
export type TemporaryBlockMutationResult = Apollo.MutationResult<TemporaryBlockMutation>;
export type TemporaryBlockMutationOptions = Apollo.BaseMutationOptions<TemporaryBlockMutation, TemporaryBlockMutationVariables>;
export const TerminateCallDocument = gql`
    mutation TerminateCall($id: Int!) {
  leaveCall(where: {id: $id}) {
    id
    status
    room
    requestTime
    startTime
    endTime
    participants {
      twilioToken
      id
      role
      status
      joinTime
      account {
        id
        email
        accountStatus
        subscriptionStatus
        role
        createdAt
        profile {
          __typename
          ... on ClientProfile {
            id
            name
            lastname
            birthday
            sex
          }
          ... on DoctorProfile {
            id
            name
            lastname
            birthday
            sex
          }
          ... on SystemUserProfile {
            id
            type
          }
        }
      }
    }
  }
}
    `;
export type TerminateCallMutationFn = Apollo.MutationFunction<TerminateCallMutation, TerminateCallMutationVariables>;

/**
 * __useTerminateCallMutation__
 *
 * To run a mutation, you first call `useTerminateCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTerminateCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [terminateCallMutation, { data, loading, error }] = useTerminateCallMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTerminateCallMutation(baseOptions?: Apollo.MutationHookOptions<TerminateCallMutation, TerminateCallMutationVariables>) {
        return Apollo.useMutation<TerminateCallMutation, TerminateCallMutationVariables>(TerminateCallDocument, baseOptions);
      }
export type TerminateCallMutationHookResult = ReturnType<typeof useTerminateCallMutation>;
export type TerminateCallMutationResult = Apollo.MutationResult<TerminateCallMutation>;
export type TerminateCallMutationOptions = Apollo.BaseMutationOptions<TerminateCallMutation, TerminateCallMutationVariables>;
export const UpdateLanguageDocument = gql`
    mutation UpdateLanguage($languageCode: LanguageCode!) {
  setAccountProfileLanguage(data: {languageCode: $languageCode}) {
    id
  }
}
    `;
export type UpdateLanguageMutationFn = Apollo.MutationFunction<UpdateLanguageMutation, UpdateLanguageMutationVariables>;

/**
 * __useUpdateLanguageMutation__
 *
 * To run a mutation, you first call `useUpdateLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLanguageMutation, { data, loading, error }] = useUpdateLanguageMutation({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useUpdateLanguageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLanguageMutation, UpdateLanguageMutationVariables>) {
        return Apollo.useMutation<UpdateLanguageMutation, UpdateLanguageMutationVariables>(UpdateLanguageDocument, baseOptions);
      }
export type UpdateLanguageMutationHookResult = ReturnType<typeof useUpdateLanguageMutation>;
export type UpdateLanguageMutationResult = Apollo.MutationResult<UpdateLanguageMutation>;
export type UpdateLanguageMutationOptions = Apollo.BaseMutationOptions<UpdateLanguageMutation, UpdateLanguageMutationVariables>;
export const UpdateArticleDocument = gql`
    mutation UpdateArticle($id: Int!, $languageCode: LanguageCode!, $title: String!, $body: String!, $coverMediaKey: String!, $excerpt: String!) {
  updateArticle(
    id: $id
    data: {excerpt: $excerpt, languageCode: $languageCode, title: $title, body: $body, coverMediaKey: $coverMediaKey}
  ) {
    id
  }
}
    `;
export type UpdateArticleMutationFn = Apollo.MutationFunction<UpdateArticleMutation, UpdateArticleMutationVariables>;

/**
 * __useUpdateArticleMutation__
 *
 * To run a mutation, you first call `useUpdateArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArticleMutation, { data, loading, error }] = useUpdateArticleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      languageCode: // value for 'languageCode'
 *      title: // value for 'title'
 *      body: // value for 'body'
 *      coverMediaKey: // value for 'coverMediaKey'
 *      excerpt: // value for 'excerpt'
 *   },
 * });
 */
export function useUpdateArticleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArticleMutation, UpdateArticleMutationVariables>) {
        return Apollo.useMutation<UpdateArticleMutation, UpdateArticleMutationVariables>(UpdateArticleDocument, baseOptions);
      }
export type UpdateArticleMutationHookResult = ReturnType<typeof useUpdateArticleMutation>;
export type UpdateArticleMutationResult = Apollo.MutationResult<UpdateArticleMutation>;
export type UpdateArticleMutationOptions = Apollo.BaseMutationOptions<UpdateArticleMutation, UpdateArticleMutationVariables>;
export const UpdateBenefitDocument = gql`
    mutation UpdateBenefit($id: Int!, $title: MultiLanguageString!, $descriptioin: MultiLanguageString!, $imageMediaKey: String!, $externalURL: String, $externalUrlLabel: MultiLanguageString) {
  updateBenefit(
    where: {id: $id}
    data: {title: $title, description: $descriptioin, imageMediaKey: $imageMediaKey, externalURL: $externalURL, externalUrlLabel: $externalUrlLabel}
  ) {
    id
    title
    description
    image {
      id
      url
      key
    }
    rawTitle {
      sq
      en
      mk
    }
    rawDescription {
      sq
      en
      mk
    }
    rawExternalUrlLabel {
      sq
      en
      mk
    }
    externalUrlLabel
    externalURL
    createdAt
    updatedAt
    tiers {
      id
      name
    }
  }
}
    `;
export type UpdateBenefitMutationFn = Apollo.MutationFunction<UpdateBenefitMutation, UpdateBenefitMutationVariables>;

/**
 * __useUpdateBenefitMutation__
 *
 * To run a mutation, you first call `useUpdateBenefitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBenefitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBenefitMutation, { data, loading, error }] = useUpdateBenefitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      descriptioin: // value for 'descriptioin'
 *      imageMediaKey: // value for 'imageMediaKey'
 *      externalURL: // value for 'externalURL'
 *      externalUrlLabel: // value for 'externalUrlLabel'
 *   },
 * });
 */
export function useUpdateBenefitMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBenefitMutation, UpdateBenefitMutationVariables>) {
        return Apollo.useMutation<UpdateBenefitMutation, UpdateBenefitMutationVariables>(UpdateBenefitDocument, baseOptions);
      }
export type UpdateBenefitMutationHookResult = ReturnType<typeof useUpdateBenefitMutation>;
export type UpdateBenefitMutationResult = Apollo.MutationResult<UpdateBenefitMutation>;
export type UpdateBenefitMutationOptions = Apollo.BaseMutationOptions<UpdateBenefitMutation, UpdateBenefitMutationVariables>;
export const UpdateCityDocument = gql`
    mutation UpdateCity($id: Int!, $name: MultiLanguageString!, $countryId: Int!) {
  updateCity(where: {id: $id}, data: {countryId: $countryId, name: $name}) {
    id
    name
  }
}
    `;
export type UpdateCityMutationFn = Apollo.MutationFunction<UpdateCityMutation, UpdateCityMutationVariables>;

/**
 * __useUpdateCityMutation__
 *
 * To run a mutation, you first call `useUpdateCityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCityMutation, { data, loading, error }] = useUpdateCityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useUpdateCityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCityMutation, UpdateCityMutationVariables>) {
        return Apollo.useMutation<UpdateCityMutation, UpdateCityMutationVariables>(UpdateCityDocument, baseOptions);
      }
export type UpdateCityMutationHookResult = ReturnType<typeof useUpdateCityMutation>;
export type UpdateCityMutationResult = Apollo.MutationResult<UpdateCityMutation>;
export type UpdateCityMutationOptions = Apollo.BaseMutationOptions<UpdateCityMutation, UpdateCityMutationVariables>;
export const UpdateCountryDocument = gql`
    mutation UpdateCountry($id: Int!, $name: MultiLanguageString!) {
  updateCountry(where: {id: $id}, data: {name: $name}) {
    id
    name
  }
}
    `;
export type UpdateCountryMutationFn = Apollo.MutationFunction<UpdateCountryMutation, UpdateCountryMutationVariables>;

/**
 * __useUpdateCountryMutation__
 *
 * To run a mutation, you first call `useUpdateCountryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCountryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCountryMutation, { data, loading, error }] = useUpdateCountryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateCountryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCountryMutation, UpdateCountryMutationVariables>) {
        return Apollo.useMutation<UpdateCountryMutation, UpdateCountryMutationVariables>(UpdateCountryDocument, baseOptions);
      }
export type UpdateCountryMutationHookResult = ReturnType<typeof useUpdateCountryMutation>;
export type UpdateCountryMutationResult = Apollo.MutationResult<UpdateCountryMutation>;
export type UpdateCountryMutationOptions = Apollo.BaseMutationOptions<UpdateCountryMutation, UpdateCountryMutationVariables>;
export const UpdateDoctorDocument = gql`
    mutation UpdateDoctor($phoneNumber: String, $name: String, $lastname: String, $birthday: Date, $sex: Gender, $licenceNumber: String, $bio: String, $cityId: Int, $countryId: Int, $healthCenterId: Int) {
  updateDoctor(
    data: {phoneNumber: $phoneNumber, name: $name, lastname: $lastname, birthday: $birthday, sex: $sex, licenceNumber: $licenceNumber, bio: $bio, cityId: $cityId, countryId: $countryId, healthCenterId: $healthCenterId}
  ) {
    id
  }
}
    `;
export type UpdateDoctorMutationFn = Apollo.MutationFunction<UpdateDoctorMutation, UpdateDoctorMutationVariables>;

/**
 * __useUpdateDoctorMutation__
 *
 * To run a mutation, you first call `useUpdateDoctorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDoctorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDoctorMutation, { data, loading, error }] = useUpdateDoctorMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      name: // value for 'name'
 *      lastname: // value for 'lastname'
 *      birthday: // value for 'birthday'
 *      sex: // value for 'sex'
 *      licenceNumber: // value for 'licenceNumber'
 *      bio: // value for 'bio'
 *      cityId: // value for 'cityId'
 *      countryId: // value for 'countryId'
 *      healthCenterId: // value for 'healthCenterId'
 *   },
 * });
 */
export function useUpdateDoctorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDoctorMutation, UpdateDoctorMutationVariables>) {
        return Apollo.useMutation<UpdateDoctorMutation, UpdateDoctorMutationVariables>(UpdateDoctorDocument, baseOptions);
      }
export type UpdateDoctorMutationHookResult = ReturnType<typeof useUpdateDoctorMutation>;
export type UpdateDoctorMutationResult = Apollo.MutationResult<UpdateDoctorMutation>;
export type UpdateDoctorMutationOptions = Apollo.BaseMutationOptions<UpdateDoctorMutation, UpdateDoctorMutationVariables>;
export const UpdateDocumentCommentDocument = gql`
    mutation UpdateDocumentComment($id: Int!, $content: String!) {
  updateDocumentComment(where: {id: $id}, data: {content: $content}) {
    id
    author {
      ...ShortAccountData
    }
    content
    createdAt
    updatedAt
  }
}
    ${ShortAccountDataFragmentDoc}`;
export type UpdateDocumentCommentMutationFn = Apollo.MutationFunction<UpdateDocumentCommentMutation, UpdateDocumentCommentMutationVariables>;

/**
 * __useUpdateDocumentCommentMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentCommentMutation, { data, loading, error }] = useUpdateDocumentCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUpdateDocumentCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentCommentMutation, UpdateDocumentCommentMutationVariables>) {
        return Apollo.useMutation<UpdateDocumentCommentMutation, UpdateDocumentCommentMutationVariables>(UpdateDocumentCommentDocument, baseOptions);
      }
export type UpdateDocumentCommentMutationHookResult = ReturnType<typeof useUpdateDocumentCommentMutation>;
export type UpdateDocumentCommentMutationResult = Apollo.MutationResult<UpdateDocumentCommentMutation>;
export type UpdateDocumentCommentMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentCommentMutation, UpdateDocumentCommentMutationVariables>;
export const UpdateEventDocument = gql`
    mutation UpdateEvent($id: Int!, $title: String, $description: String, $coverMediaKey: String, $specialistId: Int, $startDate: DateTime, $durationMinutes: Int, $maxParticipantsNumber: Int) {
  updateEvent(
    id: $id
    data: {title: $title, description: $description, coverMediaKey: $coverMediaKey, specialistId: $specialistId, startDate: $startDate, durationMinutes: $durationMinutes, maxParticipantsNumber: $maxParticipantsNumber}
  ) {
    id
    title
    description
    cover(resize: {width: 800}) {
      id
      url
      createdAt
      contentType
    }
    specialist {
      ...ShortAccountData
    }
    roomName
    creator {
      ...ShortAccountData
    }
    startDate
    endDate
    durationMinutes
    participants {
      maxNumber
      currentCount
      list {
        ...ShortAccountData
      }
    }
    participationStatus
    createdAt
    updatedAt
  }
}
    ${ShortAccountDataFragmentDoc}`;
export type UpdateEventMutationFn = Apollo.MutationFunction<UpdateEventMutation, UpdateEventMutationVariables>;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      coverMediaKey: // value for 'coverMediaKey'
 *      specialistId: // value for 'specialistId'
 *      startDate: // value for 'startDate'
 *      durationMinutes: // value for 'durationMinutes'
 *      maxParticipantsNumber: // value for 'maxParticipantsNumber'
 *   },
 * });
 */
export function useUpdateEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventMutation, UpdateEventMutationVariables>) {
        return Apollo.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, baseOptions);
      }
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>;
export type UpdateEventMutationResult = Apollo.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = Apollo.BaseMutationOptions<UpdateEventMutation, UpdateEventMutationVariables>;
export const UpdateFaqDocument = gql`
    mutation UpdateFaq($id: Int!, $title: MultiLanguageString!, $bodySq: String!, $bodyEn: String!, $bodyMk: String!) {
  updateFaq(
    id: $id
    data: {title: $title, body: {sq: $bodySq, en: $bodyEn, mk: $bodyMk}}
  ) {
    id
    title
    rawTitle {
      sq
      en
      mk
    }
    body
    rawBody {
      sq
      en
      mk
    }
  }
}
    `;
export type UpdateFaqMutationFn = Apollo.MutationFunction<UpdateFaqMutation, UpdateFaqMutationVariables>;

/**
 * __useUpdateFaqMutation__
 *
 * To run a mutation, you first call `useUpdateFaqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFaqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFaqMutation, { data, loading, error }] = useUpdateFaqMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      bodySq: // value for 'bodySq'
 *      bodyEn: // value for 'bodyEn'
 *      bodyMk: // value for 'bodyMk'
 *   },
 * });
 */
export function useUpdateFaqMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFaqMutation, UpdateFaqMutationVariables>) {
        return Apollo.useMutation<UpdateFaqMutation, UpdateFaqMutationVariables>(UpdateFaqDocument, baseOptions);
      }
export type UpdateFaqMutationHookResult = ReturnType<typeof useUpdateFaqMutation>;
export type UpdateFaqMutationResult = Apollo.MutationResult<UpdateFaqMutation>;
export type UpdateFaqMutationOptions = Apollo.BaseMutationOptions<UpdateFaqMutation, UpdateFaqMutationVariables>;
export const UpdateHealthCenterDocument = gql`
    mutation UpdateHealthCenter($id: Int!, $name: MultiLanguageString!, $cityId: Int!) {
  updateHealthCenter(where: {id: $id}, data: {cityId: $cityId, name: $name}) {
    id
    name
  }
}
    `;
export type UpdateHealthCenterMutationFn = Apollo.MutationFunction<UpdateHealthCenterMutation, UpdateHealthCenterMutationVariables>;

/**
 * __useUpdateHealthCenterMutation__
 *
 * To run a mutation, you first call `useUpdateHealthCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHealthCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHealthCenterMutation, { data, loading, error }] = useUpdateHealthCenterMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      cityId: // value for 'cityId'
 *   },
 * });
 */
export function useUpdateHealthCenterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHealthCenterMutation, UpdateHealthCenterMutationVariables>) {
        return Apollo.useMutation<UpdateHealthCenterMutation, UpdateHealthCenterMutationVariables>(UpdateHealthCenterDocument, baseOptions);
      }
export type UpdateHealthCenterMutationHookResult = ReturnType<typeof useUpdateHealthCenterMutation>;
export type UpdateHealthCenterMutationResult = Apollo.MutationResult<UpdateHealthCenterMutation>;
export type UpdateHealthCenterMutationOptions = Apollo.BaseMutationOptions<UpdateHealthCenterMutation, UpdateHealthCenterMutationVariables>;
export const UpdateInsurancePolicyDocument = gql`
    mutation UpdateInsurancePolicy($id: Int!, $name: MultiLanguageString!) {
  updateInsurancePolicy(where: {id: $id}, data: {name: $name}) {
    id
    name
  }
}
    `;
export type UpdateInsurancePolicyMutationFn = Apollo.MutationFunction<UpdateInsurancePolicyMutation, UpdateInsurancePolicyMutationVariables>;

/**
 * __useUpdateInsurancePolicyMutation__
 *
 * To run a mutation, you first call `useUpdateInsurancePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsurancePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsurancePolicyMutation, { data, loading, error }] = useUpdateInsurancePolicyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateInsurancePolicyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInsurancePolicyMutation, UpdateInsurancePolicyMutationVariables>) {
        return Apollo.useMutation<UpdateInsurancePolicyMutation, UpdateInsurancePolicyMutationVariables>(UpdateInsurancePolicyDocument, baseOptions);
      }
export type UpdateInsurancePolicyMutationHookResult = ReturnType<typeof useUpdateInsurancePolicyMutation>;
export type UpdateInsurancePolicyMutationResult = Apollo.MutationResult<UpdateInsurancePolicyMutation>;
export type UpdateInsurancePolicyMutationOptions = Apollo.BaseMutationOptions<UpdateInsurancePolicyMutation, UpdateInsurancePolicyMutationVariables>;
export const UpdateMedicalCardCommentDocument = gql`
    mutation UpdateMedicalCardComment($id: Int!, $content: String!) {
  updateMedicalCardComment(where: {id: $id}, data: {content: $content}) {
    id
    author {
      ...ShortAccountData
    }
    content
    createdAt
    updatedAt
  }
}
    ${ShortAccountDataFragmentDoc}`;
export type UpdateMedicalCardCommentMutationFn = Apollo.MutationFunction<UpdateMedicalCardCommentMutation, UpdateMedicalCardCommentMutationVariables>;

/**
 * __useUpdateMedicalCardCommentMutation__
 *
 * To run a mutation, you first call `useUpdateMedicalCardCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMedicalCardCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMedicalCardCommentMutation, { data, loading, error }] = useUpdateMedicalCardCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUpdateMedicalCardCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMedicalCardCommentMutation, UpdateMedicalCardCommentMutationVariables>) {
        return Apollo.useMutation<UpdateMedicalCardCommentMutation, UpdateMedicalCardCommentMutationVariables>(UpdateMedicalCardCommentDocument, baseOptions);
      }
export type UpdateMedicalCardCommentMutationHookResult = ReturnType<typeof useUpdateMedicalCardCommentMutation>;
export type UpdateMedicalCardCommentMutationResult = Apollo.MutationResult<UpdateMedicalCardCommentMutation>;
export type UpdateMedicalCardCommentMutationOptions = Apollo.BaseMutationOptions<UpdateMedicalCardCommentMutation, UpdateMedicalCardCommentMutationVariables>;
export const UpdateMedicalCardDocument = gql`
    mutation UpdateMedicalCard($id: Int!, $symptoms: String, $diagnosis: String, $recommendation: String, $recipe: String, $privateNote: String, $medicalConcernCategoryId: Int!) {
  updateMedicalCard(
    where: {id: $id}
    data: {symptoms: $symptoms, diagnosis: $diagnosis, recommendation: $recommendation, recipe: $recipe, privateNote: $privateNote, medicalConcernCategoryId: $medicalConcernCategoryId}
  ) {
    id
    patient {
      ...ShortAccountData
    }
    doctor {
      ...ShortAccountData
    }
    symptoms
    diagnosis
    diagnosis
    recommendation
    recipe
    privateNote
    createdAt
    updatedAt
    concernCategory {
      id
      name
    }
    documents {
      id
      author {
        ...ShortAccountData
      }
      thumbnail: media(size: MEDIUM) {
        id
        url
        createdAt
        contentType
        byteSize
      }
      media {
        url
      }
      description
      comments {
        author {
          ...ShortAccountData
        }
        content
        createdAt
        updatedAt
      }
    }
    comments {
      id
      author {
        ...ShortAccountData
      }
      content
      createdAt
      updatedAt
    }
  }
}
    ${ShortAccountDataFragmentDoc}`;
export type UpdateMedicalCardMutationFn = Apollo.MutationFunction<UpdateMedicalCardMutation, UpdateMedicalCardMutationVariables>;

/**
 * __useUpdateMedicalCardMutation__
 *
 * To run a mutation, you first call `useUpdateMedicalCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMedicalCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMedicalCardMutation, { data, loading, error }] = useUpdateMedicalCardMutation({
 *   variables: {
 *      id: // value for 'id'
 *      symptoms: // value for 'symptoms'
 *      diagnosis: // value for 'diagnosis'
 *      recommendation: // value for 'recommendation'
 *      recipe: // value for 'recipe'
 *      privateNote: // value for 'privateNote'
 *      medicalConcernCategoryId: // value for 'medicalConcernCategoryId'
 *   },
 * });
 */
export function useUpdateMedicalCardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMedicalCardMutation, UpdateMedicalCardMutationVariables>) {
        return Apollo.useMutation<UpdateMedicalCardMutation, UpdateMedicalCardMutationVariables>(UpdateMedicalCardDocument, baseOptions);
      }
export type UpdateMedicalCardMutationHookResult = ReturnType<typeof useUpdateMedicalCardMutation>;
export type UpdateMedicalCardMutationResult = Apollo.MutationResult<UpdateMedicalCardMutation>;
export type UpdateMedicalCardMutationOptions = Apollo.BaseMutationOptions<UpdateMedicalCardMutation, UpdateMedicalCardMutationVariables>;
export const UpdateMedicalConcernCategoryDocument = gql`
    mutation UpdateMedicalConcernCategory($id: Int!, $name: MultiLanguageString!) {
  updateMedicalConcernCategory(where: {id: $id}, data: {name: $name}) {
    id
    name
  }
}
    `;
export type UpdateMedicalConcernCategoryMutationFn = Apollo.MutationFunction<UpdateMedicalConcernCategoryMutation, UpdateMedicalConcernCategoryMutationVariables>;

/**
 * __useUpdateMedicalConcernCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateMedicalConcernCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMedicalConcernCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMedicalConcernCategoryMutation, { data, loading, error }] = useUpdateMedicalConcernCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateMedicalConcernCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMedicalConcernCategoryMutation, UpdateMedicalConcernCategoryMutationVariables>) {
        return Apollo.useMutation<UpdateMedicalConcernCategoryMutation, UpdateMedicalConcernCategoryMutationVariables>(UpdateMedicalConcernCategoryDocument, baseOptions);
      }
export type UpdateMedicalConcernCategoryMutationHookResult = ReturnType<typeof useUpdateMedicalConcernCategoryMutation>;
export type UpdateMedicalConcernCategoryMutationResult = Apollo.MutationResult<UpdateMedicalConcernCategoryMutation>;
export type UpdateMedicalConcernCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateMedicalConcernCategoryMutation, UpdateMedicalConcernCategoryMutationVariables>;
export const UpdateSpecialistDocument = gql`
    mutation UpdateSpecialist($phoneNumber: String, $name: String, $lastname: String, $birthday: Date, $sex: Gender, $licenceNumber: String, $bio: String, $cityId: Int, $countryId: Int, $healthCenterId: Int, $specialityId: Int) {
  updateSpecialist(
    data: {phoneNumber: $phoneNumber, name: $name, lastname: $lastname, birthday: $birthday, sex: $sex, licenceNumber: $licenceNumber, bio: $bio, cityId: $cityId, countryId: $countryId, healthCenterId: $healthCenterId, specialityId: $specialityId}
  ) {
    id
  }
}
    `;
export type UpdateSpecialistMutationFn = Apollo.MutationFunction<UpdateSpecialistMutation, UpdateSpecialistMutationVariables>;

/**
 * __useUpdateSpecialistMutation__
 *
 * To run a mutation, you first call `useUpdateSpecialistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpecialistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpecialistMutation, { data, loading, error }] = useUpdateSpecialistMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      name: // value for 'name'
 *      lastname: // value for 'lastname'
 *      birthday: // value for 'birthday'
 *      sex: // value for 'sex'
 *      licenceNumber: // value for 'licenceNumber'
 *      bio: // value for 'bio'
 *      cityId: // value for 'cityId'
 *      countryId: // value for 'countryId'
 *      healthCenterId: // value for 'healthCenterId'
 *      specialityId: // value for 'specialityId'
 *   },
 * });
 */
export function useUpdateSpecialistMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpecialistMutation, UpdateSpecialistMutationVariables>) {
        return Apollo.useMutation<UpdateSpecialistMutation, UpdateSpecialistMutationVariables>(UpdateSpecialistDocument, baseOptions);
      }
export type UpdateSpecialistMutationHookResult = ReturnType<typeof useUpdateSpecialistMutation>;
export type UpdateSpecialistMutationResult = Apollo.MutationResult<UpdateSpecialistMutation>;
export type UpdateSpecialistMutationOptions = Apollo.BaseMutationOptions<UpdateSpecialistMutation, UpdateSpecialistMutationVariables>;
export const UpdateSpecialityDocument = gql`
    mutation UpdateSpeciality($id: Int!, $name: MultiLanguageString!) {
  updateSpeciality(where: {id: $id}, data: {name: $name}) {
    id
    name
  }
}
    `;
export type UpdateSpecialityMutationFn = Apollo.MutationFunction<UpdateSpecialityMutation, UpdateSpecialityMutationVariables>;

/**
 * __useUpdateSpecialityMutation__
 *
 * To run a mutation, you first call `useUpdateSpecialityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpecialityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpecialityMutation, { data, loading, error }] = useUpdateSpecialityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateSpecialityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpecialityMutation, UpdateSpecialityMutationVariables>) {
        return Apollo.useMutation<UpdateSpecialityMutation, UpdateSpecialityMutationVariables>(UpdateSpecialityDocument, baseOptions);
      }
export type UpdateSpecialityMutationHookResult = ReturnType<typeof useUpdateSpecialityMutation>;
export type UpdateSpecialityMutationResult = Apollo.MutationResult<UpdateSpecialityMutation>;
export type UpdateSpecialityMutationOptions = Apollo.BaseMutationOptions<UpdateSpecialityMutation, UpdateSpecialityMutationVariables>;
export const UpdateStoryItemDocument = gql`
    mutation UpdateStoryItem($id: Int!, $isActive: Boolean!, $mediaKey: String!, $linkURL: String, $linkLabel: String, $bgColor: String!, $storyId: Int!, $language: LanguageCode!) {
  updateStoryItem(
    where: {id: $id}
    data: {isActive: $isActive, linkURL: $linkURL, linkLabel: $linkLabel, bgColor: $bgColor, mediaKey: $mediaKey, storyId: $storyId, language: $language}
  ) {
    id
  }
}
    `;
export type UpdateStoryItemMutationFn = Apollo.MutationFunction<UpdateStoryItemMutation, UpdateStoryItemMutationVariables>;

/**
 * __useUpdateStoryItemMutation__
 *
 * To run a mutation, you first call `useUpdateStoryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStoryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStoryItemMutation, { data, loading, error }] = useUpdateStoryItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isActive: // value for 'isActive'
 *      mediaKey: // value for 'mediaKey'
 *      linkURL: // value for 'linkURL'
 *      linkLabel: // value for 'linkLabel'
 *      bgColor: // value for 'bgColor'
 *      storyId: // value for 'storyId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateStoryItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStoryItemMutation, UpdateStoryItemMutationVariables>) {
        return Apollo.useMutation<UpdateStoryItemMutation, UpdateStoryItemMutationVariables>(UpdateStoryItemDocument, baseOptions);
      }
export type UpdateStoryItemMutationHookResult = ReturnType<typeof useUpdateStoryItemMutation>;
export type UpdateStoryItemMutationResult = Apollo.MutationResult<UpdateStoryItemMutation>;
export type UpdateStoryItemMutationOptions = Apollo.BaseMutationOptions<UpdateStoryItemMutation, UpdateStoryItemMutationVariables>;
export const UpdateStoryDocument = gql`
    mutation UpdateStory($id: Int!, $isActive: Boolean!, $mediaKey: String!, $title: MultiLanguageString!) {
  updateStory(
    where: {id: $id}
    data: {isActive: $isActive, mediaKey: $mediaKey, title: $title}
  ) {
    id
    order
    author {
      ...ShortAccountDataFragment
    }
    icon {
      url
    }
    title
    rawTitle {
      sq
      en
      mk
    }
    items {
      id
      isActive
    }
    createdAt
    updatedAt
  }
}
    ${ShortAccountDataFragmentFragmentDoc}`;
export type UpdateStoryMutationFn = Apollo.MutationFunction<UpdateStoryMutation, UpdateStoryMutationVariables>;

/**
 * __useUpdateStoryMutation__
 *
 * To run a mutation, you first call `useUpdateStoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStoryMutation, { data, loading, error }] = useUpdateStoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isActive: // value for 'isActive'
 *      mediaKey: // value for 'mediaKey'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateStoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStoryMutation, UpdateStoryMutationVariables>) {
        return Apollo.useMutation<UpdateStoryMutation, UpdateStoryMutationVariables>(UpdateStoryDocument, baseOptions);
      }
export type UpdateStoryMutationHookResult = ReturnType<typeof useUpdateStoryMutation>;
export type UpdateStoryMutationResult = Apollo.MutationResult<UpdateStoryMutation>;
export type UpdateStoryMutationOptions = Apollo.BaseMutationOptions<UpdateStoryMutation, UpdateStoryMutationVariables>;
export const UpdateSystemUserDocument = gql`
    mutation UpdateSystemUser($name: String, $lastname: String, $phoneNumber: String) {
  updateSystemUser(
    data: {name: $name, lastname: $lastname, phoneNumber: $phoneNumber}
  ) {
    id
  }
}
    `;
export type UpdateSystemUserMutationFn = Apollo.MutationFunction<UpdateSystemUserMutation, UpdateSystemUserMutationVariables>;

/**
 * __useUpdateSystemUserMutation__
 *
 * To run a mutation, you first call `useUpdateSystemUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSystemUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSystemUserMutation, { data, loading, error }] = useUpdateSystemUserMutation({
 *   variables: {
 *      name: // value for 'name'
 *      lastname: // value for 'lastname'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useUpdateSystemUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSystemUserMutation, UpdateSystemUserMutationVariables>) {
        return Apollo.useMutation<UpdateSystemUserMutation, UpdateSystemUserMutationVariables>(UpdateSystemUserDocument, baseOptions);
      }
export type UpdateSystemUserMutationHookResult = ReturnType<typeof useUpdateSystemUserMutation>;
export type UpdateSystemUserMutationResult = Apollo.MutationResult<UpdateSystemUserMutation>;
export type UpdateSystemUserMutationOptions = Apollo.BaseMutationOptions<UpdateSystemUserMutation, UpdateSystemUserMutationVariables>;
export const UpdateTierDocument = gql`
    mutation UpdateTier($id: Int!, $nameSq: String!, $nameEn: String!, $nameMk: String!, $descriptionSq: String!, $descriptionEn: String!, $descriptionMk: String!, $color: String!, $activeDays: Int!, $eventsPerMonth: Int!, $pricePerYear: Int!, $default: Boolean!, $demo: Boolean!, $benefitIDs: [Int!]!, $sigalHealthInsuranceType: HealthInsuranceCardType) {
  updateTier(
    where: {id: $id}
    data: {name: {en: $nameEn, sq: $nameSq, mk: $nameMk}, description: {en: $descriptionEn, sq: $descriptionSq, mk: $descriptionMk}, color: $color, activeDays: $activeDays, eventsPerMonth: $eventsPerMonth, pricePerYear: $pricePerYear, isDefaultForSigalClients: $default, isDefaultForDemo: $demo, benefitIDs: $benefitIDs, sigalHealthInsuranceType: $sigalHealthInsuranceType}
  ) {
    id
    name
    description
    color
    activeDays
    eventsPerMonth
    pricePerYear
    isPublic
    isDefaultForSigalClients
    isDefaultForDemo
    sigalHealthInsuranceType
  }
}
    `;
export type UpdateTierMutationFn = Apollo.MutationFunction<UpdateTierMutation, UpdateTierMutationVariables>;

/**
 * __useUpdateTierMutation__
 *
 * To run a mutation, you first call `useUpdateTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTierMutation, { data, loading, error }] = useUpdateTierMutation({
 *   variables: {
 *      id: // value for 'id'
 *      nameSq: // value for 'nameSq'
 *      nameEn: // value for 'nameEn'
 *      nameMk: // value for 'nameMk'
 *      descriptionSq: // value for 'descriptionSq'
 *      descriptionEn: // value for 'descriptionEn'
 *      descriptionMk: // value for 'descriptionMk'
 *      color: // value for 'color'
 *      activeDays: // value for 'activeDays'
 *      eventsPerMonth: // value for 'eventsPerMonth'
 *      pricePerYear: // value for 'pricePerYear'
 *      default: // value for 'default'
 *      demo: // value for 'demo'
 *      benefitIDs: // value for 'benefitIDs'
 *      sigalHealthInsuranceType: // value for 'sigalHealthInsuranceType'
 *   },
 * });
 */
export function useUpdateTierMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTierMutation, UpdateTierMutationVariables>) {
        return Apollo.useMutation<UpdateTierMutation, UpdateTierMutationVariables>(UpdateTierDocument, baseOptions);
      }
export type UpdateTierMutationHookResult = ReturnType<typeof useUpdateTierMutation>;
export type UpdateTierMutationResult = Apollo.MutationResult<UpdateTierMutation>;
export type UpdateTierMutationOptions = Apollo.BaseMutationOptions<UpdateTierMutation, UpdateTierMutationVariables>;
export const VerifyAccountUsingVerificationCodeDocument = gql`
    mutation VerifyAccountUsingVerificationCode($code: String!) {
  verifyAccountUsingVerificationCode(verificationCode: $code) {
    message
  }
}
    `;
export type VerifyAccountUsingVerificationCodeMutationFn = Apollo.MutationFunction<VerifyAccountUsingVerificationCodeMutation, VerifyAccountUsingVerificationCodeMutationVariables>;

/**
 * __useVerifyAccountUsingVerificationCodeMutation__
 *
 * To run a mutation, you first call `useVerifyAccountUsingVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAccountUsingVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAccountUsingVerificationCodeMutation, { data, loading, error }] = useVerifyAccountUsingVerificationCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyAccountUsingVerificationCodeMutation(baseOptions?: Apollo.MutationHookOptions<VerifyAccountUsingVerificationCodeMutation, VerifyAccountUsingVerificationCodeMutationVariables>) {
        return Apollo.useMutation<VerifyAccountUsingVerificationCodeMutation, VerifyAccountUsingVerificationCodeMutationVariables>(VerifyAccountUsingVerificationCodeDocument, baseOptions);
      }
export type VerifyAccountUsingVerificationCodeMutationHookResult = ReturnType<typeof useVerifyAccountUsingVerificationCodeMutation>;
export type VerifyAccountUsingVerificationCodeMutationResult = Apollo.MutationResult<VerifyAccountUsingVerificationCodeMutation>;
export type VerifyAccountUsingVerificationCodeMutationOptions = Apollo.BaseMutationOptions<VerifyAccountUsingVerificationCodeMutation, VerifyAccountUsingVerificationCodeMutationVariables>;
export const AccountSubscriptionDocument = gql`
    query AccountSubscription($id: Int!) {
  subscription(id: $id) {
    id
    account {
      id
      email
      profileImage
      role
      profile {
        ... on ClientProfile {
          name
          lastname
        }
      }
    }
    tier {
      id
      name
      description
      color
      pricePerYear
    }
    startDate
    expirationDate
    isActive
    authorization {
      __typename
      ... on InsurancePolicyHolderSubscriptionAuthorization {
        type
        insurancePolicy {
          name
        }
        insurancePolicySerialNumber
        status
        insuranceUsageType
        insuranceCodeType
        tier {
          name
        }
        createdAt
      }
      ... on TierCardHolderSubscriptionAuthorization {
        type
        payment {
          amount
        }
        tier {
          name
        }
        createdAt
        tierCode {
          code
          id
          type
          status
          claimDate
          issueDate
        }
      }
    }
  }
}
    `;

/**
 * __useAccountSubscriptionQuery__
 *
 * To run a query within a React component, call `useAccountSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSubscriptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<AccountSubscriptionQuery, AccountSubscriptionQueryVariables>) {
        return Apollo.useQuery<AccountSubscriptionQuery, AccountSubscriptionQueryVariables>(AccountSubscriptionDocument, baseOptions);
      }
export function useAccountSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountSubscriptionQuery, AccountSubscriptionQueryVariables>) {
          return Apollo.useLazyQuery<AccountSubscriptionQuery, AccountSubscriptionQueryVariables>(AccountSubscriptionDocument, baseOptions);
        }
export type AccountSubscriptionQueryHookResult = ReturnType<typeof useAccountSubscriptionQuery>;
export type AccountSubscriptionLazyQueryHookResult = ReturnType<typeof useAccountSubscriptionLazyQuery>;
export type AccountSubscriptionQueryResult = Apollo.QueryResult<AccountSubscriptionQuery, AccountSubscriptionQueryVariables>;
export const AccountSubscriptionsDocument = gql`
    query AccountSubscriptions($range: DateRange, $endRange: DateRange, $tierId: Int, $page: Int!, $pageLimit: Int!) {
  subscriptions(
    range: $range
    endRange: $endRange
    tierId: $tierId
    page: $page
    pageLimit: $pageLimit
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      nextPage
    }
    nodes {
      id
      account {
        id
        email
        profileImage
        role
        profile {
          ... on ClientProfile {
            name
            lastname
          }
        }
      }
      tier {
        id
        name
        description
        color
        pricePerYear
      }
      startDate
      expirationDate
      isActive
      authorization {
        __typename
        ... on InsurancePolicyHolderSubscriptionAuthorization {
          type
          insurancePolicy {
            name
          }
          insurancePolicySerialNumber
          status
          insuranceUsageType
          insuranceCodeType
          tier {
            name
          }
          createdAt
        }
        ... on TierCardHolderSubscriptionAuthorization {
          type
          payment {
            amount
          }
          tier {
            name
          }
          createdAt
          tierCode {
            code
            id
            type
            status
            claimDate
            issueDate
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAccountSubscriptionsQuery__
 *
 * To run a query within a React component, call `useAccountSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSubscriptionsQuery({
 *   variables: {
 *      range: // value for 'range'
 *      endRange: // value for 'endRange'
 *      tierId: // value for 'tierId'
 *      page: // value for 'page'
 *      pageLimit: // value for 'pageLimit'
 *   },
 * });
 */
export function useAccountSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<AccountSubscriptionsQuery, AccountSubscriptionsQueryVariables>) {
        return Apollo.useQuery<AccountSubscriptionsQuery, AccountSubscriptionsQueryVariables>(AccountSubscriptionsDocument, baseOptions);
      }
export function useAccountSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountSubscriptionsQuery, AccountSubscriptionsQueryVariables>) {
          return Apollo.useLazyQuery<AccountSubscriptionsQuery, AccountSubscriptionsQueryVariables>(AccountSubscriptionsDocument, baseOptions);
        }
export type AccountSubscriptionsQueryHookResult = ReturnType<typeof useAccountSubscriptionsQuery>;
export type AccountSubscriptionsLazyQueryHookResult = ReturnType<typeof useAccountSubscriptionsLazyQuery>;
export type AccountSubscriptionsQueryResult = Apollo.QueryResult<AccountSubscriptionsQuery, AccountSubscriptionsQueryVariables>;
export const AccountDocument = gql`
    query Account($id: Int!) {
  account(where: {id: $id}) {
    id
    email
    accountStatus
    subscriptionStatus
    role
    createdAt
    phoneNumber
    profileImage(resize: {width: 100})
    language {
      code
      name
    }
    profile {
      __typename
      ... on ClientProfile {
        id
        type
        name
        lastname
        birthday
        sex
        subscription {
          id
          tier {
            id
            tierId
            name
            description
            color
            activeDays
            eventsPerMonth
          }
          startDate
          expirationDate
          isActive
          remainingDays
        }
      }
      ... on DoctorProfile {
        id
        type
        name
        lastname
        birthday
        licenceNumber
        country {
          id
          name
        }
        city {
          id
          name
        }
        healthCenter {
          id
          name
        }
        speciality {
          id
          name
        }
        sex
        bio
        timetable {
          dayOfWeek
          startHour
          startMinute
          endHour
          endMinute
        }
      }
      ... on SystemUserProfile {
        id
        type
        name
        lastname
      }
    }
  }
}
    `;

/**
 * __useAccountQuery__
 *
 * To run a query within a React component, call `useAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountQuery(baseOptions?: Apollo.QueryHookOptions<AccountQuery, AccountQueryVariables>) {
        return Apollo.useQuery<AccountQuery, AccountQueryVariables>(AccountDocument, baseOptions);
      }
export function useAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountQuery, AccountQueryVariables>) {
          return Apollo.useLazyQuery<AccountQuery, AccountQueryVariables>(AccountDocument, baseOptions);
        }
export type AccountQueryHookResult = ReturnType<typeof useAccountQuery>;
export type AccountLazyQueryHookResult = ReturnType<typeof useAccountLazyQuery>;
export type AccountQueryResult = Apollo.QueryResult<AccountQuery, AccountQueryVariables>;
export const AccountsDocument = gql`
    query Accounts($role: AccountRole!, $accountStatus: AccountStatus, $search: String, $page: Int!, $pageLimit: Int!) {
  accounts(
    where: {role: $role, search: $search, accountStatus: $accountStatus}
    page: $page
    pageLimit: $pageLimit
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      nextPage
    }
    nodes {
      id
      email
      accountStatus
      subscriptionStatus
      role
      createdAt
      phoneNumber
      profileImage(resize: {width: 100})
      language {
        code
        name
      }
      profile {
        __typename
        ... on ClientProfile {
          id
          type
          name
          lastname
          birthday
          sex
          subscription {
            id
            tier {
              id
              name
              description
              color
            }
            startDate
            expirationDate
            remainingDays
          }
        }
        ... on DoctorProfile {
          id
          type
          name
          lastname
          birthday
          licenceNumber
          country {
            id
            name
          }
          city {
            id
            name
          }
          healthCenter {
            id
            name
          }
          speciality {
            id
            name
          }
          sex
          bio
        }
        ... on SystemUserProfile {
          id
          type
          name
          lastname
        }
      }
    }
  }
}
    `;

/**
 * __useAccountsQuery__
 *
 * To run a query within a React component, call `useAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsQuery({
 *   variables: {
 *      role: // value for 'role'
 *      accountStatus: // value for 'accountStatus'
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      pageLimit: // value for 'pageLimit'
 *   },
 * });
 */
export function useAccountsQuery(baseOptions?: Apollo.QueryHookOptions<AccountsQuery, AccountsQueryVariables>) {
        return Apollo.useQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, baseOptions);
      }
export function useAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountsQuery, AccountsQueryVariables>) {
          return Apollo.useLazyQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, baseOptions);
        }
export type AccountsQueryHookResult = ReturnType<typeof useAccountsQuery>;
export type AccountsLazyQueryHookResult = ReturnType<typeof useAccountsLazyQuery>;
export type AccountsQueryResult = Apollo.QueryResult<AccountsQuery, AccountsQueryVariables>;
export const AdvertisementsDocument = gql`
    query Advertisements {
  advertisements {
    id
    position
    isActive
    clickUrl
    media {
      url
    }
    createdAt
    author {
      id
      email
      profileImage
      role
      profile {
        ... on SystemUserProfile {
          name
          lastname
        }
      }
    }
  }
}
    `;

/**
 * __useAdvertisementsQuery__
 *
 * To run a query within a React component, call `useAdvertisementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvertisementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvertisementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdvertisementsQuery(baseOptions?: Apollo.QueryHookOptions<AdvertisementsQuery, AdvertisementsQueryVariables>) {
        return Apollo.useQuery<AdvertisementsQuery, AdvertisementsQueryVariables>(AdvertisementsDocument, baseOptions);
      }
export function useAdvertisementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdvertisementsQuery, AdvertisementsQueryVariables>) {
          return Apollo.useLazyQuery<AdvertisementsQuery, AdvertisementsQueryVariables>(AdvertisementsDocument, baseOptions);
        }
export type AdvertisementsQueryHookResult = ReturnType<typeof useAdvertisementsQuery>;
export type AdvertisementsLazyQueryHookResult = ReturnType<typeof useAdvertisementsLazyQuery>;
export type AdvertisementsQueryResult = Apollo.QueryResult<AdvertisementsQuery, AdvertisementsQueryVariables>;
export const ArticleDocument = gql`
    query Article($id: Int!) {
  article(id: $id) {
    id
    language {
      code
      name
    }
    title
    body
    excerpt
    createdAt
    cover {
      url
      key
    }
    author {
      id
      email
      profileImage
      role
      profile {
        ... on SystemUserProfile {
          name
          lastname
        }
      }
    }
  }
}
    `;

/**
 * __useArticleQuery__
 *
 * To run a query within a React component, call `useArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArticleQuery(baseOptions?: Apollo.QueryHookOptions<ArticleQuery, ArticleQueryVariables>) {
        return Apollo.useQuery<ArticleQuery, ArticleQueryVariables>(ArticleDocument, baseOptions);
      }
export function useArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticleQuery, ArticleQueryVariables>) {
          return Apollo.useLazyQuery<ArticleQuery, ArticleQueryVariables>(ArticleDocument, baseOptions);
        }
export type ArticleQueryHookResult = ReturnType<typeof useArticleQuery>;
export type ArticleLazyQueryHookResult = ReturnType<typeof useArticleLazyQuery>;
export type ArticleQueryResult = Apollo.QueryResult<ArticleQuery, ArticleQueryVariables>;
export const ArticlesDocument = gql`
    query Articles($page: Int, $pageLimit: Int) {
  articles(page: $page, pageLimit: $pageLimit) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      nextPage
    }
    nodes {
      id
      language {
        code
        name
      }
      title
      body
      excerpt
      createdAt
      cover {
        url
        key
      }
      author {
        id
        email
        profileImage
        role
        profile {
          ... on SystemUserProfile {
            name
            lastname
          }
        }
      }
    }
  }
}
    `;

/**
 * __useArticlesQuery__
 *
 * To run a query within a React component, call `useArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticlesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageLimit: // value for 'pageLimit'
 *   },
 * });
 */
export function useArticlesQuery(baseOptions?: Apollo.QueryHookOptions<ArticlesQuery, ArticlesQueryVariables>) {
        return Apollo.useQuery<ArticlesQuery, ArticlesQueryVariables>(ArticlesDocument, baseOptions);
      }
export function useArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticlesQuery, ArticlesQueryVariables>) {
          return Apollo.useLazyQuery<ArticlesQuery, ArticlesQueryVariables>(ArticlesDocument, baseOptions);
        }
export type ArticlesQueryHookResult = ReturnType<typeof useArticlesQuery>;
export type ArticlesLazyQueryHookResult = ReturnType<typeof useArticlesLazyQuery>;
export type ArticlesQueryResult = Apollo.QueryResult<ArticlesQuery, ArticlesQueryVariables>;
export const BenefitDocument = gql`
    query Benefit($id: Int!) {
  benefit(where: {id: $id}) {
    id
    title
    description
    image {
      id
      url
      key
      createdAt
      contentType
      byteSize
    }
    rawTitle {
      sq
      en
      mk
    }
    rawDescription {
      sq
      en
      mk
    }
    rawExternalUrlLabel {
      sq
      en
      mk
    }
    externalUrlLabel
    externalURL
    createdAt
    updatedAt
    tiers {
      id
      name
    }
  }
}
    `;

/**
 * __useBenefitQuery__
 *
 * To run a query within a React component, call `useBenefitQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenefitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenefitQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBenefitQuery(baseOptions?: Apollo.QueryHookOptions<BenefitQuery, BenefitQueryVariables>) {
        return Apollo.useQuery<BenefitQuery, BenefitQueryVariables>(BenefitDocument, baseOptions);
      }
export function useBenefitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BenefitQuery, BenefitQueryVariables>) {
          return Apollo.useLazyQuery<BenefitQuery, BenefitQueryVariables>(BenefitDocument, baseOptions);
        }
export type BenefitQueryHookResult = ReturnType<typeof useBenefitQuery>;
export type BenefitLazyQueryHookResult = ReturnType<typeof useBenefitLazyQuery>;
export type BenefitQueryResult = Apollo.QueryResult<BenefitQuery, BenefitQueryVariables>;
export const BenefitsDocument = gql`
    query Benefits {
  benefits {
    id
    title
    description
    image {
      id
      url
      key
      createdAt
      contentType
      byteSize
    }
    rawTitle {
      sq
      en
      mk
    }
    rawDescription {
      sq
      en
      mk
    }
    rawExternalUrlLabel {
      sq
      en
      mk
    }
    externalUrlLabel
    externalURL
    createdAt
    updatedAt
    tiers {
      id
      name
    }
  }
}
    `;

/**
 * __useBenefitsQuery__
 *
 * To run a query within a React component, call `useBenefitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenefitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenefitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBenefitsQuery(baseOptions?: Apollo.QueryHookOptions<BenefitsQuery, BenefitsQueryVariables>) {
        return Apollo.useQuery<BenefitsQuery, BenefitsQueryVariables>(BenefitsDocument, baseOptions);
      }
export function useBenefitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BenefitsQuery, BenefitsQueryVariables>) {
          return Apollo.useLazyQuery<BenefitsQuery, BenefitsQueryVariables>(BenefitsDocument, baseOptions);
        }
export type BenefitsQueryHookResult = ReturnType<typeof useBenefitsQuery>;
export type BenefitsLazyQueryHookResult = ReturnType<typeof useBenefitsLazyQuery>;
export type BenefitsQueryResult = Apollo.QueryResult<BenefitsQuery, BenefitsQueryVariables>;
export const CallDocument = gql`
    query Call($id: Int!) {
  call(where: {id: $id}) {
    id
    status
    room
    requestTime
    startTime
    endTime
    duration
    recordings
    review {
      rating
      description
    }
    participants {
      twilioToken
      id
      role
      status
      joinTime
      account {
        id
        email
        accountStatus
        subscriptionStatus
        role
        createdAt
        phoneNumber
        profileImage(resize: {width: 100})
        profile {
          __typename
          ... on ClientProfile {
            id
            type
            name
            lastname
            birthday
            sex
          }
          ... on DoctorProfile {
            id
            type
            name
            lastname
            birthday
            licenceNumber
            sex
            bio
          }
          ... on SystemUserProfile {
            id
            type
            name
            lastname
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCallQuery__
 *
 * To run a query within a React component, call `useCallQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCallQuery(baseOptions?: Apollo.QueryHookOptions<CallQuery, CallQueryVariables>) {
        return Apollo.useQuery<CallQuery, CallQueryVariables>(CallDocument, baseOptions);
      }
export function useCallLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallQuery, CallQueryVariables>) {
          return Apollo.useLazyQuery<CallQuery, CallQueryVariables>(CallDocument, baseOptions);
        }
export type CallQueryHookResult = ReturnType<typeof useCallQuery>;
export type CallLazyQueryHookResult = ReturnType<typeof useCallLazyQuery>;
export type CallQueryResult = Apollo.QueryResult<CallQuery, CallQueryVariables>;
export const CallsByDoctorStatsDocument = gql`
    query CallsByDoctorStats {
  callsByDoctorStats {
    callsByDoctor {
      doctorName
      info {
        callsSuccess
        callsExpired
        callsClosed
        callsMinutes
      }
    }
    totalCalls {
      callsSuccess
      callsExpired
      callsClosed
      callsMinutes
    }
  }
}
    `;

/**
 * __useCallsByDoctorStatsQuery__
 *
 * To run a query within a React component, call `useCallsByDoctorStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallsByDoctorStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallsByDoctorStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCallsByDoctorStatsQuery(baseOptions?: Apollo.QueryHookOptions<CallsByDoctorStatsQuery, CallsByDoctorStatsQueryVariables>) {
        return Apollo.useQuery<CallsByDoctorStatsQuery, CallsByDoctorStatsQueryVariables>(CallsByDoctorStatsDocument, baseOptions);
      }
export function useCallsByDoctorStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallsByDoctorStatsQuery, CallsByDoctorStatsQueryVariables>) {
          return Apollo.useLazyQuery<CallsByDoctorStatsQuery, CallsByDoctorStatsQueryVariables>(CallsByDoctorStatsDocument, baseOptions);
        }
export type CallsByDoctorStatsQueryHookResult = ReturnType<typeof useCallsByDoctorStatsQuery>;
export type CallsByDoctorStatsLazyQueryHookResult = ReturnType<typeof useCallsByDoctorStatsLazyQuery>;
export type CallsByDoctorStatsQueryResult = Apollo.QueryResult<CallsByDoctorStatsQuery, CallsByDoctorStatsQueryVariables>;
export const CallsReportDocument = gql`
    query CallsReport($range: DateRange!) {
  callsReport(range: $range) {
    month
    year
    day
    date
    value
  }
}
    `;

/**
 * __useCallsReportQuery__
 *
 * To run a query within a React component, call `useCallsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallsReportQuery({
 *   variables: {
 *      range: // value for 'range'
 *   },
 * });
 */
export function useCallsReportQuery(baseOptions?: Apollo.QueryHookOptions<CallsReportQuery, CallsReportQueryVariables>) {
        return Apollo.useQuery<CallsReportQuery, CallsReportQueryVariables>(CallsReportDocument, baseOptions);
      }
export function useCallsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallsReportQuery, CallsReportQueryVariables>) {
          return Apollo.useLazyQuery<CallsReportQuery, CallsReportQueryVariables>(CallsReportDocument, baseOptions);
        }
export type CallsReportQueryHookResult = ReturnType<typeof useCallsReportQuery>;
export type CallsReportLazyQueryHookResult = ReturnType<typeof useCallsReportLazyQuery>;
export type CallsReportQueryResult = Apollo.QueryResult<CallsReportQuery, CallsReportQueryVariables>;
export const CallsDocument = gql`
    query Calls($where: CallsWhereInput, $page: Int!, $pageLimit: Int!) {
  calls(where: $where, page: $page, pageLimit: $pageLimit) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      nextPage
    }
    nodes {
      id
      status
      room
      requestTime
      startTime
      endTime
      duration
      participants {
        twilioToken
        id
        role
        status
        joinTime
        account {
          id
          email
          accountStatus
          subscriptionStatus
          role
          createdAt
          phoneNumber
          profileImage(resize: {width: 100})
          profile {
            __typename
            ... on ClientProfile {
              id
              type
              name
              lastname
              birthday
              sex
            }
            ... on DoctorProfile {
              id
              type
              name
              lastname
              birthday
              licenceNumber
              sex
              bio
            }
            ... on SystemUserProfile {
              id
              type
              name
              lastname
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCallsQuery__
 *
 * To run a query within a React component, call `useCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageLimit: // value for 'pageLimit'
 *   },
 * });
 */
export function useCallsQuery(baseOptions?: Apollo.QueryHookOptions<CallsQuery, CallsQueryVariables>) {
        return Apollo.useQuery<CallsQuery, CallsQueryVariables>(CallsDocument, baseOptions);
      }
export function useCallsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallsQuery, CallsQueryVariables>) {
          return Apollo.useLazyQuery<CallsQuery, CallsQueryVariables>(CallsDocument, baseOptions);
        }
export type CallsQueryHookResult = ReturnType<typeof useCallsQuery>;
export type CallsLazyQueryHookResult = ReturnType<typeof useCallsLazyQuery>;
export type CallsQueryResult = Apollo.QueryResult<CallsQuery, CallsQueryVariables>;
export const Calls2CsvDocument = gql`
    mutation Calls2CSV($where: CallsWhereInput, $page: Int!, $pageLimit: Int!) {
  calls2csv(where: $where, page: $page, pageLimit: $pageLimit) {
    url
  }
}
    `;
export type Calls2CsvMutationFn = Apollo.MutationFunction<Calls2CsvMutation, Calls2CsvMutationVariables>;

/**
 * __useCalls2CsvMutation__
 *
 * To run a mutation, you first call `useCalls2CsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalls2CsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calls2CsvMutation, { data, loading, error }] = useCalls2CsvMutation({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageLimit: // value for 'pageLimit'
 *   },
 * });
 */
export function useCalls2CsvMutation(baseOptions?: Apollo.MutationHookOptions<Calls2CsvMutation, Calls2CsvMutationVariables>) {
        return Apollo.useMutation<Calls2CsvMutation, Calls2CsvMutationVariables>(Calls2CsvDocument, baseOptions);
      }
export type Calls2CsvMutationHookResult = ReturnType<typeof useCalls2CsvMutation>;
export type Calls2CsvMutationResult = Apollo.MutationResult<Calls2CsvMutation>;
export type Calls2CsvMutationOptions = Apollo.BaseMutationOptions<Calls2CsvMutation, Calls2CsvMutationVariables>;
export const CitiesDocument = gql`
    query Cities($countryId: Int) {
  cities(countryId: $countryId) {
    id
    name
    rawName {
      sq
      mk
      en
    }
    country {
      id
      name
    }
  }
}
    `;

/**
 * __useCitiesQuery__
 *
 * To run a query within a React component, call `useCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCitiesQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useCitiesQuery(baseOptions?: Apollo.QueryHookOptions<CitiesQuery, CitiesQueryVariables>) {
        return Apollo.useQuery<CitiesQuery, CitiesQueryVariables>(CitiesDocument, baseOptions);
      }
export function useCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CitiesQuery, CitiesQueryVariables>) {
          return Apollo.useLazyQuery<CitiesQuery, CitiesQueryVariables>(CitiesDocument, baseOptions);
        }
export type CitiesQueryHookResult = ReturnType<typeof useCitiesQuery>;
export type CitiesLazyQueryHookResult = ReturnType<typeof useCitiesLazyQuery>;
export type CitiesQueryResult = Apollo.QueryResult<CitiesQuery, CitiesQueryVariables>;
export const CodeStatsDocument = gql`
    query CodeStats {
  codeStats {
    tier {
      id
      name
      pricePerYear
      isPublic
    }
    totalCount
    usedCount
    unusedCount
  }
}
    `;

/**
 * __useCodeStatsQuery__
 *
 * To run a query within a React component, call `useCodeStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCodeStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCodeStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCodeStatsQuery(baseOptions?: Apollo.QueryHookOptions<CodeStatsQuery, CodeStatsQueryVariables>) {
        return Apollo.useQuery<CodeStatsQuery, CodeStatsQueryVariables>(CodeStatsDocument, baseOptions);
      }
export function useCodeStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CodeStatsQuery, CodeStatsQueryVariables>) {
          return Apollo.useLazyQuery<CodeStatsQuery, CodeStatsQueryVariables>(CodeStatsDocument, baseOptions);
        }
export type CodeStatsQueryHookResult = ReturnType<typeof useCodeStatsQuery>;
export type CodeStatsLazyQueryHookResult = ReturnType<typeof useCodeStatsLazyQuery>;
export type CodeStatsQueryResult = Apollo.QueryResult<CodeStatsQuery, CodeStatsQueryVariables>;
export const CodeDocument = gql`
    query Code($code: String!) {
  code(code: $code) {
    id
    code
    type
    status
    issueDate
    claimDate
    tier {
      name
    }
    client {
      id
      email
      accountStatus
      subscriptionStatus
      role
      createdAt
      phoneNumber
      profileImage(resize: {width: 100})
      language {
        code
        name
      }
      profile {
        __typename
        ... on ClientProfile {
          id
          type
          name
          lastname
          birthday
          sex
          subscription {
            id
            tier {
              id
              tierId
              name
              description
              color
              activeDays
              eventsPerMonth
            }
            startDate
            expirationDate
            isActive
            remainingDays
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCodeQuery__
 *
 * To run a query within a React component, call `useCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCodeQuery(baseOptions?: Apollo.QueryHookOptions<CodeQuery, CodeQueryVariables>) {
        return Apollo.useQuery<CodeQuery, CodeQueryVariables>(CodeDocument, baseOptions);
      }
export function useCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CodeQuery, CodeQueryVariables>) {
          return Apollo.useLazyQuery<CodeQuery, CodeQueryVariables>(CodeDocument, baseOptions);
        }
export type CodeQueryHookResult = ReturnType<typeof useCodeQuery>;
export type CodeLazyQueryHookResult = ReturnType<typeof useCodeLazyQuery>;
export type CodeQueryResult = Apollo.QueryResult<CodeQuery, CodeQueryVariables>;
export const Codes2csvDocument = gql`
    mutation Codes2csv {
  codes2csv
}
    `;
export type Codes2csvMutationFn = Apollo.MutationFunction<Codes2csvMutation, Codes2csvMutationVariables>;

/**
 * __useCodes2csvMutation__
 *
 * To run a mutation, you first call `useCodes2csvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCodes2csvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [codes2csvMutation, { data, loading, error }] = useCodes2csvMutation({
 *   variables: {
 *   },
 * });
 */
export function useCodes2csvMutation(baseOptions?: Apollo.MutationHookOptions<Codes2csvMutation, Codes2csvMutationVariables>) {
        return Apollo.useMutation<Codes2csvMutation, Codes2csvMutationVariables>(Codes2csvDocument, baseOptions);
      }
export type Codes2csvMutationHookResult = ReturnType<typeof useCodes2csvMutation>;
export type Codes2csvMutationResult = Apollo.MutationResult<Codes2csvMutation>;
export type Codes2csvMutationOptions = Apollo.BaseMutationOptions<Codes2csvMutation, Codes2csvMutationVariables>;
export const ConfigDocument = gql`
    query Config {
  config {
    policy
    terms
  }
}
    `;

/**
 * __useConfigQuery__
 *
 * To run a query within a React component, call `useConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfigQuery(baseOptions?: Apollo.QueryHookOptions<ConfigQuery, ConfigQueryVariables>) {
        return Apollo.useQuery<ConfigQuery, ConfigQueryVariables>(ConfigDocument, baseOptions);
      }
export function useConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigQuery, ConfigQueryVariables>) {
          return Apollo.useLazyQuery<ConfigQuery, ConfigQueryVariables>(ConfigDocument, baseOptions);
        }
export type ConfigQueryHookResult = ReturnType<typeof useConfigQuery>;
export type ConfigLazyQueryHookResult = ReturnType<typeof useConfigLazyQuery>;
export type ConfigQueryResult = Apollo.QueryResult<ConfigQuery, ConfigQueryVariables>;
export const CountriesDocument = gql`
    query Countries {
  countries {
    id
    name
    rawName {
      sq
      mk
      en
    }
  }
}
    `;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: Apollo.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        return Apollo.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, baseOptions);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          return Apollo.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, baseOptions);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export const DoctorRequestDocument = gql`
    query DoctorRequest($id: Int!) {
  doctorRequest(where: {id: $id}) {
    id
    name
    lastname
    email
    birthday
    createdAt
    phoneNumber
    createdAt
    language {
      code
      name
    }
    licenceNumber
    cvUrl
    sex
    country {
      id
      name
    }
    city {
      id
      name
    }
    healthCenter {
      id
      name
    }
  }
}
    `;

/**
 * __useDoctorRequestQuery__
 *
 * To run a query within a React component, call `useDoctorRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorRequestQuery(baseOptions?: Apollo.QueryHookOptions<DoctorRequestQuery, DoctorRequestQueryVariables>) {
        return Apollo.useQuery<DoctorRequestQuery, DoctorRequestQueryVariables>(DoctorRequestDocument, baseOptions);
      }
export function useDoctorRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorRequestQuery, DoctorRequestQueryVariables>) {
          return Apollo.useLazyQuery<DoctorRequestQuery, DoctorRequestQueryVariables>(DoctorRequestDocument, baseOptions);
        }
export type DoctorRequestQueryHookResult = ReturnType<typeof useDoctorRequestQuery>;
export type DoctorRequestLazyQueryHookResult = ReturnType<typeof useDoctorRequestLazyQuery>;
export type DoctorRequestQueryResult = Apollo.QueryResult<DoctorRequestQuery, DoctorRequestQueryVariables>;
export const AllDoctorRequestsDocument = gql`
    query AllDoctorRequests {
  doctorRequests {
    id
    name
    lastname
    email
    birthday
    createdAt
    phoneNumber
    createdAt
    language {
      code
      name
    }
    licenceNumber
    cvUrl
    sex
    country {
      id
      name
    }
    city {
      id
      name
    }
    healthCenter {
      id
      name
    }
  }
}
    `;

/**
 * __useAllDoctorRequestsQuery__
 *
 * To run a query within a React component, call `useAllDoctorRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDoctorRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDoctorRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllDoctorRequestsQuery(baseOptions?: Apollo.QueryHookOptions<AllDoctorRequestsQuery, AllDoctorRequestsQueryVariables>) {
        return Apollo.useQuery<AllDoctorRequestsQuery, AllDoctorRequestsQueryVariables>(AllDoctorRequestsDocument, baseOptions);
      }
export function useAllDoctorRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDoctorRequestsQuery, AllDoctorRequestsQueryVariables>) {
          return Apollo.useLazyQuery<AllDoctorRequestsQuery, AllDoctorRequestsQueryVariables>(AllDoctorRequestsDocument, baseOptions);
        }
export type AllDoctorRequestsQueryHookResult = ReturnType<typeof useAllDoctorRequestsQuery>;
export type AllDoctorRequestsLazyQueryHookResult = ReturnType<typeof useAllDoctorRequestsLazyQuery>;
export type AllDoctorRequestsQueryResult = Apollo.QueryResult<AllDoctorRequestsQuery, AllDoctorRequestsQueryVariables>;
export const FaqDocument = gql`
    query Faq($id: Int!) {
  frequentlyAskedQuestion(id: $id) {
    id
    title
    rawTitle {
      sq
      en
      mk
    }
    body
    rawBody {
      sq
      en
      mk
    }
  }
}
    `;

/**
 * __useFaqQuery__
 *
 * To run a query within a React component, call `useFaqQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaqQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFaqQuery(baseOptions?: Apollo.QueryHookOptions<FaqQuery, FaqQueryVariables>) {
        return Apollo.useQuery<FaqQuery, FaqQueryVariables>(FaqDocument, baseOptions);
      }
export function useFaqLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaqQuery, FaqQueryVariables>) {
          return Apollo.useLazyQuery<FaqQuery, FaqQueryVariables>(FaqDocument, baseOptions);
        }
export type FaqQueryHookResult = ReturnType<typeof useFaqQuery>;
export type FaqLazyQueryHookResult = ReturnType<typeof useFaqLazyQuery>;
export type FaqQueryResult = Apollo.QueryResult<FaqQuery, FaqQueryVariables>;
export const FaqsDocument = gql`
    query Faqs($search: String) {
  frequentlyAskedQuestions(search: $search) {
    id
    title
    rawTitle {
      sq
      en
      mk
    }
    body
    rawBody {
      sq
      en
      mk
    }
  }
}
    `;

/**
 * __useFaqsQuery__
 *
 * To run a query within a React component, call `useFaqsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaqsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaqsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useFaqsQuery(baseOptions?: Apollo.QueryHookOptions<FaqsQuery, FaqsQueryVariables>) {
        return Apollo.useQuery<FaqsQuery, FaqsQueryVariables>(FaqsDocument, baseOptions);
      }
export function useFaqsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaqsQuery, FaqsQueryVariables>) {
          return Apollo.useLazyQuery<FaqsQuery, FaqsQueryVariables>(FaqsDocument, baseOptions);
        }
export type FaqsQueryHookResult = ReturnType<typeof useFaqsQuery>;
export type FaqsLazyQueryHookResult = ReturnType<typeof useFaqsLazyQuery>;
export type FaqsQueryResult = Apollo.QueryResult<FaqsQuery, FaqsQueryVariables>;
export const GetEventDocument = gql`
    query GetEvent($id: Int!) {
  getEvent(id: $id) {
    id
    title
    description
    cover(resize: {width: 800}) {
      id
      url
      createdAt
      contentType
    }
    specialist {
      ...ShortAccountData
    }
    roomName
    creator {
      ...ShortAccountData
    }
    startDate
    endDate
    durationMinutes
    participants {
      maxNumber
      currentCount
      list {
        ...ShortAccountData
      }
    }
    participationStatus
    createdAt
    updatedAt
  }
}
    ${ShortAccountDataFragmentDoc}`;

/**
 * __useGetEventQuery__
 *
 * To run a query within a React component, call `useGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventQuery(baseOptions?: Apollo.QueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
        return Apollo.useQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, baseOptions);
      }
export function useGetEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
          return Apollo.useLazyQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, baseOptions);
        }
export type GetEventQueryHookResult = ReturnType<typeof useGetEventQuery>;
export type GetEventLazyQueryHookResult = ReturnType<typeof useGetEventLazyQuery>;
export type GetEventQueryResult = Apollo.QueryResult<GetEventQuery, GetEventQueryVariables>;
export const GetEventsNotUserScopedDocument = gql`
    query GetEventsNotUserScoped($epoch: EVENT_EPOCH) {
  getEventsNotUserScoped(where: {epoch: $epoch}) {
    id
    title
    description
    cover(resize: {width: 800}) {
      id
      url
      createdAt
      contentType
    }
    specialist {
      ...ShortAccountData
    }
    roomName
    creator {
      ...ShortAccountData
    }
    startDate
    endDate
    durationMinutes
    participants {
      maxNumber
      currentCount
      list {
        ...ShortAccountData
      }
    }
    participationStatus
    createdAt
    updatedAt
  }
}
    ${ShortAccountDataFragmentDoc}`;

/**
 * __useGetEventsNotUserScopedQuery__
 *
 * To run a query within a React component, call `useGetEventsNotUserScopedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsNotUserScopedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsNotUserScopedQuery({
 *   variables: {
 *      epoch: // value for 'epoch'
 *   },
 * });
 */
export function useGetEventsNotUserScopedQuery(baseOptions?: Apollo.QueryHookOptions<GetEventsNotUserScopedQuery, GetEventsNotUserScopedQueryVariables>) {
        return Apollo.useQuery<GetEventsNotUserScopedQuery, GetEventsNotUserScopedQueryVariables>(GetEventsNotUserScopedDocument, baseOptions);
      }
export function useGetEventsNotUserScopedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsNotUserScopedQuery, GetEventsNotUserScopedQueryVariables>) {
          return Apollo.useLazyQuery<GetEventsNotUserScopedQuery, GetEventsNotUserScopedQueryVariables>(GetEventsNotUserScopedDocument, baseOptions);
        }
export type GetEventsNotUserScopedQueryHookResult = ReturnType<typeof useGetEventsNotUserScopedQuery>;
export type GetEventsNotUserScopedLazyQueryHookResult = ReturnType<typeof useGetEventsNotUserScopedLazyQuery>;
export type GetEventsNotUserScopedQueryResult = Apollo.QueryResult<GetEventsNotUserScopedQuery, GetEventsNotUserScopedQueryVariables>;
export const GetEventsDocument = gql`
    query GetEvents($epoch: EVENT_EPOCH) {
  getEvents(where: {epoch: $epoch}) {
    id
    title
    description
    cover(resize: {width: 800}) {
      id
      url
      createdAt
      contentType
    }
    specialist {
      ...ShortAccountData
    }
    roomName
    creator {
      ...ShortAccountData
    }
    startDate
    endDate
    durationMinutes
    participants {
      maxNumber
      currentCount
      list {
        ...ShortAccountData
      }
    }
    participationStatus
    createdAt
    updatedAt
  }
}
    ${ShortAccountDataFragmentDoc}`;

/**
 * __useGetEventsQuery__
 *
 * To run a query within a React component, call `useGetEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsQuery({
 *   variables: {
 *      epoch: // value for 'epoch'
 *   },
 * });
 */
export function useGetEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetEventsQuery, GetEventsQueryVariables>) {
        return Apollo.useQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, baseOptions);
      }
export function useGetEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsQuery, GetEventsQueryVariables>) {
          return Apollo.useLazyQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, baseOptions);
        }
export type GetEventsQueryHookResult = ReturnType<typeof useGetEventsQuery>;
export type GetEventsLazyQueryHookResult = ReturnType<typeof useGetEventsLazyQuery>;
export type GetEventsQueryResult = Apollo.QueryResult<GetEventsQuery, GetEventsQueryVariables>;
export const GetHostedEventsDocument = gql`
    query GetHostedEvents($epoch: EVENT_EPOCH) {
  getEvents(where: {epoch: $epoch, participationRole: HOST}) {
    id
    title
    description
    cover(resize: {width: 800}) {
      id
      url
      createdAt
      contentType
    }
    specialist {
      ...ShortAccountData
    }
    roomName
    creator {
      ...ShortAccountData
    }
    startDate
    endDate
    durationMinutes
    participants {
      maxNumber
      currentCount
      list {
        ...ShortAccountData
      }
    }
    participationStatus
    createdAt
    updatedAt
  }
}
    ${ShortAccountDataFragmentDoc}`;

/**
 * __useGetHostedEventsQuery__
 *
 * To run a query within a React component, call `useGetHostedEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHostedEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHostedEventsQuery({
 *   variables: {
 *      epoch: // value for 'epoch'
 *   },
 * });
 */
export function useGetHostedEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetHostedEventsQuery, GetHostedEventsQueryVariables>) {
        return Apollo.useQuery<GetHostedEventsQuery, GetHostedEventsQueryVariables>(GetHostedEventsDocument, baseOptions);
      }
export function useGetHostedEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHostedEventsQuery, GetHostedEventsQueryVariables>) {
          return Apollo.useLazyQuery<GetHostedEventsQuery, GetHostedEventsQueryVariables>(GetHostedEventsDocument, baseOptions);
        }
export type GetHostedEventsQueryHookResult = ReturnType<typeof useGetHostedEventsQuery>;
export type GetHostedEventsLazyQueryHookResult = ReturnType<typeof useGetHostedEventsLazyQuery>;
export type GetHostedEventsQueryResult = Apollo.QueryResult<GetHostedEventsQuery, GetHostedEventsQueryVariables>;
export const GetMedicalCardDocumentDocument = gql`
    query GetMedicalCardDocument($id: Int!) {
  getMedicalCardDocument(id: $id) {
    id
    createdAt
    updatedAt
    author {
      ...ShortAccountData
    }
    medicalCard {
      patient {
        ...ShortAccountData
      }
    }
    thumbnail: media(size: MEDIUM) {
      id
      url
      createdAt
      contentType
      byteSize
    }
    media {
      contentType
      url
    }
    description
    comments {
      id
      author {
        ...ShortAccountData
      }
      content
      createdAt
      updatedAt
    }
  }
}
    ${ShortAccountDataFragmentDoc}`;

/**
 * __useGetMedicalCardDocumentQuery__
 *
 * To run a query within a React component, call `useGetMedicalCardDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMedicalCardDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMedicalCardDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMedicalCardDocumentQuery(baseOptions?: Apollo.QueryHookOptions<GetMedicalCardDocumentQuery, GetMedicalCardDocumentQueryVariables>) {
        return Apollo.useQuery<GetMedicalCardDocumentQuery, GetMedicalCardDocumentQueryVariables>(GetMedicalCardDocumentDocument, baseOptions);
      }
export function useGetMedicalCardDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMedicalCardDocumentQuery, GetMedicalCardDocumentQueryVariables>) {
          return Apollo.useLazyQuery<GetMedicalCardDocumentQuery, GetMedicalCardDocumentQueryVariables>(GetMedicalCardDocumentDocument, baseOptions);
        }
export type GetMedicalCardDocumentQueryHookResult = ReturnType<typeof useGetMedicalCardDocumentQuery>;
export type GetMedicalCardDocumentLazyQueryHookResult = ReturnType<typeof useGetMedicalCardDocumentLazyQuery>;
export type GetMedicalCardDocumentQueryResult = Apollo.QueryResult<GetMedicalCardDocumentQuery, GetMedicalCardDocumentQueryVariables>;
export const GetMedicalCardDocument = gql`
    query GetMedicalCard($id: Int!) {
  getMedicalCard(id: $id) {
    id
    patient {
      ...ShortAccountData
    }
    doctor {
      ...ShortAccountData
    }
    symptoms
    diagnosis
    diagnosis
    recommendation
    recipe
    privateNote
    createdAt
    updatedAt
    concernCategory {
      id
      name
    }
    documents {
      id
      author {
        ...ShortAccountData
      }
      thumbnail: media(size: MEDIUM) {
        id
        url
        createdAt
        contentType
        byteSize
      }
      media {
        url
      }
      description
      comments {
        author {
          ...ShortAccountData
        }
        content
        createdAt
        updatedAt
      }
    }
    comments {
      id
      author {
        ...ShortAccountData
      }
      content
      createdAt
      updatedAt
    }
  }
}
    ${ShortAccountDataFragmentDoc}`;

/**
 * __useGetMedicalCardQuery__
 *
 * To run a query within a React component, call `useGetMedicalCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMedicalCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMedicalCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMedicalCardQuery(baseOptions?: Apollo.QueryHookOptions<GetMedicalCardQuery, GetMedicalCardQueryVariables>) {
        return Apollo.useQuery<GetMedicalCardQuery, GetMedicalCardQueryVariables>(GetMedicalCardDocument, baseOptions);
      }
export function useGetMedicalCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMedicalCardQuery, GetMedicalCardQueryVariables>) {
          return Apollo.useLazyQuery<GetMedicalCardQuery, GetMedicalCardQueryVariables>(GetMedicalCardDocument, baseOptions);
        }
export type GetMedicalCardQueryHookResult = ReturnType<typeof useGetMedicalCardQuery>;
export type GetMedicalCardLazyQueryHookResult = ReturnType<typeof useGetMedicalCardLazyQuery>;
export type GetMedicalCardQueryResult = Apollo.QueryResult<GetMedicalCardQuery, GetMedicalCardQueryVariables>;
export const GetMedicalCardsDocument = gql`
    query GetMedicalCards($patientId: Int!) {
  getMedicalCards(patientId: $patientId) {
    id
    patient {
      ...ShortAccountData
    }
    doctor {
      ...ShortAccountData
    }
    symptoms
    diagnosis
    diagnosis
    recommendation
    recipe
    privateNote
    createdAt
    updatedAt
    documents {
      id
      author {
        ...ShortAccountData
      }
      thumbnail: media(size: MEDIUM) {
        id
        url
        createdAt
        contentType
        byteSize
      }
      media {
        url
      }
      description
      comments {
        author {
          ...ShortAccountData
        }
        content
        createdAt
        updatedAt
      }
    }
    comments {
      id
      author {
        ...ShortAccountData
      }
      content
      createdAt
      updatedAt
    }
  }
}
    ${ShortAccountDataFragmentDoc}`;

/**
 * __useGetMedicalCardsQuery__
 *
 * To run a query within a React component, call `useGetMedicalCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMedicalCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMedicalCardsQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useGetMedicalCardsQuery(baseOptions?: Apollo.QueryHookOptions<GetMedicalCardsQuery, GetMedicalCardsQueryVariables>) {
        return Apollo.useQuery<GetMedicalCardsQuery, GetMedicalCardsQueryVariables>(GetMedicalCardsDocument, baseOptions);
      }
export function useGetMedicalCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMedicalCardsQuery, GetMedicalCardsQueryVariables>) {
          return Apollo.useLazyQuery<GetMedicalCardsQuery, GetMedicalCardsQueryVariables>(GetMedicalCardsDocument, baseOptions);
        }
export type GetMedicalCardsQueryHookResult = ReturnType<typeof useGetMedicalCardsQuery>;
export type GetMedicalCardsLazyQueryHookResult = ReturnType<typeof useGetMedicalCardsLazyQuery>;
export type GetMedicalCardsQueryResult = Apollo.QueryResult<GetMedicalCardsQuery, GetMedicalCardsQueryVariables>;
export const GetPresignedPublicS3UrlDocument = gql`
    query GetPresignedPublicS3Url($fileName: String!) {
  getPresignedPublicS3Url(data: {fileName: $fileName}) {
    key
    url
    expiry
    contentType
  }
}
    `;

/**
 * __useGetPresignedPublicS3UrlQuery__
 *
 * To run a query within a React component, call `useGetPresignedPublicS3UrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPresignedPublicS3UrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPresignedPublicS3UrlQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useGetPresignedPublicS3UrlQuery(baseOptions?: Apollo.QueryHookOptions<GetPresignedPublicS3UrlQuery, GetPresignedPublicS3UrlQueryVariables>) {
        return Apollo.useQuery<GetPresignedPublicS3UrlQuery, GetPresignedPublicS3UrlQueryVariables>(GetPresignedPublicS3UrlDocument, baseOptions);
      }
export function useGetPresignedPublicS3UrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPresignedPublicS3UrlQuery, GetPresignedPublicS3UrlQueryVariables>) {
          return Apollo.useLazyQuery<GetPresignedPublicS3UrlQuery, GetPresignedPublicS3UrlQueryVariables>(GetPresignedPublicS3UrlDocument, baseOptions);
        }
export type GetPresignedPublicS3UrlQueryHookResult = ReturnType<typeof useGetPresignedPublicS3UrlQuery>;
export type GetPresignedPublicS3UrlLazyQueryHookResult = ReturnType<typeof useGetPresignedPublicS3UrlLazyQuery>;
export type GetPresignedPublicS3UrlQueryResult = Apollo.QueryResult<GetPresignedPublicS3UrlQuery, GetPresignedPublicS3UrlQueryVariables>;
export const GetPresignedS3UrlDocument = gql`
    query GetPresignedS3Url($fileName: String!) {
  getPresignedS3Url(data: {fileName: $fileName}) {
    key
    url
    expiry
    contentType
  }
}
    `;

/**
 * __useGetPresignedS3UrlQuery__
 *
 * To run a query within a React component, call `useGetPresignedS3UrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPresignedS3UrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPresignedS3UrlQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useGetPresignedS3UrlQuery(baseOptions?: Apollo.QueryHookOptions<GetPresignedS3UrlQuery, GetPresignedS3UrlQueryVariables>) {
        return Apollo.useQuery<GetPresignedS3UrlQuery, GetPresignedS3UrlQueryVariables>(GetPresignedS3UrlDocument, baseOptions);
      }
export function useGetPresignedS3UrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPresignedS3UrlQuery, GetPresignedS3UrlQueryVariables>) {
          return Apollo.useLazyQuery<GetPresignedS3UrlQuery, GetPresignedS3UrlQueryVariables>(GetPresignedS3UrlDocument, baseOptions);
        }
export type GetPresignedS3UrlQueryHookResult = ReturnType<typeof useGetPresignedS3UrlQuery>;
export type GetPresignedS3UrlLazyQueryHookResult = ReturnType<typeof useGetPresignedS3UrlLazyQuery>;
export type GetPresignedS3UrlQueryResult = Apollo.QueryResult<GetPresignedS3UrlQuery, GetPresignedS3UrlQueryVariables>;
export const GetSubscriptionsThatNeedReviewDocument = gql`
    query GetSubscriptionsThatNeedReview {
  getSubscriptionsThatNeedReview {
    totalCount
    nodes {
      id
      account {
        id
        email
        profileImage
        role
        profile {
          ... on ClientProfile {
            name
            lastname
          }
        }
      }
      tier {
        id
        name
        description
        color
        pricePerYear
      }
      startDate
      expirationDate
      isActive
      authorization {
        __typename
        ... on InsurancePolicyHolderSubscriptionAuthorization {
          type
          insurancePolicy {
            name
          }
          insurancePolicySerialNumber
          status
          insuranceUsageType
          insuranceCodeType
          tier {
            name
          }
          createdAt
        }
        ... on TierCardHolderSubscriptionAuthorization {
          type
          payment {
            amount
          }
          tier {
            name
          }
          createdAt
          tierCode {
            code
            id
            type
            status
            claimDate
            issueDate
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSubscriptionsThatNeedReviewQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionsThatNeedReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionsThatNeedReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionsThatNeedReviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscriptionsThatNeedReviewQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionsThatNeedReviewQuery, GetSubscriptionsThatNeedReviewQueryVariables>) {
        return Apollo.useQuery<GetSubscriptionsThatNeedReviewQuery, GetSubscriptionsThatNeedReviewQueryVariables>(GetSubscriptionsThatNeedReviewDocument, baseOptions);
      }
export function useGetSubscriptionsThatNeedReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionsThatNeedReviewQuery, GetSubscriptionsThatNeedReviewQueryVariables>) {
          return Apollo.useLazyQuery<GetSubscriptionsThatNeedReviewQuery, GetSubscriptionsThatNeedReviewQueryVariables>(GetSubscriptionsThatNeedReviewDocument, baseOptions);
        }
export type GetSubscriptionsThatNeedReviewQueryHookResult = ReturnType<typeof useGetSubscriptionsThatNeedReviewQuery>;
export type GetSubscriptionsThatNeedReviewLazyQueryHookResult = ReturnType<typeof useGetSubscriptionsThatNeedReviewLazyQuery>;
export type GetSubscriptionsThatNeedReviewQueryResult = Apollo.QueryResult<GetSubscriptionsThatNeedReviewQuery, GetSubscriptionsThatNeedReviewQueryVariables>;
export const HealthCentersDocument = gql`
    query HealthCenters($cityId: Int) {
  healthCenters(cityId: $cityId) {
    id
    name
    rawName {
      sq
      mk
      en
    }
    city {
      id
      name
    }
  }
}
    `;

/**
 * __useHealthCentersQuery__
 *
 * To run a query within a React component, call `useHealthCentersQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthCentersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHealthCentersQuery({
 *   variables: {
 *      cityId: // value for 'cityId'
 *   },
 * });
 */
export function useHealthCentersQuery(baseOptions?: Apollo.QueryHookOptions<HealthCentersQuery, HealthCentersQueryVariables>) {
        return Apollo.useQuery<HealthCentersQuery, HealthCentersQueryVariables>(HealthCentersDocument, baseOptions);
      }
export function useHealthCentersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HealthCentersQuery, HealthCentersQueryVariables>) {
          return Apollo.useLazyQuery<HealthCentersQuery, HealthCentersQueryVariables>(HealthCentersDocument, baseOptions);
        }
export type HealthCentersQueryHookResult = ReturnType<typeof useHealthCentersQuery>;
export type HealthCentersLazyQueryHookResult = ReturnType<typeof useHealthCentersLazyQuery>;
export type HealthCentersQueryResult = Apollo.QueryResult<HealthCentersQuery, HealthCentersQueryVariables>;
export const InsurancePoliciesDocument = gql`
    query InsurancePolicies {
  insurancePolicies {
    id
    name
    rawName {
      sq
      mk
      en
    }
  }
}
    `;

/**
 * __useInsurancePoliciesQuery__
 *
 * To run a query within a React component, call `useInsurancePoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsurancePoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsurancePoliciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInsurancePoliciesQuery(baseOptions?: Apollo.QueryHookOptions<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>) {
        return Apollo.useQuery<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>(InsurancePoliciesDocument, baseOptions);
      }
export function useInsurancePoliciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>) {
          return Apollo.useLazyQuery<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>(InsurancePoliciesDocument, baseOptions);
        }
export type InsurancePoliciesQueryHookResult = ReturnType<typeof useInsurancePoliciesQuery>;
export type InsurancePoliciesLazyQueryHookResult = ReturnType<typeof useInsurancePoliciesLazyQuery>;
export type InsurancePoliciesQueryResult = Apollo.QueryResult<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>;
export const LanguagesDocument = gql`
    query Languages {
  languages {
    code
    name
  }
}
    `;

/**
 * __useLanguagesQuery__
 *
 * To run a query within a React component, call `useLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<LanguagesQuery, LanguagesQueryVariables>) {
        return Apollo.useQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, baseOptions);
      }
export function useLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LanguagesQuery, LanguagesQueryVariables>) {
          return Apollo.useLazyQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, baseOptions);
        }
export type LanguagesQueryHookResult = ReturnType<typeof useLanguagesQuery>;
export type LanguagesLazyQueryHookResult = ReturnType<typeof useLanguagesLazyQuery>;
export type LanguagesQueryResult = Apollo.QueryResult<LanguagesQuery, LanguagesQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    id
    email
    accountStatus
    subscriptionStatus
    role
    createdAt
    phoneNumber
    profileImage(resize: {width: 100})
    language {
      code
      name
    }
    profile {
      __typename
      ... on ClientProfile {
        id
        type
        name
        lastname
        birthday
        sex
        subscription {
          id
          tier {
            id
            tierId
            name
            description
            color
            activeDays
            eventsPerMonth
          }
          startDate
          expirationDate
          isActive
          remainingDays
        }
      }
      ... on DoctorProfile {
        id
        type
        name
        lastname
        birthday
        licenceNumber
        country {
          id
          name
        }
        city {
          id
          name
        }
        healthCenter {
          id
          name
        }
        speciality {
          id
          name
        }
        sex
        bio
      }
      ... on SystemUserProfile {
        id
        type
        name
        lastname
      }
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, baseOptions);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, baseOptions);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const MediaLibraryItemDocument = gql`
    query MediaLibraryItem($id: Int!) {
  mediaLibraryItem(where: {id: $id}) {
    id
    title
    thumbnail: media(size: THUMBNAIL) {
      url
      contentType
    }
    medium: media(size: MEDIUM) {
      url
      contentType
    }
    large: media(size: LARGE) {
      url
      contentType
    }
    createdAt
  }
}
    `;

/**
 * __useMediaLibraryItemQuery__
 *
 * To run a query within a React component, call `useMediaLibraryItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaLibraryItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaLibraryItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMediaLibraryItemQuery(baseOptions?: Apollo.QueryHookOptions<MediaLibraryItemQuery, MediaLibraryItemQueryVariables>) {
        return Apollo.useQuery<MediaLibraryItemQuery, MediaLibraryItemQueryVariables>(MediaLibraryItemDocument, baseOptions);
      }
export function useMediaLibraryItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaLibraryItemQuery, MediaLibraryItemQueryVariables>) {
          return Apollo.useLazyQuery<MediaLibraryItemQuery, MediaLibraryItemQueryVariables>(MediaLibraryItemDocument, baseOptions);
        }
export type MediaLibraryItemQueryHookResult = ReturnType<typeof useMediaLibraryItemQuery>;
export type MediaLibraryItemLazyQueryHookResult = ReturnType<typeof useMediaLibraryItemLazyQuery>;
export type MediaLibraryItemQueryResult = Apollo.QueryResult<MediaLibraryItemQuery, MediaLibraryItemQueryVariables>;
export const MediaLibraryItemsDocument = gql`
    query MediaLibraryItems($search: String!, $page: Int!, $pageLimit: Int!) {
  mediaLibraryItems(where: {search: $search}, page: $page, pageLimit: $pageLimit) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      nextPage
    }
    nodes {
      id
      title
      thumbnail: media(size: THUMBNAIL) {
        url
        contentType
      }
      medium: media(size: MEDIUM) {
        url
        contentType
      }
      large: media(size: LARGE) {
        url
        contentType
      }
      createdAt
    }
  }
}
    `;

/**
 * __useMediaLibraryItemsQuery__
 *
 * To run a query within a React component, call `useMediaLibraryItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaLibraryItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaLibraryItemsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      pageLimit: // value for 'pageLimit'
 *   },
 * });
 */
export function useMediaLibraryItemsQuery(baseOptions?: Apollo.QueryHookOptions<MediaLibraryItemsQuery, MediaLibraryItemsQueryVariables>) {
        return Apollo.useQuery<MediaLibraryItemsQuery, MediaLibraryItemsQueryVariables>(MediaLibraryItemsDocument, baseOptions);
      }
export function useMediaLibraryItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaLibraryItemsQuery, MediaLibraryItemsQueryVariables>) {
          return Apollo.useLazyQuery<MediaLibraryItemsQuery, MediaLibraryItemsQueryVariables>(MediaLibraryItemsDocument, baseOptions);
        }
export type MediaLibraryItemsQueryHookResult = ReturnType<typeof useMediaLibraryItemsQuery>;
export type MediaLibraryItemsLazyQueryHookResult = ReturnType<typeof useMediaLibraryItemsLazyQuery>;
export type MediaLibraryItemsQueryResult = Apollo.QueryResult<MediaLibraryItemsQuery, MediaLibraryItemsQueryVariables>;
export const MedicalCardsByMedicalConcernReportDocument = gql`
    query MedicalCardsByMedicalConcernReport($range: DateRange!) {
  medicalCardsByMedicalConcernReport(range: $range) {
    name
    value
  }
}
    `;

/**
 * __useMedicalCardsByMedicalConcernReportQuery__
 *
 * To run a query within a React component, call `useMedicalCardsByMedicalConcernReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicalCardsByMedicalConcernReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicalCardsByMedicalConcernReportQuery({
 *   variables: {
 *      range: // value for 'range'
 *   },
 * });
 */
export function useMedicalCardsByMedicalConcernReportQuery(baseOptions?: Apollo.QueryHookOptions<MedicalCardsByMedicalConcernReportQuery, MedicalCardsByMedicalConcernReportQueryVariables>) {
        return Apollo.useQuery<MedicalCardsByMedicalConcernReportQuery, MedicalCardsByMedicalConcernReportQueryVariables>(MedicalCardsByMedicalConcernReportDocument, baseOptions);
      }
export function useMedicalCardsByMedicalConcernReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedicalCardsByMedicalConcernReportQuery, MedicalCardsByMedicalConcernReportQueryVariables>) {
          return Apollo.useLazyQuery<MedicalCardsByMedicalConcernReportQuery, MedicalCardsByMedicalConcernReportQueryVariables>(MedicalCardsByMedicalConcernReportDocument, baseOptions);
        }
export type MedicalCardsByMedicalConcernReportQueryHookResult = ReturnType<typeof useMedicalCardsByMedicalConcernReportQuery>;
export type MedicalCardsByMedicalConcernReportLazyQueryHookResult = ReturnType<typeof useMedicalCardsByMedicalConcernReportLazyQuery>;
export type MedicalCardsByMedicalConcernReportQueryResult = Apollo.QueryResult<MedicalCardsByMedicalConcernReportQuery, MedicalCardsByMedicalConcernReportQueryVariables>;
export const MedicalConcernCategoriesDocument = gql`
    query MedicalConcernCategories {
  medicalConcernCategories {
    id
    name
    rawName {
      sq
      mk
      en
    }
  }
}
    `;

/**
 * __useMedicalConcernCategoriesQuery__
 *
 * To run a query within a React component, call `useMedicalConcernCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicalConcernCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicalConcernCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMedicalConcernCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<MedicalConcernCategoriesQuery, MedicalConcernCategoriesQueryVariables>) {
        return Apollo.useQuery<MedicalConcernCategoriesQuery, MedicalConcernCategoriesQueryVariables>(MedicalConcernCategoriesDocument, baseOptions);
      }
export function useMedicalConcernCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedicalConcernCategoriesQuery, MedicalConcernCategoriesQueryVariables>) {
          return Apollo.useLazyQuery<MedicalConcernCategoriesQuery, MedicalConcernCategoriesQueryVariables>(MedicalConcernCategoriesDocument, baseOptions);
        }
export type MedicalConcernCategoriesQueryHookResult = ReturnType<typeof useMedicalConcernCategoriesQuery>;
export type MedicalConcernCategoriesLazyQueryHookResult = ReturnType<typeof useMedicalConcernCategoriesLazyQuery>;
export type MedicalConcernCategoriesQueryResult = Apollo.QueryResult<MedicalConcernCategoriesQuery, MedicalConcernCategoriesQueryVariables>;
export const MyCallsDocument = gql`
    query MyCalls($where: MyCallsWhereInput, $page: Int = 1, $pageLimit: Int = 100) {
  myCalls(where: $where, page: $page, pageLimit: $pageLimit) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      nextPage
    }
    nodes {
      id
      status
      room
      requestTime
      startTime
      endTime
      duration
      participants {
        twilioToken
        id
        role
        status
        joinTime
        account {
          id
          email
          accountStatus
          subscriptionStatus
          role
          createdAt
          language {
            code
            name
          }
          profile {
            __typename
            ... on ClientProfile {
              id
              name
              lastname
              birthday
              sex
            }
            ... on DoctorProfile {
              id
              name
              lastname
              birthday
              sex
            }
            ... on SystemUserProfile {
              id
              type
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMyCallsQuery__
 *
 * To run a query within a React component, call `useMyCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCallsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageLimit: // value for 'pageLimit'
 *   },
 * });
 */
export function useMyCallsQuery(baseOptions?: Apollo.QueryHookOptions<MyCallsQuery, MyCallsQueryVariables>) {
        return Apollo.useQuery<MyCallsQuery, MyCallsQueryVariables>(MyCallsDocument, baseOptions);
      }
export function useMyCallsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCallsQuery, MyCallsQueryVariables>) {
          return Apollo.useLazyQuery<MyCallsQuery, MyCallsQueryVariables>(MyCallsDocument, baseOptions);
        }
export type MyCallsQueryHookResult = ReturnType<typeof useMyCallsQuery>;
export type MyCallsLazyQueryHookResult = ReturnType<typeof useMyCallsLazyQuery>;
export type MyCallsQueryResult = Apollo.QueryResult<MyCallsQuery, MyCallsQueryVariables>;
export const MyContactsDocument = gql`
    query MyContacts($contains: String, $callDate: FromToDate, $page: Int!, $pageLimit: Int!) {
  myContacts(
    where: {contains: $contains, callDate: $callDate}
    page: $page
    pageLimit: $pageLimit
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      nextPage
    }
    totalCount
    nodes {
      id
      email
      accountStatus
      subscriptionStatus
      role
      createdAt
      phoneNumber
      profile {
        __typename
        ... on ClientProfile {
          id
          name
          lastname
          birthday
          sex
        }
        ... on DoctorProfile {
          id
          name
          lastname
          birthday
          sex
        }
        ... on SystemUserProfile {
          id
          type
          name
          lastname
        }
      }
    }
  }
}
    `;

/**
 * __useMyContactsQuery__
 *
 * To run a query within a React component, call `useMyContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyContactsQuery({
 *   variables: {
 *      contains: // value for 'contains'
 *      callDate: // value for 'callDate'
 *      page: // value for 'page'
 *      pageLimit: // value for 'pageLimit'
 *   },
 * });
 */
export function useMyContactsQuery(baseOptions?: Apollo.QueryHookOptions<MyContactsQuery, MyContactsQueryVariables>) {
        return Apollo.useQuery<MyContactsQuery, MyContactsQueryVariables>(MyContactsDocument, baseOptions);
      }
export function useMyContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyContactsQuery, MyContactsQueryVariables>) {
          return Apollo.useLazyQuery<MyContactsQuery, MyContactsQueryVariables>(MyContactsDocument, baseOptions);
        }
export type MyContactsQueryHookResult = ReturnType<typeof useMyContactsQuery>;
export type MyContactsLazyQueryHookResult = ReturnType<typeof useMyContactsLazyQuery>;
export type MyContactsQueryResult = Apollo.QueryResult<MyContactsQuery, MyContactsQueryVariables>;
export const SpecialitiesDocument = gql`
    query Specialities {
  specialities {
    id
    name
    rawName {
      sq
      mk
      en
    }
  }
}
    `;

/**
 * __useSpecialitiesQuery__
 *
 * To run a query within a React component, call `useSpecialitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecialitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecialitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpecialitiesQuery(baseOptions?: Apollo.QueryHookOptions<SpecialitiesQuery, SpecialitiesQueryVariables>) {
        return Apollo.useQuery<SpecialitiesQuery, SpecialitiesQueryVariables>(SpecialitiesDocument, baseOptions);
      }
export function useSpecialitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpecialitiesQuery, SpecialitiesQueryVariables>) {
          return Apollo.useLazyQuery<SpecialitiesQuery, SpecialitiesQueryVariables>(SpecialitiesDocument, baseOptions);
        }
export type SpecialitiesQueryHookResult = ReturnType<typeof useSpecialitiesQuery>;
export type SpecialitiesLazyQueryHookResult = ReturnType<typeof useSpecialitiesLazyQuery>;
export type SpecialitiesQueryResult = Apollo.QueryResult<SpecialitiesQuery, SpecialitiesQueryVariables>;
export const StoriesDocument = gql`
    query Stories($iconWidth: Int!) {
  stories {
    id
    title
    author {
      ...ShortAccountDataFragment
    }
    icon(resize: {width: $iconWidth}) {
      contentType
      url
      key
    }
    title
    isActive
    items {
      id
      type
      linkURL
      linkLabel
      bgColor
      language {
        code
        name
      }
      media {
        contentType
        url
        key
      }
      createdAt
      updatedAt
    }
    order
    rawTitle {
      sq
      en
      mk
    }
    createdAt
    updatedAt
  }
}
    ${ShortAccountDataFragmentFragmentDoc}`;

/**
 * __useStoriesQuery__
 *
 * To run a query within a React component, call `useStoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoriesQuery({
 *   variables: {
 *      iconWidth: // value for 'iconWidth'
 *   },
 * });
 */
export function useStoriesQuery(baseOptions?: Apollo.QueryHookOptions<StoriesQuery, StoriesQueryVariables>) {
        return Apollo.useQuery<StoriesQuery, StoriesQueryVariables>(StoriesDocument, baseOptions);
      }
export function useStoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoriesQuery, StoriesQueryVariables>) {
          return Apollo.useLazyQuery<StoriesQuery, StoriesQueryVariables>(StoriesDocument, baseOptions);
        }
export type StoriesQueryHookResult = ReturnType<typeof useStoriesQuery>;
export type StoriesLazyQueryHookResult = ReturnType<typeof useStoriesLazyQuery>;
export type StoriesQueryResult = Apollo.QueryResult<StoriesQuery, StoriesQueryVariables>;
export const StoryDocument = gql`
    query Story($id: Int!, $iconWidth: Int!) {
  story(id: $id) {
    id
    title
    author {
      ...ShortAccountDataFragment
    }
    icon(resize: {width: $iconWidth}) {
      contentType
      url
      key
    }
    title
    isActive
    items {
      id
      type
      isActive
      author {
        ...ShortAccountDataFragment
      }
      linkURL
      linkLabel
      bgColor
      language {
        code
        name
      }
      media {
        contentType
        url
        key
      }
      createdAt
      updatedAt
    }
    order
    rawTitle {
      sq
      en
      mk
    }
    createdAt
    updatedAt
  }
}
    ${ShortAccountDataFragmentFragmentDoc}`;

/**
 * __useStoryQuery__
 *
 * To run a query within a React component, call `useStoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      iconWidth: // value for 'iconWidth'
 *   },
 * });
 */
export function useStoryQuery(baseOptions?: Apollo.QueryHookOptions<StoryQuery, StoryQueryVariables>) {
        return Apollo.useQuery<StoryQuery, StoryQueryVariables>(StoryDocument, baseOptions);
      }
export function useStoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoryQuery, StoryQueryVariables>) {
          return Apollo.useLazyQuery<StoryQuery, StoryQueryVariables>(StoryDocument, baseOptions);
        }
export type StoryQueryHookResult = ReturnType<typeof useStoryQuery>;
export type StoryLazyQueryHookResult = ReturnType<typeof useStoryLazyQuery>;
export type StoryQueryResult = Apollo.QueryResult<StoryQuery, StoryQueryVariables>;
export const SubscriptionsByTierDocument = gql`
    query subscriptionsByTier {
  subscriptionsByTier {
    tierId
    tierName
    subscriptions
  }
}
    `;

/**
 * __useSubscriptionsByTierQuery__
 *
 * To run a query within a React component, call `useSubscriptionsByTierQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionsByTierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionsByTierQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionsByTierQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionsByTierQuery, SubscriptionsByTierQueryVariables>) {
        return Apollo.useQuery<SubscriptionsByTierQuery, SubscriptionsByTierQueryVariables>(SubscriptionsByTierDocument, baseOptions);
      }
export function useSubscriptionsByTierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionsByTierQuery, SubscriptionsByTierQueryVariables>) {
          return Apollo.useLazyQuery<SubscriptionsByTierQuery, SubscriptionsByTierQueryVariables>(SubscriptionsByTierDocument, baseOptions);
        }
export type SubscriptionsByTierQueryHookResult = ReturnType<typeof useSubscriptionsByTierQuery>;
export type SubscriptionsByTierLazyQueryHookResult = ReturnType<typeof useSubscriptionsByTierLazyQuery>;
export type SubscriptionsByTierQueryResult = Apollo.QueryResult<SubscriptionsByTierQuery, SubscriptionsByTierQueryVariables>;
export const SubscriptionsReportDocument = gql`
    query SubscriptionsReport($range: DateRange!) {
  subscriptionsReport(range: $range) {
    month
    year
    day
    date
    value
  }
}
    `;

/**
 * __useSubscriptionsReportQuery__
 *
 * To run a query within a React component, call `useSubscriptionsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionsReportQuery({
 *   variables: {
 *      range: // value for 'range'
 *   },
 * });
 */
export function useSubscriptionsReportQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionsReportQuery, SubscriptionsReportQueryVariables>) {
        return Apollo.useQuery<SubscriptionsReportQuery, SubscriptionsReportQueryVariables>(SubscriptionsReportDocument, baseOptions);
      }
export function useSubscriptionsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionsReportQuery, SubscriptionsReportQueryVariables>) {
          return Apollo.useLazyQuery<SubscriptionsReportQuery, SubscriptionsReportQueryVariables>(SubscriptionsReportDocument, baseOptions);
        }
export type SubscriptionsReportQueryHookResult = ReturnType<typeof useSubscriptionsReportQuery>;
export type SubscriptionsReportLazyQueryHookResult = ReturnType<typeof useSubscriptionsReportLazyQuery>;
export type SubscriptionsReportQueryResult = Apollo.QueryResult<SubscriptionsReportQuery, SubscriptionsReportQueryVariables>;
export const Subscriptions2CsvDocument = gql`
    mutation Subscriptions2Csv($range: DateRange, $endRange: DateRange, $tierId: Int) {
  subscriptions2csv(range: $range, endRange: $endRange, tierId: $tierId)
}
    `;
export type Subscriptions2CsvMutationFn = Apollo.MutationFunction<Subscriptions2CsvMutation, Subscriptions2CsvMutationVariables>;

/**
 * __useSubscriptions2CsvMutation__
 *
 * To run a mutation, you first call `useSubscriptions2CsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptions2CsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptions2CsvMutation, { data, loading, error }] = useSubscriptions2CsvMutation({
 *   variables: {
 *      range: // value for 'range'
 *      endRange: // value for 'endRange'
 *      tierId: // value for 'tierId'
 *   },
 * });
 */
export function useSubscriptions2CsvMutation(baseOptions?: Apollo.MutationHookOptions<Subscriptions2CsvMutation, Subscriptions2CsvMutationVariables>) {
        return Apollo.useMutation<Subscriptions2CsvMutation, Subscriptions2CsvMutationVariables>(Subscriptions2CsvDocument, baseOptions);
      }
export type Subscriptions2CsvMutationHookResult = ReturnType<typeof useSubscriptions2CsvMutation>;
export type Subscriptions2CsvMutationResult = Apollo.MutationResult<Subscriptions2CsvMutation>;
export type Subscriptions2CsvMutationOptions = Apollo.BaseMutationOptions<Subscriptions2CsvMutation, Subscriptions2CsvMutationVariables>;
export const TemporaryBlockagesDocument = gql`
    query TemporaryBlockages($id: Int!) {
  temporaryBlockages(accountId: $id) {
    id
    author {
      ...ShortAccountDataFragment
    }
    reason
    validUntil
    createdAt
  }
}
    ${ShortAccountDataFragmentFragmentDoc}`;

/**
 * __useTemporaryBlockagesQuery__
 *
 * To run a query within a React component, call `useTemporaryBlockagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemporaryBlockagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemporaryBlockagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTemporaryBlockagesQuery(baseOptions?: Apollo.QueryHookOptions<TemporaryBlockagesQuery, TemporaryBlockagesQueryVariables>) {
        return Apollo.useQuery<TemporaryBlockagesQuery, TemporaryBlockagesQueryVariables>(TemporaryBlockagesDocument, baseOptions);
      }
export function useTemporaryBlockagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemporaryBlockagesQuery, TemporaryBlockagesQueryVariables>) {
          return Apollo.useLazyQuery<TemporaryBlockagesQuery, TemporaryBlockagesQueryVariables>(TemporaryBlockagesDocument, baseOptions);
        }
export type TemporaryBlockagesQueryHookResult = ReturnType<typeof useTemporaryBlockagesQuery>;
export type TemporaryBlockagesLazyQueryHookResult = ReturnType<typeof useTemporaryBlockagesLazyQuery>;
export type TemporaryBlockagesQueryResult = Apollo.QueryResult<TemporaryBlockagesQuery, TemporaryBlockagesQueryVariables>;
export const TierByTierIdDocument = gql`
    query TierByTierId($tierId: String!) {
  tierByTierId(tierId: $tierId) {
    id
    tierId
    name
    description
    rawName {
      sq
      en
      mk
    }
    rawDescription {
      sq
      en
      mk
    }
    color
    activeDays
    eventsPerMonth
    pricePerYear
    isPublic
    isDefaultForSigalClients
    sigalHealthInsuranceType
    isDefaultForDemo
    benefits {
      id
      title
    }
  }
}
    `;

/**
 * __useTierByTierIdQuery__
 *
 * To run a query within a React component, call `useTierByTierIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTierByTierIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTierByTierIdQuery({
 *   variables: {
 *      tierId: // value for 'tierId'
 *   },
 * });
 */
export function useTierByTierIdQuery(baseOptions?: Apollo.QueryHookOptions<TierByTierIdQuery, TierByTierIdQueryVariables>) {
        return Apollo.useQuery<TierByTierIdQuery, TierByTierIdQueryVariables>(TierByTierIdDocument, baseOptions);
      }
export function useTierByTierIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TierByTierIdQuery, TierByTierIdQueryVariables>) {
          return Apollo.useLazyQuery<TierByTierIdQuery, TierByTierIdQueryVariables>(TierByTierIdDocument, baseOptions);
        }
export type TierByTierIdQueryHookResult = ReturnType<typeof useTierByTierIdQuery>;
export type TierByTierIdLazyQueryHookResult = ReturnType<typeof useTierByTierIdLazyQuery>;
export type TierByTierIdQueryResult = Apollo.QueryResult<TierByTierIdQuery, TierByTierIdQueryVariables>;
export const TierDocument = gql`
    query Tier($id: Int!) {
  tier(where: {id: $id}) {
    id
    tierId
    name
    description
    rawName {
      sq
      en
      mk
    }
    rawDescription {
      sq
      en
      mk
    }
    color
    activeDays
    eventsPerMonth
    pricePerYear
    isPublic
    isDefaultForSigalClients
    sigalHealthInsuranceType
    isDefaultForDemo
    benefits {
      id
      title
    }
  }
}
    `;

/**
 * __useTierQuery__
 *
 * To run a query within a React component, call `useTierQuery` and pass it any options that fit your needs.
 * When your component renders, `useTierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTierQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTierQuery(baseOptions?: Apollo.QueryHookOptions<TierQuery, TierQueryVariables>) {
        return Apollo.useQuery<TierQuery, TierQueryVariables>(TierDocument, baseOptions);
      }
export function useTierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TierQuery, TierQueryVariables>) {
          return Apollo.useLazyQuery<TierQuery, TierQueryVariables>(TierDocument, baseOptions);
        }
export type TierQueryHookResult = ReturnType<typeof useTierQuery>;
export type TierLazyQueryHookResult = ReturnType<typeof useTierLazyQuery>;
export type TierQueryResult = Apollo.QueryResult<TierQuery, TierQueryVariables>;
export const TiersDocument = gql`
    query Tiers {
  tiers {
    id
    tierId
    name
    description
    rawName {
      sq
      en
      mk
    }
    rawDescription {
      sq
      en
      mk
    }
    color
    activeDays
    eventsPerMonth
    pricePerYear
    isPublic
    isDefaultForSigalClients
    sigalHealthInsuranceType
    isDefaultForDemo
    benefits {
      id
      title
    }
  }
}
    `;

/**
 * __useTiersQuery__
 *
 * To run a query within a React component, call `useTiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTiersQuery({
 *   variables: {
 *   },
 * });
 */
export function useTiersQuery(baseOptions?: Apollo.QueryHookOptions<TiersQuery, TiersQueryVariables>) {
        return Apollo.useQuery<TiersQuery, TiersQueryVariables>(TiersDocument, baseOptions);
      }
export function useTiersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TiersQuery, TiersQueryVariables>) {
          return Apollo.useLazyQuery<TiersQuery, TiersQueryVariables>(TiersDocument, baseOptions);
        }
export type TiersQueryHookResult = ReturnType<typeof useTiersQuery>;
export type TiersLazyQueryHookResult = ReturnType<typeof useTiersLazyQuery>;
export type TiersQueryResult = Apollo.QueryResult<TiersQuery, TiersQueryVariables>;
export const AllWaitingQueueDocument = gql`
    query AllWaitingQueue {
  allWaitingQueue {
    profile {
      id
      account {
        email
        id
        role
        profileImage
        profile {
          ... on DoctorProfile {
            id
            type
            name
            lastname
          }
        }
      }
    }
    calls {
      id
      room
      requestTime
      startTime
      status
      participants {
        twilioToken
        id
        account {
          id
          email
          role
          profileImage
          profile {
            __typename
            ... on ClientProfile {
              id
              name
              lastname
            }
          }
        }
        role
        status
        joinTime
      }
    }
  }
}
    `;

/**
 * __useAllWaitingQueueQuery__
 *
 * To run a query within a React component, call `useAllWaitingQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllWaitingQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllWaitingQueueQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllWaitingQueueQuery(baseOptions?: Apollo.QueryHookOptions<AllWaitingQueueQuery, AllWaitingQueueQueryVariables>) {
        return Apollo.useQuery<AllWaitingQueueQuery, AllWaitingQueueQueryVariables>(AllWaitingQueueDocument, baseOptions);
      }
export function useAllWaitingQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllWaitingQueueQuery, AllWaitingQueueQueryVariables>) {
          return Apollo.useLazyQuery<AllWaitingQueueQuery, AllWaitingQueueQueryVariables>(AllWaitingQueueDocument, baseOptions);
        }
export type AllWaitingQueueQueryHookResult = ReturnType<typeof useAllWaitingQueueQuery>;
export type AllWaitingQueueLazyQueryHookResult = ReturnType<typeof useAllWaitingQueueLazyQuery>;
export type AllWaitingQueueQueryResult = Apollo.QueryResult<AllWaitingQueueQuery, AllWaitingQueueQueryVariables>;
export const IncomingCallDocument = gql`
    subscription IncomingCall {
  incomingCall {
    call {
      id
      room
      requestTime
      startTime
      endTime
      status
      participants {
        twilioToken
        account {
          id
          email
          role
          profile {
            __typename
            ... on ClientProfile {
              id
              name
              lastname
              birthday
              sex
            }
            ... on DoctorProfile {
              id
              name
              lastname
              birthday
              sex
            }
            ... on SystemUserProfile {
              id
              type
            }
          }
        }
        role
        status
        joinTime
      }
    }
  }
}
    `;

/**
 * __useIncomingCallSubscription__
 *
 * To run a query within a React component, call `useIncomingCallSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIncomingCallSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncomingCallSubscription({
 *   variables: {
 *   },
 * });
 */
export function useIncomingCallSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IncomingCallSubscription, IncomingCallSubscriptionVariables>) {
        return Apollo.useSubscription<IncomingCallSubscription, IncomingCallSubscriptionVariables>(IncomingCallDocument, baseOptions);
      }
export type IncomingCallSubscriptionHookResult = ReturnType<typeof useIncomingCallSubscription>;
export type IncomingCallSubscriptionResult = Apollo.SubscriptionResult<IncomingCallSubscription>;
export const MyWaitingQueueDocument = gql`
    subscription MyWaitingQueue {
  myWaitingQueue {
    id
    status
    room
    requestTime
    startTime
    endTime
    participants {
      id
      role
      status
      joinTime
      account {
        id
        email
        accountStatus
        subscriptionStatus
        profileImage
        role
        createdAt
        profile {
          __typename
          ... on ClientProfile {
            id
            name
            lastname
            birthday
            sex
          }
          ... on DoctorProfile {
            id
            name
            lastname
            birthday
            sex
          }
          ... on SystemUserProfile {
            id
            type
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMyWaitingQueueSubscription__
 *
 * To run a query within a React component, call `useMyWaitingQueueSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMyWaitingQueueSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyWaitingQueueSubscription({
 *   variables: {
 *   },
 * });
 */
export function useMyWaitingQueueSubscription(baseOptions?: Apollo.SubscriptionHookOptions<MyWaitingQueueSubscription, MyWaitingQueueSubscriptionVariables>) {
        return Apollo.useSubscription<MyWaitingQueueSubscription, MyWaitingQueueSubscriptionVariables>(MyWaitingQueueDocument, baseOptions);
      }
export type MyWaitingQueueSubscriptionHookResult = ReturnType<typeof useMyWaitingQueueSubscription>;
export type MyWaitingQueueSubscriptionResult = Apollo.SubscriptionResult<MyWaitingQueueSubscription>;
export const SubscribeToCallDocument = gql`
    subscription SubscribeToCall($id: Int!) {
  callUpdate(where: {id: $id}) {
    waitingCalls
    call {
      id
      requestTime
      status
      room
      participants {
        id
        role
        status
        joinTime
      }
    }
  }
}
    `;

/**
 * __useSubscribeToCallSubscription__
 *
 * To run a query within a React component, call `useSubscribeToCallSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToCallSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToCallSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubscribeToCallSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SubscribeToCallSubscription, SubscribeToCallSubscriptionVariables>) {
        return Apollo.useSubscription<SubscribeToCallSubscription, SubscribeToCallSubscriptionVariables>(SubscribeToCallDocument, baseOptions);
      }
export type SubscribeToCallSubscriptionHookResult = ReturnType<typeof useSubscribeToCallSubscription>;
export type SubscribeToCallSubscriptionResult = Apollo.SubscriptionResult<SubscribeToCallSubscription>;